import CommonState from './CommonState'
import lang from '@/lang'
import { OPERATOR_EQUAL, OPERATOR_UNEQUAL } from '@/class/cargo/model/parameters/OperatorConstants'
import { CONTAINER_ASCRIPTION_COC, CONTAINER_ASCRIPTION_SOC } from '@/class/cargo/model/parameters/SeaExportConstants'
import * as ChargeMeasure from '@/class/cargo/model/parameters/ChargeMeasure'

/** 系统常量 **/
export const PENDING = -1
export const OPERATING = 0
export const COMMITED = 1
export const VERIFIED = 2
export const SHUT_OUT = 3
export const PRE_COMMIT = 11
export const COMMITTING = 13

export const STATE_VERIFYING = new CommonState(-1, '待审核', 'Pending')
export const STATE_VERIFYING_REVIEW = new CommonState(-1, '已审核（待复核）', 'Approved (pending review)')
export const STATE_OPERATING = new CommonState(0, '正操作', 'Operating')
export const STATE_COMMITED = new CommonState(1, '已提交', 'Committed')
export const STATE_VERIFIED = new CommonState(2, '已审核', 'Verified')
export const STATE_SHUT_OUT = new CommonState(3, '已退关', 'Shut Out')
export const STATE_PRE_COMMIT = new CommonState(11, '预提交', 'Pre Commit')
export const STATE_REJECT = new CommonState(12, '已拒绝', 'Reject')
export const STATE_COMMITTING = new CommonState(13, '提交中', 'Committing')

export const JOB_STATES = new Set([STATE_OPERATING, STATE_PRE_COMMIT, STATE_COMMITTING, STATE_COMMITED, STATE_VERIFIED, STATE_SHUT_OUT])

export const PRICE_STATE_NULL = new CommonState(-1, '空值', 'Null')
export const PRICE_STATE_REVIEW = new CommonState(0, '待审核', 'Operating')
export const PRICE_STATE_REVIEWED = new CommonState(1, '已审核', 'Committed')
export const PRICE_STATE_REJECT = new CommonState(2, '已拒绝', 'Verified')
export const PRICE_JOB_STATES = new Set([PRICE_STATE_REVIEW, PRICE_STATE_REVIEWED, PRICE_STATE_REJECT])

export const PRICE_JOB_WITH_NULL_STATES = new Set([PRICE_STATE_NULL, PRICE_STATE_REVIEW, PRICE_STATE_REVIEWED])

export const OPERATE_PRE_SUBMISSION = new CommonState(0, '预提交', 'Pre Submission')
export const OPERATE_SUBMISSION = new CommonState(1, '提交', 'Submission')
export const OPERATE_MANAGER_SUBMISSION = new CommonState(2, '主管提交', 'Manager Submission')
export const OPERATE_RETURN_ACTION = new CommonState(3, '退回操作', 'ReturnAction')
export const OPERATE_PRINT_RETURN = new CommonState(4, '撤回', 'PrintReturn')
export const OPERATE_AUDIT = new CommonState(5, '审核', 'Audit')
export const OPERATE_CANCEL_AUDIT = new CommonState(6, '取消审核', 'CancelAudit')
export const OPERATE_SHUTOUT = new CommonState(7, '退关', 'ShutOut')
export const OPERATE_CANCEL_SHUTOUT = new CommonState(8, '取消退关', 'CancelShutOut')
export const OPERATE_BATCH_SUBMISSION = new CommonState(9, '批量提交', 'BatchSubmission')
export const OPERATE_BATCH_AUDIT = new CommonState(10, '批量审核', 'BatchAudit')
export const OPERATE_BATCH_SHUTOUT = new CommonState(11, '批量退关', 'BatchShutOut')
export const OPERATE_BATCH_PRE_SHUTOUT = new CommonState(12, '批量预提交', 'BatchPreShutOut')

export const CHANGE_DEFAULT = new CommonState(0, '', 'default')
export const CHANGE_DEFAULT2 = new CommonState(0, '无', 'default')
export const CHANGE_CANNOTCHANGE = new CommonState(1, '不可改单', 'CanNotChange')
export const CHANGE_CANCHANGE = new CommonState(2, '可改单', 'CanChange')
export const CHANGE_COMMIT = new CommonState(3, '改单提交', 'Change Commit')
export const CHANGE_AUDIT = new CommonState(4, '改单完成', 'Change Audit')
export const CHANGE_REVOKE_COMMIT = new CommonState(30, '撤回改单提交', 'Revoke Change Commit')

export const SE = new CommonState('SE', '海运出口', 'Sea export')
export const SI = new CommonState('SI', '海运进口', 'Sea import')
export const AE = new CommonState('AE', '空运出口', 'Air export')
export const AI = new CommonState('AI', '空运进口', 'Air import')
export const RE = new CommonState('RE', '铁路出口', 'Rail export')
export const RI = new CommonState('RI', '铁路进口', 'Rail import')
export const PT = new CommonState('PT', '合作伙伴', 'Partner')
export const IE = new CommonState('IE', '综合物流', 'Integrated logistics')
export const FS = new CommonState('FS', '财务结算', 'Financial settlement')

// FBA业务
export const FBA_SE = new CommonState('FBA_SE', 'FBA海运', 'FBA sea freight')
export const FBA_AE = new CommonState('FBA_AE', 'FBA空运', 'FBA air freight')
export const FBA_RE = new CommonState('FBA_RE', 'FBA铁路', 'FBA rail freight')

// 付款申请 业务类型
export const BILL_PAYMENT_LOBS = [SE, SI, AE, AI, RI, RE, IE]
// CARGO-5517
export const OJ_TE = new CommonState('OJ_TE', '二线出口', '二线出口')
export const OJ_GE = new CommonState('OJ_GE', '公路出口', '公路出口')
export const OJ_SE = new CommonState('SE', '海运出口', 'SeaExport')
export const OJ_ER = new CommonState('OJ_ER', '出境备案', '出境备案')
export const OJ_AE = new CommonState('AE', '空运出口', 'AirExport')
export const OJ_RE = new CommonState('RE', '铁路出口', 'RailwayExport')
export const OJ_EE = new CommonState('OJ_EE', '邮件出口', '邮件出口')
export const OJ_OE = new CommonState('OJ_OE', '其他出口', '其他出口')
export const OJ_TI = new CommonState('OJ_TI', '二线进口', '二线进口')
export const OJ_GI = new CommonState('OJ_GI', '公路进口', '公路进口')
export const OJ_SI = new CommonState('SI', '海运进口', 'SeaImport')
export const OJ_IR = new CommonState('OJ_IR', '进境备案', '进境备案')
export const OJ_AI = new CommonState('AI', '空运进口', 'AirImport')
export const OJ_RI = new CommonState('RI', '铁路出口', 'RailwayExport')
export const OJ_EI = new CommonState('OJ_EI', '邮件进口', '邮件进口')
export const OJ_OI = new CommonState('OJ_OI', '其他进口', '其他进口')
export const OJ_CI = new CommonState('OJ_CI', '报关查验', '报关查验')
export const OJ_GC = new CommonState('OJ_GC', '货物报检', '货物报检')
export const OJ_CB = new CommonState('OJ_CB', '加贸业务', '加贸业务')
export const OJ_OB = new CommonState('OJ_OB', '其他业务', '其他业务')
export const OJ_PC = new CommonState('OJ_PC', '预归类', '预归类')
// 欧坚业务类型
export const OJ_LOBS = new Set([OJ_SE, OJ_AE, OJ_SI, OJ_AI, OJ_CI, OJ_GC, OJ_PC])

// 财务综合查询使用-费用核销状态
export const NOT_FINANCE_CHARGE_SEARCH_ALL_VERIFICATION = new CommonState(0, '未核销', 'Non-Write')
export const FINANCE_CHARGE_SEARCH_VERIFICATION = new CommonState(1, '已销账', 'verification')
export const CHARGE_SEARCH_FINANCE = [NOT_FINANCE_CHARGE_SEARCH_ALL_VERIFICATION, FINANCE_CHARGE_SEARCH_VERIFICATION]

// 核销状态
export const VERIFICATION_ALL = new CommonState('4', '全部', 'ALL')
export const NOT_AllVERIFICATION = new CommonState('0', '未核销', 'Non-Write')
export const ALL_VERIFICATION = new CommonState('1', '全部核销', 'Full Writeoff')
export const PARTS_VERIFICATION = new CommonState('2', '部分核销', 'Partial Writeoff')
export const NO_RECIVABLE = new CommonState('3', '无应收', 'noReceivable')
export const NO_DUE = new CommonState('3', '无应付', 'noDue')

// 费用确认状态
export const CHARGE_NOT_AR = new CommonState('0', '无应收', 'Not Ar')
export const CHARGE_NOT_AP = new CommonState('0', '无应付', 'Not Ap')
export const CHARGE_NOT_CONFIRM = new CommonState('1', '未确认', 'Not Confirm')
export const CHARGE_PARTIAL_CONFIRM = new CommonState('2', '部分确认', 'Partial Confirm')
export const CHARGE_ALL_CONFIRM = new CommonState('3', '全部确认', 'ALL Confirm')

// 应收核销状态
export const NOT_WRITEOFF_VERIFICATION = new CommonState('1', '未核销', 'Non-Write')
export const SOME_WRITEOFF_VERIFICATION = new CommonState('2', '部分核销', 'Partial Writeoff')
export const ALL_WRITEOFF_VERIFICATION = new CommonState('3', '全部核销', 'Full Writeoff')

// 报关状态
export const STATE_EMPTY = new CommonState(0, '-请选择-', 'Select')
export const STATE_YLR = new CommonState(1, '已录入', 'Entered')
export const STATE_YLD = new CommonState(2, '已拉单', 'Order Pulled')
export const STATE_ZQT = new CommonState(3, '在前台', 'At The Customs Desk')
export const STATE_BH = new CommonState(4, '报好', 'Filed')
export const STATE_WBH = new CommonState(5, '未报好', 'Not Filed')
export const STATE_HGJY = new CommonState(6, '海关查验', 'Customs Inspection')
export const STATE_SJCY = new CommonState(7, '商检查验', 'Commodity Inspection')
export const STATE_YCWFX = new CommonState(8, '已查未放行', 'Inspected, Not Released')
export const STATE_GD = new CommonState(9, '改单', 'Amend The Order')
export const STATE_DTZBG = new CommonState(10, '等通知报关', 'Waiting for notification for customs clearance')
export const STATE_HGYC = new CommonState(11, '海关已查', 'Customs Inspected')
export const STATE_HGJYYWT = new CommonState(12, '海关查验有问题', 'Issues found during customs inspection')
export const STATE_SHUTOUT = new CommonState(13, '退关', 'Withdraw from Customs Clearance')
export const STATE_BACKPOSITION = new CommonState(14, '退仓', 'Withdraw from Warehouse')
export const STATE_UNSIGNED = new CommonState(15, '未签约', 'Unsigned')
export const STATE_OVERTIMEDECLARATION = new CommonState(16, '加班报关', 'Overtime Customs Clearance')
export const CUSTOMS_RELEASED = new CommonState(17, '海关放行', 'Customs Released')
export const CUSTOMS_NOT_RELEASED = new CommonState(18, '海关未放行', 'Customs Not Released')

// 协议类型
export const PROTOCOL_NONE = new CommonState('none', '无', 'None')
export const PROTOCOL_FIXED = new CommonState('fixed', '固定板', 'Fixed')
export const PROTOCOL_FLOATING = new CommonState('floating', '浮动板', 'Floating')
export const PROTOCOL_PROTOCOL = new CommonState('protocol', '协议', 'Protocol')
export const PROTOCOL_CASEBYCASE = new CommonState('casebycase', '议价', 'Casebycase')
export const PROTOCOL_MARKUP = new CommonState('markup', '加价', 'Markup')

/**
 * 0.新创建
 * 1.预存   已预录入单证信息
 * 2.已解锁
 * 3.锁定   已打印正式运单
 * 4.已确认   客户已确认
 * 5.预制单   确认信息录入完成 待客户确认
 */
export const DOC_ALL = new CommonState('-1', '全部', 'ALL')
export const DOC_OPERAT = new CommonState('2', '正操作', 'Positive Operat')
export const DOC_LOCK = new CommonState('3', '已锁定', 'Lock')
export const DOC_CONFIRM = new CommonState('4', '已确认', 'Confirm')
export const DOC_SUBMIT = new CommonState('5', '已提交', 'Submit')

export const VERIFYING_PENDING = new CommonState(1, '待审核', 'VerifyPending')
export const VERIFYING_AUDITED = new CommonState(2, '已审核', 'VerifyAudited')
export const VERIFYING_REJECT = new CommonState(3, '已拒绝', 'VerifyReject')
export const VERIFYING_LOCK = new CommonState(4, '暂不提交', 'VerifyLock')
export const VERIFYING_REVIEW_THROUGH = new CommonState(5, '复核通过', 'VerifyReviewThrough')
export const VERIFYING_REVIEW_REFUSAL = new CommonState(6, '复核拒绝', 'VerifyReviewRefusal')
export const VERIFYING_REVOKE = new CommonState(7, '已作废', 'VerifyRevoked')

export const STATE_YES = new CommonState(1, '是', 'Yes')
export const STATE_NO = new CommonState(0, '否', 'No')

export const COMMON_STATE_YES = new CommonState(true, '是', 'Yes')
export const COMMON_STATE_NO = new CommonState(false, '否', 'No')

export const STATE_HAVE = new CommonState(true, '有', 'Have')
export const STATE_NONE = new CommonState(false, '无', 'None')

export const BILLING_SINGLE = new CommonState(0, '单票开票', 'BillingSingle')
export const BILLING_MONTHLY = new CommonState(1, '月结开票', 'BillingMonthly')

export const DOC_STATES = new Set([DOC_ALL, DOC_OPERAT, DOC_LOCK, DOC_CONFIRM, DOC_SUBMIT])

export const LOBS = new Set([SE, SI, AE, AI, RE, RI, IE])

export const FBA_LOBS = new Set([SE, SI, AE, AI, RE, RI, IE, FBA_SE, FBA_AE, FBA_RE])

export const CHARGE_SCHEME_LOBS = new Set([SE, SI, AE, AI, RE, RI, FBA_SE, FBA_AE, FBA_RE, IE])

export const FBA_IE_LOBS = new Set([SE, SI, AE, AI, RE, RI, FBA_SE, FBA_AE, FBA_RE, IE])

// SOP配置管理使用
export const SOP_CONFIG_LOBS = new Set([SE, SI, AE, AI, RE, RI, FBA_SE, FBA_AE, FBA_RE, IE, FS])

export const RB_LOBS = new Set([RE, RI])

export const SE_AE = new Set([SE, AE])

export const SE_AE_RE_RI = new Set([SE, AE, RE, RI])

export const JOB_CHANGE_STATES = new Set([CHANGE_DEFAULT2, CHANGE_CANNOTCHANGE, CHANGE_CANCHANGE, CHANGE_COMMIT, CHANGE_AUDIT])

export const SettleByMonthly = new CommonState('-1', '按月结算', 'SettleByMonthly')
export const SettleByWeekly = new CommonState('-2', '按周结算', 'SettleByWeekly')
export const FixedDateMonthly = new CommonState('n', '每月指定日期', 'FixedDateMonthly')
export const HalfMonthly = new CommonState('3', '半月结', 'HalfMonthly')

// 结算方式
export const settlementMethod = [SettleByMonthly, SettleByWeekly, FixedDateMonthly, HalfMonthly]

// 模板名称规则枚举
export const TEMPLATE_NAME_RULE = new Set([
  { name: '', value: 0 },
  { name: '客户中文名', value: 1 },
  { name: '客户简称', value: 2 },
  { name: '结算对象中文名', value: 3 },
  { name: '结算对象简称', value: 4 },
  { name: '订舱代理中文', value: 5 },
  { name: '订舱代理简称', value: 6 },
  { name: '业务编号', value: 7 },
  { name: 'MBL NO', value: 8 },
  { name: 'HBL NO', value: 9 },
  { name: '关单号', value: 10 },
  { name: '账单号', value: 11 },
  { name: '付款号', value: 12 },
  { name: '进仓号', value: 13 }
])

export const RECEIVABLE = new Set([ALL_VERIFICATION, NOT_AllVERIFICATION, PARTS_VERIFICATION, NO_RECIVABLE])
// 财务审核-费用确认状态
export const CHARGE_CONFIRM_STATE_AR = new Set([CHARGE_NOT_AR, CHARGE_NOT_CONFIRM, CHARGE_PARTIAL_CONFIRM, CHARGE_ALL_CONFIRM])
export const CHARGE_CONFIRM_STATE_AP = new Set([CHARGE_NOT_AP, CHARGE_NOT_CONFIRM, CHARGE_PARTIAL_CONFIRM, CHARGE_ALL_CONFIRM])
// 对账新版-对账类型-应收核销状态
export const RECEIVABLE_FINANCE = new Set([ALL_VERIFICATION, NOT_AllVERIFICATION, PARTS_VERIFICATION])

// 对账新版-对账类型-应收核销状态
export const RECEIVABLE_WRITEOFF = new Set([NOT_WRITEOFF_VERIFICATION, SOME_WRITEOFF_VERIFICATION, ALL_WRITEOFF_VERIFICATION])

export const DUE = new Set([ALL_VERIFICATION, NOT_AllVERIFICATION, PARTS_VERIFICATION, NO_DUE])

export const BILLINGS = new Set([BILLING_SINGLE, BILLING_MONTHLY])

export const DOC_CATEGORY_LIST = new Set([SE, SI, AE, AI, PT, RE])

export const JOB_STATES_FORFINANCE = new Set([STATE_OPERATING, STATE_PRE_COMMIT, STATE_COMMITED, STATE_VERIFIED, STATE_SHUT_OUT])

export const VERIFY_STATES = new Set([VERIFYING_PENDING, VERIFYING_AUDITED, VERIFYING_REJECT])

export const VERIFY_STATES_REVIEW = new Set([VERIFYING_PENDING, VERIFYING_AUDITED, VERIFYING_REJECT, VERIFYING_REVIEW_THROUGH, VERIFYING_REVIEW_REFUSAL])

export const REMOTE_BOOKING_STATES = new Set([VERIFYING_PENDING, VERIFYING_AUDITED, VERIFYING_REJECT, VERIFYING_LOCK])
export const HC_REMOTE_BOOKING_STATES = new Set([VERIFYING_PENDING, VERIFYING_AUDITED, VERIFYING_REJECT, VERIFYING_LOCK, VERIFYING_REVOKE])

export const REMOTE_BOOKING_ALL_STATES = new Set([VERIFYING_PENDING, VERIFYING_AUDITED, VERIFYING_REJECT, VERIFYING_LOCK, VERIFYING_REVIEW_THROUGH, VERIFYING_REVIEW_REFUSAL])
export const HC_REMOTE_BOOKING_ALL_STATES = new Set([VERIFYING_PENDING, VERIFYING_AUDITED, VERIFYING_REJECT, VERIFYING_LOCK, VERIFYING_REVIEW_THROUGH, VERIFYING_REVIEW_REFUSAL, VERIFYING_REVOKE])

export const DECLARE_CUSTOMS_STATE = new Set([STATE_EMPTY, STATE_YLR, STATE_YLD, STATE_ZQT, STATE_BH, STATE_WBH, STATE_HGJY, STATE_SJCY,
  STATE_YCWFX, STATE_GD, STATE_DTZBG, STATE_HGYC, STATE_HGJYYWT, STATE_SHUTOUT, STATE_BACKPOSITION, STATE_UNSIGNED, STATE_OVERTIMEDECLARATION, CUSTOMS_RELEASED, CUSTOMS_NOT_RELEASED])

export const PROTOCOL_TYPES = new Set([PROTOCOL_NONE, PROTOCOL_FIXED, PROTOCOL_FLOATING, PROTOCOL_PROTOCOL, PROTOCOL_CASEBYCASE, PROTOCOL_MARKUP])

export const ALL = new CommonState('1', '【全部】', '')
export const FCL = new CommonState('2', '整箱', 'FCL')
export const LCL = new CommonState('3', '拼箱', 'LCL')
export const CON = new CommonState('4', '集拼', 'CON')
export const POJ = new CommonState('5', '项目', 'POJ')
export const PVE = new CommonState('6', '私人物品', 'PVE')
export const JOB_LOB = new Set([ALL, FCL, LCL, CON, POJ, PVE])

export const YESORNO_STATES = new Set([STATE_YES, STATE_NO])

export const YESORNO_COMMON_STATES = new Set([COMMON_STATE_YES, COMMON_STATE_NO])

export const HAVENONE_STATES = new Set([STATE_HAVE, STATE_NONE])
// 内部往来公司
export const INTERNAL_CORRESPONDENT_ALL = new CommonState('', '全部', 'ALL')
export const INTERNAL_CORRESPONDENT_STATE = [INTERNAL_CORRESPONDENT_ALL, STATE_YES, STATE_NO]

// CARGO-45565 风险客商
export const IS_RISK_ALL = new CommonState('', '全部', 'ALL')
export const IS_RISK_STATE = [IS_RISK_ALL, STATE_YES, STATE_NO]

export const CARGO_SOURCE_NC = new CommonState('NC', '指定货', 'Nominated Cargo')
export const CARGO_SOURCE_SC = new CommonState('SC', '自揽货', 'Free Hand')

/**
 * 提货类型
 */
export const CARGO_SOURCES = new Set([
  CARGO_SOURCE_NC,
  CARGO_SOURCE_SC
])
export const CARGODOC_CFM_STATE_WQF = new CommonState(0, '未签发', '未签发')
export const CARGODOC_CFM_STATE_WKS = new CommonState(0, '未开始', '未开始')
export const CARGODOC_CFM_STATE_DHD = new CommonState(1, '未邀请', '未邀请')
export const CARGODOC_CFM_STATE_ZDD = new CommonState(2, '待确认', '待确认')
export const CARGODOC_CFM_STATE_YQR = new CommonState(3, '已确认', '已确认')
export const CARGODOC_CFM_STATE_SQDD = new CommonState(4, '客人申请对单', '客人申请对单')
export const CARGODOC_CFM_STATE_CMPFEED = new CommonState(5, '已补料', '已补料')
export const CARGODOC_CFM_STATE_EXCEPTION = new CommonState(6, '对单异常', '对单异常')
export const CARGODOC_CFM_STATE_GET_BACKED = new CommonState(7, '已取回', 'Get back')
export const CARGODOC_CFM_STATE_RECEIVED = new CommonState(8, '已接收', 'Received')
export const CARGODOC_CFM_STATE_CLAIMED = new CommonState(9, '已认领', 'Claimed')
export const CARGODOC_CFM_STATE_RELEASED = new CommonState(10, '已放单', 'Released')
export const CARGODOC_CFM_STATE_YQF = new CommonState(12, '已签发', 'Issued')
export const CARGODOC_CFM_STATE_GDZ = new CommonState(13, '改单中', 'Change Order')
export const CARGODOC_CFM_STATE_SHIPPER_CONFIRMED = new CommonState(15, 'SHIPPER已确认', 'Shipper Confirmed')
// 提单签发状态
export const ISSUE_BULL_LADIING_STATES = new Set([
  CARGODOC_CFM_STATE_WQF,
  CARGODOC_CFM_STATE_YQF,
  CARGODOC_CFM_STATE_GET_BACKED,
  CARGODOC_CFM_STATE_RECEIVED,
  CARGODOC_CFM_STATE_CLAIMED,
  CARGODOC_CFM_STATE_GDZ
])

/**
 * 对单状态
 */
export const CFM_STATES = new Set([
  CARGODOC_CFM_STATE_WKS,
  CARGODOC_CFM_STATE_DHD,
  CARGODOC_CFM_STATE_ZDD,
  CARGODOC_CFM_STATE_YQR,
  CARGODOC_CFM_STATE_EXCEPTION,
  CARGODOC_CFM_STATE_RELEASED
])

/**
 * 对单状态2
 */
export const CFM_STATES2 = new Set([
  CARGODOC_CFM_STATE_WKS,
  CARGODOC_CFM_STATE_DHD,
  CARGODOC_CFM_STATE_ZDD,
  CARGODOC_CFM_STATE_YQR,
  CARGODOC_CFM_STATE_EXCEPTION,
  CARGODOC_CFM_STATE_RELEASED,
  CARGODOC_CFM_STATE_GET_BACKED,
  CARGODOC_CFM_STATE_SHIPPER_CONFIRMED,
  CARGODOC_CFM_STATE_CMPFEED
])

/**
 * mbl提单状态
 */
export const CFM_MBL_STATES = new Set([
  CARGODOC_CFM_STATE_WKS,
  CARGODOC_CFM_STATE_ZDD, CARGODOC_CFM_STATE_YQR,
  CARGODOC_CFM_STATE_GET_BACKED,
  CARGODOC_CFM_STATE_RECEIVED, CARGODOC_CFM_STATE_CLAIMED,
  CARGODOC_CFM_STATE_RELEASED,
  CARGODOC_CFM_STATE_CMPFEED
])

export const CARGODOC_RELEASE_TYPE_ORI = new CommonState(1, 'ORIGINAL', 'ORIGINAL')
export const CARGODOC_RELEASE_TYPE_SUR = new CommonState(2, 'SURRENDERED', 'SURRENDERED')
export const CARGODOC_RELEASE_TYPE_SEA = new CommonState(3, 'SEA WAYBILL', 'SEA WAYBILL')
export const CARGODOC_RELEASE_TYPE_ELC = new CommonState(4, '电放', '电放')

/**
 * 提单方式（放单方式）
 */
export const RELEASE_TYPE = new Set([
  CARGODOC_RELEASE_TYPE_ORI,
  CARGODOC_RELEASE_TYPE_SUR,
  CARGODOC_RELEASE_TYPE_SEA,
  CARGODOC_RELEASE_TYPE_ELC
])

export const CUSTOMER_SELF_RELEASE_0 = new CommonState('0', '全部', 'ALL')
export const CUSTOMER_SELF_RELEASE_1 = new CommonState('1', '客户自出单', 'Customer Self HBL')
export const CUSTOMER_SELF_RELEASE_2 = new CommonState('2', '公司自出单', 'Company Self HBL')
export const CUSTOMER_SELF_RELEASE_3 = new CommonState('0', '其它', 'Other')

/**
 * 出单类型
 */
export const CUSTOMER_SELF_RELEASE_STATES = new Set([
  CUSTOMER_SELF_RELEASE_1,
  CUSTOMER_SELF_RELEASE_2,
  CUSTOMER_SELF_RELEASE_0
])

/**
 * 出单类型1
 */
export const CUSTOMER_SELF_RELEASE_STATES1 = new Set([
  CUSTOMER_SELF_RELEASE_1,
  CUSTOMER_SELF_RELEASE_2
])

/**
 * 出单类型2
 */
export const CUSTOMER_SELF_RELEASE_STATES2 = new Set([
  CUSTOMER_SELF_RELEASE_1,
  CUSTOMER_SELF_RELEASE_2,
  CUSTOMER_SELF_RELEASE_3
])

export const BUSINERSSADJUSTMENT_NULL = new CommonState(0, '请选择', 'Please select')
export const BUSINERSSADJUSTMENT_CSR = new CommonState(1, '客服', 'CSR_ID')
export const BUSINERSSADJUSTMENT_OP = new CommonState(2, '操作', 'OP_ID')
export const BUSINERSSADJUSTMENT_DC = new CommonState(3, '单证', 'DC_ID')
export const BUSINERSSADJUSTMENT_BOOKINGTERM = new CommonState(4, '约价性质', 'BOOKING_TERM')
export const BUSINERSSADJUSTMENT_BOOKINGAGENT = new CommonState(5, '订舱代理', 'BOOKING_AGENT')
export const BUSINERSSADJUSTMENT_CARRIER = new CommonState(6, '承运人', 'CARRIER_ID')
export const BUSINERSSADJUSTMENT_CARGOSOURCE = new CommonState(7, '揽货类型', 'CARGO_SOURCE')
export const BUSINERSSADJUSTMENT_SALES = new CommonState(8, '销售', 'SALES_ID')
export const BUSINERSSADJUSTMENT_CUSTOMERREFNO = new CommonState(9, '业务参考号', 'CUSTOMER_REF_NO')
export const BUSINERSSADJUSTMENT_PLANNER = new CommonState(10, '航线负责人', 'PLANNER')
export const BUSINERSSADJUSTMENT_BUSINESSDATE = new CommonState(11, '业务日期', 'BUSINESS_DATE')
export const BUSINERSSADJUSTMENT_PONO = new CommonState(12, '项目编号', 'PONO')

export const BUSINERSSADJUSTMENT_CUSTOMER = new CommonState(13, '委托单位', 'CUSTOMER_ID')
export const BUSINERSSADJUSTMENT_DESTINATIONAGENT_POD = new CommonState(14, '目的港代理', 'DESTINATION_AGENT')
export const BUSINERSSADJUSTMENT_DESTINATIONAGENT_POL = new CommonState(15, '起运港代理', 'DESTINATION_AGENT')
export const BUSINERSSADJUSTMENT_WEIGHT = new CommonState(16, '实际计费重量', 'C_WEIGHT')
export const BUSINERSSADJUSTMENT_OVERSEAOP = new CommonState(17, '海外客服', 'OVERSEA_OP')
export const BUSINERSSADJUSTMENT_DESIGNATIONAGENT = new CommonState(18, '指定货代理', 'DESIGNATION_AGENT')
export const BUSINERSSADJUSTMENT_CUSTOM_JOB_TYPE = new CommonState(20, '自定义业务类型', 'CUSTOM_JOB_TYPE')
export const BUSINERSSADJUSTMENT_CARRIER_AGENT = new CommonState(21, '船代', 'CARRIER_AGENT_ID')

export const BUSINERSSADJUSTMENT_CUSTOMS_BROKER = new CommonState(22, '报关行', 'CUSTOMS_BROKER')
export const BUSINERSSADJUSTMENT_TRUCKING_COMPANY = new CommonState(23, '运输公司', 'TRUCKING_ID')
// WAREHOUSE_ID调整为 WAREHOUSE_CMP ,cargo的业务调整逻辑使用，因为有bug
export const BUSINERSSADJUSTMENT_WAREHOUSE = new CommonState(24, '仓库', 'WAREHOUSE_CMP')

export const BUSINERSSADJUSTMENT_ETA = new CommonState(25, '到港日期(ETA)', 'ETA')
export const BUSINERSSADJUSTMENT_RAILWAY_ETA = new CommonState(26, '到达日期(ETA)', 'ETA')

export const BUSINERSSADJUSTMENT_BOOKINGTERM2 = new CommonState(27, '订舱性质', 'BOOKING_TERM')
// 自定义字段 1,2，3,4
export const BUSINERSSADJUSTMENT_USER_DEFINED_FIELD_1 = new CommonState(28, '自定义字段1', 'USER_DEFINED_FIELD_1')
export const BUSINERSSADJUSTMENT_USER_DEFINED_FIELD_2 = new CommonState(29, '自定义字段2', 'USER_DEFINED_FIELD_2')
export const BUSINERSSADJUSTMENT_USER_DEFINED_FIELD_3 = new CommonState(30, '自定义字段3', 'USER_DEFINED_FIELD_3')
export const BUSINERSSADJUSTMENT_USER_DEFINED_FIELD_4 = new CommonState(31, '自定义字段4', 'USER_DEFINED_FIELD_4')
// 自定义岗位1，2
export const BUSINERSSADJUSTMENT_USER_DEFINED_ROLE_ID_1 = new CommonState(32, '自定义岗位1', 'USER_DEFINED_ROLE_ID_1')
export const BUSINERSSADJUSTMENT_USER_DEFINED_ROLE_ID_2 = new CommonState(33, '自定义岗位2', 'USER_DEFINED_ROLE_ID_2')
export const BUSINERSSADJUSTMENT_USER_DEFINED_ROLE_ID_3 = new CommonState(50, '自定义岗位3', 'USER_DEFINED_ROLE_ID_3')
export const BUSINERSSADJUSTMENT_USER_DEFINED_ROLE_ID_4 = new CommonState(51, '自定义岗位4', 'USER_DEFINED_ROLE_ID_4')
export const BUSINERSSADJUSTMENT_USER_DEFINED_ROLE_ID_5 = new CommonState(52, '自定义岗位5', 'USER_DEFINED_ROLE_ID_5')
export const BUSINERSSADJUSTMENT_USER_DEFINED_ROLE_ID_6 = new CommonState(53, '自定义岗位6', 'USER_DEFINED_ROLE_ID_6')
export const BUSINERSSADJUSTMENT_USER_DEFINED_ROLE_ID_7 = new CommonState(54, '自定义岗位7', 'USER_DEFINED_ROLE_ID_7')

export const BUSINERSSADJUSTMENT_ETD = new CommonState(34, '开航日期(ETD)', 'ETD')
export const BUSINERSSADJUSTMENT_RAILWAY_ETD = new CommonState(35, '发运日期(ETD)', 'ETD')

export const BUSINERSSADJUSTMENT_ATD = new CommonState(36, '实际开航日期(ATD)', 'ATD')
export const BUSINERSSADJUSTMENT_RAILWAY_ATD = new CommonState(37, '实际发运日期(ATD)', 'ATD')

export const BUSINERSSADJUSTMENT_ATA = new CommonState(38, '实际到港日期(ATA)', 'ATA')
export const BUSINERSSADJUSTMENT_RAILWAY_ATA = new CommonState(39, '实际到达日期(ATA)', 'ATA')
export const BUSINERSSADJUSTMENT_SALES_OF_GOODS = new CommonState(40, '揽货销售', 'CARGO_SALES_ID')
export const BUSINERSSADJUSTMENT_PORT_OF_LOADING = new CommonState(41, '起运港', 'PORT_OF_LOADING')
export const BUSINERSSADJUSTMENT_PORT_OF_DISCHARGE = new CommonState(42, '卸货港', 'PORT_OF_DISCHARGE')
export const BUSINERSSADJUSTMENT_AIRPORT_OF_LOADING = new CommonState(43, '装货港', 'AIRPORT_OF_LOADING')
export const BUSINERSSADJUSTMENT_AIRPORT_OF_DISCHARGE = new CommonState(44, '目的港', 'AIRPORT_OF_DISCHARGE')
export const BUSINERSSADJUSTMENT_AIRPORT_IMPORT_OF_DISCHARGE = new CommonState(45, '目的港', 'AIRPORT_IMPORT_OF_DISCHARGE')
export const BUSINERSSADJUSTMENT_DEPARTURE_STATION = new CommonState(46, '始发站', 'DEPARTURE_STATION')
export const BUSINERSSADJUSTMENT_DESTINATION_STATION = new CommonState(47, '目的站', 'DESTINATION_STATION')
export const BUSINERSSADJUSTMENT_GOODS_CATEGORIES = new CommonState(48, '货物大类', 'GOODS_CATEGORIES')
export const BUSINERSSADJUSTMENT_INCOTERM = new CommonState(49, '贸易条款', 'INCO_TERM')
export const BUSINERSSADJUSTMENT_CUSTOMER_REMARKS = new CommonState(55, '海进-委托单位抬头', 'Title of Entrusting Unit')
export const BUSINERSSADJUSTMENT_PAYMENT_TERM_MBL = new CommonState(56, '主单运费条款', 'MBL Freight Terms')
export const BUSINERSSADJUSTMENT_PAYMENT_TERM_HBL = new CommonState(57, '分单运费条款', 'HBL Freight Terms')
export const BUSINERSSADJUSTMENT_FORWARDING_AGENT = new CommonState(58, '发运代理', 'FORWARDING_AGENT')

/**
 * 业务调整类型
 */
export const BUSINERSSADJUSTMENT_TYPE = new Set([
  BUSINERSSADJUSTMENT_NULL,
  BUSINERSSADJUSTMENT_CSR,
  BUSINERSSADJUSTMENT_DC,
  BUSINERSSADJUSTMENT_OP,
  BUSINERSSADJUSTMENT_SALES,
  BUSINERSSADJUSTMENT_PLANNER,
  BUSINERSSADJUSTMENT_BUSINESSDATE,
  BUSINERSSADJUSTMENT_PONO,
  BUSINERSSADJUSTMENT_CUSTOMERREFNO,
  BUSINERSSADJUSTMENT_CUSTOM_JOB_TYPE,
  BUSINERSSADJUSTMENT_CARGOSOURCE,
  // BUSINERSSADJUSTMENT_BOOKINGTERM,
  BUSINERSSADJUSTMENT_CARRIER,
  BUSINERSSADJUSTMENT_BOOKINGAGENT,
  BUSINERSSADJUSTMENT_OVERSEAOP,
  BUSINERSSADJUSTMENT_USER_DEFINED_FIELD_1,
  BUSINERSSADJUSTMENT_USER_DEFINED_FIELD_2,
  BUSINERSSADJUSTMENT_USER_DEFINED_FIELD_3,
  BUSINERSSADJUSTMENT_USER_DEFINED_FIELD_4,
  BUSINERSSADJUSTMENT_USER_DEFINED_ROLE_ID_1,
  BUSINERSSADJUSTMENT_USER_DEFINED_ROLE_ID_2,
  BUSINERSSADJUSTMENT_USER_DEFINED_ROLE_ID_3,
  BUSINERSSADJUSTMENT_USER_DEFINED_ROLE_ID_4,
  BUSINERSSADJUSTMENT_USER_DEFINED_ROLE_ID_5,
  BUSINERSSADJUSTMENT_USER_DEFINED_ROLE_ID_6,
  BUSINERSSADJUSTMENT_USER_DEFINED_ROLE_ID_7,
  BUSINERSSADJUSTMENT_SALES_OF_GOODS
])

export const BOOKINGTERMLIST = new Set(
  [
    new CommonState('OS', '自有约价', 'OWN S/C'),
    new CommonState('CS', '客户约价', 'CUSTOMER S/C'),
    new CommonState('AS', '海外代理约价', 'O.AGENT S/C'),
    new CommonState('PS', '同行约价', 'Peer S/C'),
    new CommonState('NS', '无约价', 'NO.S/C')
  ]
)

// 税务性质
export const TAX_NOT_EXEMPTION = new CommonState(0, '非免税', 'Non-tax-exempt')
export const TAX_EXEMPTION = new CommonState(1, '免税', 'Tax exemption')

export const TAX_NATURES = [
  TAX_EXEMPTION,
  TAX_NOT_EXEMPTION
]

// 出口管制品
export const EXPORT_CONTROLLED_PRODUCT_NO = new CommonState(1, '否', 'deny')
export const EXPORT_CONTROLLED_PRODUCT_YES_NOT_PERMISSION = new CommonState(2, '是/未获得许可', 'Yes/No permission obtained')
export const EXPORT_CONTROLLED_PRODUCT_YES_LICENSED = new CommonState(3, '是/已获得许可', 'Yes/licensed')

export const EXPORT_CONTROLLED_PRODUCT = [
  EXPORT_CONTROLLED_PRODUCT_NO,
  EXPORT_CONTROLLED_PRODUCT_YES_NOT_PERMISSION,
  EXPORT_CONTROLLED_PRODUCT_YES_LICENSED
]
// --------------
// 结算类型
// --------------
export const SETTLEMENTTYPE_JOB = new CommonState('JOB', '票结', 'Job')
export const SETTLEMENTTYPE_NOTJOB = new CommonState('NOTJOB', '非票结', 'NotJob')

export const SETTLEMENTTYPE_TYPE = new Set([
  SETTLEMENTTYPE_JOB,
  SETTLEMENTTYPE_NOTJOB
])

export const SETTLEMENT_TYPE_TICKET = new CommonState(0, '票结', 'TicketSettlement')
export const SETTLEMENT_TYPE_MONTHLY = new CommonState(1, '月结', 'SettlementTypeMonthly')

export const SETTLEMENT_TYPE_NEW = new Set([
  SETTLEMENT_TYPE_TICKET,
  SETTLEMENT_TYPE_MONTHLY
])

// 本地服务
export const STUFFY_ISBOOKING = new CommonState('ISBOOKING', '订舱', 'Space booking')
export const STUFFY_IS = new CommonState('IS', '内装箱', 'inner packing')
export const STUFFY_DD = new CommonState('DD', '门点装箱', 'door point packing')
export const STUFFY_SD = new CommonState('SD', '自拉自送', 'self delivery')
export const STUFFY_CT = new CommonState('CT', '报关', 'customs declaration')
export const STUFFY_HT = new CommonState('HT', '熏蒸', 'fumigation')
export const STUFFY_CIT = new CommonState('CIT', '商检', 'commodity inspection')
export const STUFFY_AMS = new CommonState('AMS', '反恐舱单', 'anti-terrorism manifest')
export const STUFFY_BACKUP_WAREHOUSE = new CommonState('BACK_UP_WAREHOUSE', '前置仓', 'front warehouse')

export const LOCAL_SERVICES_TYPE = new Set([
  STUFFY_IS,
  STUFFY_DD,
  STUFFY_SD,
  STUFFY_CT,
  STUFFY_HT,
  STUFFY_CIT,
  STUFFY_AMS,
  STUFFY_ISBOOKING,
  STUFFY_BACKUP_WAREHOUSE
])

// 反恐舱单ENS 亿通的海关回执状态
export const ENS_REG = new CommonState('ENS_REG', 'R01-回执成功', 'R01-Accept', 'green')
export const ASM_CPL = new CommonState('ASM_CPL', 'N03-风险评估完成', 'N03-Assessment complete', 'green')
export const DNL_NOT = new CommonState('DNL_NOT', 'DNL-禁止装船', 'DNL-DO NOT LOAD', 'red')
export const RFI_NOT = new CommonState('RFI_NOT', 'RFI-补充信息', 'RFI-Request Info', 'yellow')
export const ERR_NTF = new CommonState('ERR_NTF', 'ERR-字段异常', 'ERR-Error', 'red')
export const AMD_ACC = new CommonState('AMD_ACC', 'AMD-修改成功', 'AMD-Amendment Accept', 'green')
export const INV_ACC = new CommonState('INV_ACC', 'DET-删除成功', 'DET-Cancelled', 'gray')
export const INC_NOT = new CommonState('INC_NOT', 'INC-风险评估未完成', 'INC-Assessment Incomplete', 'yellow')
export const SEND_FAIL = new CommonState('F', '发送失败', 'Send Fail', 'red')
export const SEND_SUCCESS = new CommonState('T', '发送成功', 'Send Success', 'green')
export const SEND_INIT = new CommonState('INIT', '未发送', 'Send Init', 'gray')
export const SEND_NO_RECEIPT	 = new CommonState('Sent', '已发送', 'Sent', 'green')

// 反恐舱单ENS link的海关回执
export const IE3Q01 = new CommonState('IE3Q01', 'DNL-禁止装船', 'DNL-DO NOT LOAD', 'red')
export const IE3Q02 = new CommonState('IE3Q02', 'RFI-补充信息', 'RFI-Request Info', 'yellow')
export const IE3R01 = new CommonState('IE3R01', 'R01-回执成功', 'R01-Accept', 'green')
export const IE3R04 = new CommonState('IE3R04', 'R04-到港登记', 'R04-Port Registration', 'gray')
export const IE3R07 = new CommonState('IE3R07', 'DET-删除成功', 'DET-Cancelled', 'gray')
export const IE3N01 = new CommonState('IE3N01', 'N01-删除异常', 'N01-Delete Exception', 'red')
export const IE3N02 = new CommonState('IE3N02', 'N02-入境摘要报关单未完成', 'N02-Entry Summary Customs Declaration Form Not Completed', 'red')
export const IE3N03 = new CommonState('IE3N03', 'N03-风险评估完成', 'N03-Assessment complete', 'green')
export const IE3N04 = new CommonState('IE3N04', 'RFI-补充信息', 'RFI-Request Info', 'yellow')
export const IE3N05 = new CommonState('IE3N05', 'N05-查验通知', 'N05-Inspection Notice', 'yellow')
export const IE3N07 = new CommonState('IE3N07', 'INC-风险评估未完成', 'INC-Assessment Incomplete', 'yellow')
export const IE3N08 = new CommonState('IE3N08', 'N08-监管通知', 'N08-Regulatory Notice', 'green')
export const IE3N09 = new CommonState('IE3N09', 'N09-授权经济运营商监管通知', 'N09-Regulatory Notice for Authorized Economic Operators', 'red')
export const IE3N10 = new CommonState('IE3N10', 'AMD-修改成功', 'AMD-Amendment Accept', 'green')
export const IE3N11 = new CommonState('IE3N11', 'N11-入境摘要报关单待处理通知', 'N11-Notice of Pending Processing of Entry Summary Customs Declaration Form', 'green')
export const IE3N12 = new CommonState('IE3N12', 'N12-预装载风险评估状态通知', 'N12-Pre loaded Risk Assessment Status Notification', 'green')
export const IE3N99 = new CommonState('IE3N99', 'ERR-字段异常', 'ERR-Error', 'red')

// 反恐仓单AMS link回执
export const AMS_ACCEPTED = new CommonState('ACCEPTED', '已接受', 'Accepted', 'green')
export const AMS_REJECTED = new CommonState('REJECTED', '已拒绝', 'Rejected', 'red')
export const AMS_1Y = new CommonState('1Y', '1Y–HBL与MBL匹配成功', '1Y–HBL matches MBL successfully', 'green')
export const AMS_3Z = new CommonState('3Z', '3Z-海关匹配成功', '3Z-Customs match successful', 'green')

export const AMS_STATUS_LINK_LIST = new Set([
  AMS_ACCEPTED,
  AMS_REJECTED,
  AMS_1Y,
  AMS_3Z
])

// 反恐仓单AFR link回执
export const AFR_MBN = new CommonState('MBN', '主提单未备案', 'Master BL not on file', 'red')
export const AFR_MBE = new CommonState('MBE', '主提单已作为直单提单提交', 'Master BL has been filed as a straight BL(without House BL)', 'green')
export const AFR_MBR = new CommonState('MBR', '主提单已登记', 'Master BL registered', 'green')
export const AFR_MBD = new CommonState('MBD', '主提单已删除', 'Master BL deleted', 'green')
export const AFR_HLD = new CommonState('HLD', '扣货', 'Hold', 'red')
export const AFR_DNL = new CommonState('DNL', '禁止装船', 'Do Not Load', 'red')
export const AFR_DNU = new CommonState('DNU', '禁止装船', 'Do Not Unload', 'red')
export const AFR_HLDC = new CommonState('HLDC', '扣货状态已解除', 'Hold has been cancelled', 'green')
export const AFR_DNLC = new CommonState('DNLC', '禁止装船指令已解除', 'Do Not Load has been cancelled', 'green')
export const AFR_DNUC = new CommonState('DNUC', '禁止卸船指令已解除', 'Do Not Unload has been cancelled', 'green')
export const AFR_FAILED = new CommonState('FAILED', '发送失败', 'Send message to NACCS failed', 'red')
export const AFR_ACCEPTED = new CommonState('ACCEPTED', '已接受', 'Accepted', 'green')
export const AFR_REJECTED = new CommonState('REJECTED', '已拒绝', 'Rejected', 'red')

export const AFR_STATUS_LINK_LIST = new Set([
  AFR_MBN,
  AFR_MBE,
  AFR_MBR,
  AFR_MBD,
  AFR_HLD,
  AFR_DNL,
  AFR_DNU,
  AFR_HLDC,
  AFR_DNLC,
  AFR_DNUC,
  AFR_FAILED,
  AFR_ACCEPTED,
  AFR_REJECTED
])

export const CUSTOMS_STATUS_LIST = new Set([
  ENS_REG,
  ASM_CPL,
  DNL_NOT,
  RFI_NOT,
  ERR_NTF,
  AMD_ACC,
  INV_ACC,
  INC_NOT,
  SEND_FAIL,
  SEND_SUCCESS,
  SEND_INIT,
  SEND_NO_RECEIPT
])

export const CUSTOMS_STATUS_LINK_LIST = new Set([
  IE3Q01,
  IE3Q02,
  IE3R01,
  IE3R04,
  IE3R07,
  IE3N01,
  IE3N02,
  IE3N03,
  IE3N04,
  IE3N05,
  IE3N07,
  IE3N08,
  IE3N09,
  IE3N10,
  IE3N11,
  IE3N12,
  IE3N99
])

// 合同修改日志类型
export const ADD_CONTRACT = new CommonState(1, '新增合同', 'add')
export const EDIT_CONTRACT = new CommonState(2, '编辑合同', 'Edit')
export const RENEW_CONTRACT = new CommonState(3, '续签合同', 'Renew')
export const REPEAL_CONTRACT = new CommonState(4, '撤销合同', 'Repeal')
export const UPLOAD_CONTRACT_ATTACHMENTS = new CommonState(5, '上传合同附件', 'Upload')

export const CONTRACT_TYPE = new Set([
  ADD_CONTRACT,
  EDIT_CONTRACT,
  RENEW_CONTRACT,
  REPEAL_CONTRACT,
  UPLOAD_CONTRACT_ATTACHMENTS
])

// 结转状态
export const CLOSINGACCOUNT_NO = new CommonState(1, '不结转', 'No ClosingAccount')
export const CLOSINGACCOUNT_UN = new CommonState(2, '待结转', 'Un ClosingAccount')
export const CLOSINGACCOUNT_APPEND = new CommonState(3, '追加待结转', 'Append ClosingAccount')
export const CLOSINGACCOUNT_FINISH = new CommonState(4, '已结转', 'ClosingAccount')

export const CLOSINGACCOUNT_STATUS = new Set([
  CLOSINGACCOUNT_NO,
  CLOSINGACCOUNT_UN,
  CLOSINGACCOUNT_APPEND,
  CLOSINGACCOUNT_FINISH
])

// 整拼类型/操作模式
// 1、海出
export const SE_FCL = new CommonState('SE_FCL', '海出-整箱', 'SE-FCL')
export const SE_LCL = new CommonState('SE_LCL', '海出-自拼箱', 'SE-LCL')
export const SE_BB = new CommonState('SE_BB', '海出-委托拼箱', 'SE-Consignment LCL')
export const SE_BC = new CommonState('SE_BC', '海出-Buyer Consol', 'SE-Buyer Consol')
export const SE_BULK = new CommonState('SE_BULK', '海出-散杂货', 'SE-BULK')
export const SE_SPA = new CommonState('SE_SPA', '海出-特种箱', 'SE-Special')
// 2、海进
export const SI_FCL = new CommonState('SI_FCL', '海进-整箱', 'SI-FCL')
export const SI_LCL = new CommonState('SI_LCL', '海进-拼箱', 'SI-LCL')
export const SI_CON = new CommonState('SI_CON', '海进-集拼', 'SI-Consolidation')
export const SI_POJ = new CommonState('SI_POJ', '海进-项目', 'SI-Project')
export const SI_PVE = new CommonState('SI_PVE', '海进-私人物品', 'SI-Personal Items')
export const SI_ECL = new CommonState('SI_ECL', '海进-委托拼箱', 'SI-Entrust the LCL')
// 3、空出
export const AE_0 = new CommonState('AE_0', '空出-一主多分', 'AE-Console')
export const AE_1 = new CommonState('AE_1', '空出-委托同行', 'AE-Co-Loader')
export const AE_2 = new CommonState('AE_2', '空出-直单', 'AE-Direct')
export const AE_3 = new CommonState('AE_3', '空出-一主一分', 'AE-Back To Back')
// 4、空进
export const AI_0 = new CommonState('AI_0', '空进-一主多分', 'AI-Console')
export const AI_1 = new CommonState('AI_1', '空进-委托同行', 'AI-Co-Loader')
export const AI_2 = new CommonState('AI_2', '空进-直单', 'AI-Direct')
export const AI_3 = new CommonState('AI_3', '空进-一主一分', 'AI-Back To Back')

export const CONTAINERLOAD_TYPES = new Set([SE_FCL, SE_LCL, SE_BB, SE_BC, SE_BULK, SE_SPA, SI_FCL, SI_LCL, SI_CON, SI_POJ, SI_PVE, SI_ECL, AE_0, AE_1, AE_2, AE_3, AI_0, AI_1, AI_2, AI_3])

// 计提状态
export const PROVISIONED_NO = new CommonState(1, '无计提', 'No Provisioned')
export const PROVISIONED_UN = new CommonState(2, '待计提', 'Un Provisioned')
export const PROVISIONED_APPEND = new CommonState(3, '追加待计提', 'Append Provisioned')
export const PROVISIONED_FINISH = new CommonState(4, '已计提', 'Provisioned')

export const PROVISIONED_STATUS = new Set([
  PROVISIONED_NO,
  PROVISIONED_UN,
  PROVISIONED_APPEND,
  PROVISIONED_FINISH
])

// 发送状态简道云
export const NOT_SEND = new CommonState(0, '未发送', 'Not send')
export const SENT = new CommonState(1, '已发送', 'Sent')
export const UPDATE_NOT_SEND = new CommonState(2, '更新未发送', 'Update not send')

export const JDY_SEND_STATUS = new Set([
  NOT_SEND,
  SENT,
  UPDATE_NOT_SEND
])

export function getCommonState(code, list) {
  for (var common of list) {
    if (common.code === code) {
      return common
    }
  }
  return null
}

export function getCommonStateByProp(prop, value, list) {
  for (var common of list) {
    if (common[prop] === value) {
      return common
    }
  }
  return null
}

export function getCommonStateNoLowerCase(code, list) {
  for (var common of list) {
    if (common.code.toLowerCase() === code.toLowerCase()) {
      return common
    }
  }
  return null
}
// ------------
// 跨tenant委托状态(委托方)
// ------------
/**
 * 我方已送达
 */
export const CROSS_TENANT_DELIVERY = new CommonState(0, '我方已送达', 'Delivery')
/**
 * 对方已查看
 */
export const CROSS_TENANT_LOOKOVER = new CommonState(1, '对方已查看', 'Look over')
/**
 * 对方已拒绝
 */
export const CROSS_TENANT_REFUSED = new CommonState(2, '对方已拒绝', 'Refused')
/**
 * 对方已受理
 */
export const CROSS_TENANT_ACCEPTED = new CommonState(3, '对方已受理', 'Accepted')
/**
 * 配舱已完成
 */
export const CROSS_TENANT_FINISHED = new CommonState(4, '配舱已完成', 'Finished')

/**
 * 数据被修改
 */
export const CROSS_TENANT_MODIFIED = new CommonState(5, '数据被修改', 'Modified')

export const CROSS_TENANT_HISTORY_STATES = new Set([
  CROSS_TENANT_DELIVERY,
  CROSS_TENANT_LOOKOVER,
  CROSS_TENANT_REFUSED,
  CROSS_TENANT_ACCEPTED,
  CROSS_TENANT_FINISHED
])

// ------------
// 跨tenant委托状态(接收方)
// ------------
/**
 * 对方已送达
 */
export const CROSS_TENANT_DELIVERY_RECEIVER = new CommonState(0, '对方已送达', 'Delivery')
/**
 * 我方已查看
 */
export const CROSS_TENANT_LOOKOVER_RECEIVER = new CommonState(1, '我方已查看', 'Look over')
/**
 * 我方已拒绝
 */
export const CROSS_TENANT_REFUSED_RECEIVER = new CommonState(2, '我方已拒绝', 'Refused')
/**
 * 我方已受理
 */
export const CROSS_TENANT_ACCEPTED_RECEIVER = new CommonState(3, '我方已受理', 'Accepted')
/**
 * 配舱已完成
 */
export const CROSS_TENANT_FINISHED_RECEIVER = new CommonState(4, '配舱已完成', 'Finished')
/**
 * 数据被修改
 */
export const CROSS_TENANT_MODIFIED_RECEIVER = new CommonState(5, '数据被修改', 'Modified')

export const CROSS_TENANT_HISTORY_STATES_RECEIVER = new Set([
  CROSS_TENANT_DELIVERY_RECEIVER,
  CROSS_TENANT_LOOKOVER_RECEIVER,
  CROSS_TENANT_REFUSED_RECEIVER,
  CROSS_TENANT_ACCEPTED_RECEIVER,
  CROSS_TENANT_FINISHED_RECEIVER
])

/**
 * 对应实体所在的包名，前后端一致【打印后端反射专用】
 */
export const ACT = 'act'
export const BOOKING = 'booking'
export const EDI = 'edi'
export const FINANCE = 'finance'
export const MDM = 'mdm'
export const PM = 'pm'
export const PRICE = 'price'
export const SYS = 'sys'

export const REMARK_JOB_NO = new CommonState('0', '业务编号', 'Job number')
export const REMARK_CUSTOMER_REF_NO = new CommonState('1', '业务参考号', 'Customer reference number')
export const REMARK_BUSINESS_DATE = new CommonState('2', '业务日期', 'Business date')
export const REMARK_ETD = new CommonState('3', 'ETD', 'Estimated time of departure')
export const REMARK_ETA = new CommonState('4', 'ETA', 'Estimated time of arrival')
export const REMARK_LOADING_PORT_ENGLISH = new CommonState('5', '装货港英文名', 'Loading port name (English)')
export const REMARK_LOADING_PORT_CODE = new CommonState('6', '装货港代码', 'Loading port code')
export const REMARK_DISCHARGE_PORT_ENGLISH = new CommonState('7', '卸货港英文名', 'Discharge port name (English)')
export const REMARK_DISCHARGE_PORT_CODE = new CommonState('8', '卸货港代码', 'Discharge port code')
export const REMARK_PLACE_OF_DELIVERY_ENGLISH = new CommonState('9', '交货地英文名', 'Place of delivery (English)')
export const REMARK_PLACE_OF_DELIVERY_CODE = new CommonState('10', '交货地代码', 'Place of delivery code')
export const REMARK_SHIPPING_COMPANY = new CommonState('11', '船公司', 'Shipping company')
export const REMARK_NAME_AND_VOYAGE = new CommonState('12', '船名 航次', 'Vessel name and voyage')
export const REMARK_MBL = new CommonState('13', 'MBL', 'Master bill of lading')
export const REMARK_HBL = new CommonState('14', 'HBL', 'House bill of lading')
export const REMARK_SO_NO = new CommonState('15', 'SONO', 'Shipping order number')
export const REMARK_OPERATOR = new CommonState('16', '操作人员', 'Operator')
export const REMARK_BILLING_REQUIREMENTS = new CommonState('17', '账单开票要求', 'Billing requirements')
export const REMARK_REMARKS_IN_US = new CommonState('18', '外币发票专用备注', 'USD invoice remarks')
export const REMARK_PO_NO = new CommonState('19', '项目编号', 'Purchase order number')
export const REMARK_CONTAINER_INFORMATION = new CommonState('20', '箱型箱量箱种', 'Container information')
export const REMARK_CONTAINER_NO = new CommonState('21', '箱号', 'Container number')
export const REMARK_BILLING_GROUP = new CommonState('22', '对账单开票备注', 'Statement billing remarks')
export const REMARK_SELLER_BANK_INFORMATION = new CommonState('23', '销方银行信息', 'Seller bank information')
export const REMARK_SELLER_BANK_INFORMATION_MULT = new CommonState('24', '销方银行信息（多账号）', 'Seller bank information (multiple accounts)')
export const REMARK_MBL_ALL = new CommonState('25', '主单号(全量显示)', 'Master BL (full display)')
export const REMARK_ATD = new CommonState('26', 'ATD', 'Actual time of departure')
export const REMARK_OPDEPARTMENT = new CommonState('27', '操作部门', 'Operation department')
export const REMARK_OPOFFICE = new CommonState('28', '操作公司', 'Operating company')
export const CUSTOM_REMARK_ONE = new CommonState('29', '自定义备注1', 'Invoice remarks one')
export const CUSTOM_REMARK_TWO = new CommonState('30', '自定义备注2', 'Invoice remarks two')
export const REMARK_BANK_ACCOUNT = new CommonState('31', '开户行行号', 'Bank Account')
export const BILL_NO = new CommonState('32', '账单号', 'Bil lNo')

export const BRANCH_REMARK_CONFIG = new Set([
  REMARK_JOB_NO,
  REMARK_CUSTOMER_REF_NO,
  REMARK_BUSINESS_DATE,
  REMARK_ETD,
  REMARK_ETA,
  REMARK_LOADING_PORT_ENGLISH,
  REMARK_LOADING_PORT_CODE,
  REMARK_DISCHARGE_PORT_ENGLISH,
  REMARK_DISCHARGE_PORT_CODE,
  REMARK_PLACE_OF_DELIVERY_ENGLISH,
  REMARK_PLACE_OF_DELIVERY_CODE,
  REMARK_SHIPPING_COMPANY,
  REMARK_NAME_AND_VOYAGE,
  REMARK_MBL,
  REMARK_HBL,
  REMARK_SO_NO,
  REMARK_OPERATOR,
  REMARK_BILLING_REQUIREMENTS,
  REMARK_REMARKS_IN_US,
  REMARK_PO_NO,
  REMARK_CONTAINER_INFORMATION,
  REMARK_CONTAINER_NO,
  REMARK_BILLING_GROUP,
  REMARK_SELLER_BANK_INFORMATION,
  REMARK_SELLER_BANK_INFORMATION_MULT,
  REMARK_ATD,
  REMARK_MBL_ALL,
  REMARK_OPDEPARTMENT,
  REMARK_OPOFFICE,
  CUSTOM_REMARK_ONE,
  CUSTOM_REMARK_TWO,
  REMARK_BANK_ACCOUNT,
  BILL_NO
])

export const CONTAINER_LOAD_TYPE = [
  new CommonState('FCL', '整箱', 'FCL'),
  new CommonState('LCL', '拼箱', 'LCL'),
  new CommonState('CON', '集拼', 'CON'),
  new CommonState('POJ', '项目', 'POJ'),
  new CommonState('PVE', '私人物品', 'PVE'),
  new CommonState('ECL', '委托拼箱', 'Buyer Console')
]

/**
 * 海运进口-预报模块-业务状态
 * @type {CommonState[]}
 */
export const PREDICTION_JOB_STATES = [
  STATE_VERIFYING, STATE_OPERATING, STATE_PRE_COMMIT, STATE_COMMITED, STATE_VERIFIED, STATE_SHUT_OUT
]

export const FILE_NOT_SENT = new CommonState(0, '未发送', 'Not sent')
export const FILE_SENT = new CommonState(1, '已送出', 'Sent')
export const FILE_RETRIEVED = new CommonState(2, '已取回', 'Retrieved')
export const FILE_RETURNED = new CommonState(3, '已退还', 'returned')
export const FILE_SIGNED_IN = new CommonState(4, '已签收', 'Signed in')

export const FILE_STATUS = new Set([
  FILE_NOT_SENT,
  FILE_SENT,
  FILE_RETRIEVED,
  FILE_RETURNED,
  FILE_SIGNED_IN
])

export const FILE_SENT2 = new CommonState(1, '已送出（未取回）', 'Sent')
export const FILE_RETRIEVED2 = new CommonState(2, '已取回（未退还）', 'Retrieved')

export const FILE_STATUS2 = new Set([
  FILE_NOT_SENT,
  FILE_SENT2,
  FILE_RETRIEVED2,
  FILE_RETURNED
])

export const FILE_STATUS3 = new Set([
  FILE_NOT_SENT,
  FILE_SENT2,
  FILE_RETRIEVED2,
  FILE_RETURNED,
  FILE_SIGNED_IN
])

export const WAREHOUSE_OUT_STATE_ALL = new CommonState('0', '全部', 'All')

export const WAREHOUSE_OUT_STATE_NOT_OUT = new CommonState('1', '未出库', 'Not Out Of The Library')

export const WAREHOUSE_OUT_STATE_OUT = new CommonState('2', '已出库', 'Out Of The Library')

/**
 * 海运进口-仓库操作-出库状态
 * @type {CommonState[]}
 */
export const WAREHOUSE_OUT_STATE = [WAREHOUSE_OUT_STATE_ALL, WAREHOUSE_OUT_STATE_NOT_OUT, WAREHOUSE_OUT_STATE_OUT]

export const WAREHOUSE_IN_STATE_ALL = new CommonState('0', '全部', 'All')

export const WAREHOUSE_IN_STATE_NOT_OUT = new CommonState('1', '未入库', 'Not In The Library')

export const WAREHOUSE_IN_STATE_OUT = new CommonState('2', '已入库', 'In The Library')

/**
 * 海运进口-仓库操作-入库状态
 * @type {CommonState[]}
 */
export const WAREHOUSE_IN_STATE = [WAREHOUSE_IN_STATE_ALL, WAREHOUSE_IN_STATE_NOT_OUT, WAREHOUSE_IN_STATE_OUT]

export const DOMESTIC_DIRECT_CLIENT = new CommonState(0, '国内直客', 'Domestic Direct Client')
export const OVERSEAS_DIRECT_CLIENT = new CommonState(1, '国外直客', 'Overseas Direct Client')
export const OVERSEAS_AGENT = new CommonState(2, '国外代理', 'Overseas Agent')

/**
 * 代收垫付
 */
export const CUSTOM_TYPES = new Set([
  DOMESTIC_DIRECT_CLIENT,
  OVERSEAS_DIRECT_CLIENT,
  OVERSEAS_AGENT
])

export const IMAGES = ['JPG', 'PNG', 'JPEG', 'GIF', 'BMP']

// 温度单位
export const TEMPERATURE_UNITS = [
  new CommonState('Centigrade', '摄氏度', 'Centigrade'),
  new CommonState('FahrenheitDegree', '华氏度', 'Fahrenheit Degree')
]

// 危险品货物类别
export const DAN_CLASS_NOS = [
  new CommonState('1.1类', '1.1类', 'Type 1.1'),
  new CommonState('1.2类', '1.2类', 'Type 1.2'),
  new CommonState('1.3类', '1.3类', 'Type 1.3'),
  new CommonState('1.4类', '1.4类', 'Type 1.4'),
  new CommonState('1.5类', '1.5类', 'Type 1.5'),
  new CommonState('1.6类', '1.6类', 'Type 1.6'),
  new CommonState('2.1类', '2.1类', 'Type 2.1'),
  new CommonState('2.2类', '2.2类', 'Type 2.2'),
  new CommonState('2.3类', '2.3类', 'Type 2.3'),
  new CommonState('第3类', '第3类', 'Type 3'),
  new CommonState('4.1类', '4.1类', 'Type 4.1'),
  new CommonState('4.2类', '4.2类', 'Type 4.2'),
  new CommonState('4.3类', '4.3类', 'Type 4.3'),
  new CommonState('5.1类', '5.1类', 'Type 5.1'),
  new CommonState('5.2类', '5.2类', 'Type 5.2'),
  new CommonState('6.1类', '6.1类', 'Type 6.1'),
  new CommonState('6.2类', '6.2类', 'Type 6.2'),
  new CommonState('第7类', '第7类', 'Type 7'),
  new CommonState('第8类', '第8类', 'Type 8'),
  new CommonState('第9类', '第9类', 'Type 9')
]

// 货物包装类别
export const PACKING_GOODS = [
  new CommonState('Ⅰ', 'Ⅰ', 'Ⅰ'),
  new CommonState('Ⅱ', 'Ⅱ', 'Ⅱ'),
  new CommonState('Ⅲ', 'Ⅲ', 'Ⅲ')
]

// 日志记录模块
export const ALL_MODEL = new CommonState('', '全部', 'ALL')
export const FMBILLINGNATIVE_RECONCILIATION_CHARGE = new CommonState('fmBillingNative-reconciliation-charge', '对账新版-对账-按费用', 'Reconciliation For Charge')
export const FMBILLINGNATIVE_RECONCILIATION_JOB = new CommonState('fmBillingNative-reconciliation-job', '对账新版-对账-按业务', 'Reconciliation For Job')

export const SEARCH_MODEL = [ALL_MODEL, FMBILLINGNATIVE_RECONCILIATION_CHARGE, FMBILLINGNATIVE_RECONCILIATION_JOB]

export const TIERS = [{ label: 'Tier 1', value: 1 }, { label: 'Tier 2', value: 2 }, { label: 'Tier 3', value: 99 }]

// 关账类型
export const FINANCIAL_CLOSING = new CommonState(0, '财务关账', 'Financial Closing')
export const BUSINESS_CLOSING = new CommonState(1, '业务关账', 'Business Closing')
export const CLOSING_ACCOUNT_TYPES = [FINANCIAL_CLOSING, BUSINESS_CLOSING]

/**
 * 费用来源
 */
export const CHARGE_SOURCE_OP = new CommonState(0, '操作', 'op')
export const CHARGE_SOURCE_WAREHOUSE = new CommonState(1, '仓库', 'wareHouse')
export const CHARGE_SOURCE_MOTORCADE = new CommonState(2, '车队', 'motorcade')
export const CHARGE_SOURCE_SOP = new CommonState(3, 'sop自动生成', 'SOP Create')
export const CHARGE_SOURCE_IMPORT_SYNC_EXPORT = new CommonState(4, '进口同步出口', 'Import sync Export')
export const CHARGE_BUYING_AND_SELLING_PRICE = new CommonState(5, '空运买卖价', 'Purchase and sale price of air transportation')
export const CHARGE_SOURCE_EXPORT_SYNC_IMPORT = new CommonState(6, '出口转进口', 'Export to Import')

export const CHARGE_SOURCE_DIFFERENCE_PROCESSING = new CommonState(7, '差额处理', 'Difference processing')
export const CHARGE_SOURCE_SPLIT = new CommonState(8, '拆分', 'Split')
export const CHARGE_SOURCE_RED_FLUSH = new CommonState(9, '红冲', 'Red flush')
export const CHARGE_SOURCE_INSURE = new CommonState(10, '保险', 'Insure')
export const CHARGE_SOURCE_DISPATCH_JOB = new CommonState(11, '设备调运', 'DispatchJob')
export const CHARGE_SOURCE_INTERNAL = new CommonState(12, '内结', 'Internal')
export const CHARGE_SOURCE_ACTUAL_SPILT = new CommonState(13, '真实拆分', 'Actual split')
export const CHARGE_SOURCE_CHANGE_CHARGE = new CommonState(14, '申请修改', 'Change Charge')
export const CHARGE_SOURCE_FINANCE_COST_SHARE = new CommonState(15, '财务费用分摊', 'Finance cost share')
export const CHARGE_SOURCE_FREIGHT_INSURANCE = new CommonState(16, '货运险投保', 'Freight insurance coverage')

export const CHARGE_SOURCE_SEA_HOUSE_VGM_PREPLAN = new CommonState(17, '海管家VGM/预配服务', 'Sea Manager VGM/Pre configuration Services')
export const CHARGE_SOURCE_ENTRUST = new CommonState(18, '交叉委托', 'Entrust')
export const CHARGE_SOURCE_OUT_PUSH = new CommonState(19, '外部推送', 'Out push')
export const CHARGE_SOURCE_WSE_VGM_PREPLAN = new CommonState(20, '未斯VGM/预配服务', 'Wse VGM/Pre configuration Services')
export const CHARGE_SOURCE_CW_AMS_PREPLAN = new CommonState(21, 'CW反恐舱单', 'CW Anti-terrorism manifest')
export const CHARGE_SOURCE_PROFIT_SHARE = new CommonState(22, '利润分成', 'Profit Share')

export const CHARGE_FRONT_WAREHOUSE = new CommonState(24, '前置仓未同步', 'Front-end warehouse not synchronized')
export const CHARGE_FRONT_WAREHOUSE_SYNCHRONIZE = new CommonState(25, '前置仓已同步', 'Front-end warehouse synchronized')
export const CHARGE_ASSEMBLY_ALLOCATION = new CommonState(26, '拼装分摊', 'Assembly allocation')
export const CHARGE_AUTO_GENERATED = new CommonState(27, '自动生成费用', 'Automatically generated fees')
/**
 * 费用来源
 */
export const CHARGE_SOURCES = [
  CHARGE_SOURCE_OP,
  CHARGE_SOURCE_WAREHOUSE,
  CHARGE_SOURCE_MOTORCADE,
  CHARGE_SOURCE_SOP,
  CHARGE_SOURCE_IMPORT_SYNC_EXPORT,
  CHARGE_BUYING_AND_SELLING_PRICE,
  CHARGE_SOURCE_EXPORT_SYNC_IMPORT,
  CHARGE_SOURCE_DIFFERENCE_PROCESSING,
  CHARGE_SOURCE_SPLIT,
  CHARGE_SOURCE_RED_FLUSH,
  CHARGE_SOURCE_INSURE,
  CHARGE_SOURCE_DISPATCH_JOB,
  CHARGE_SOURCE_INTERNAL,
  CHARGE_SOURCE_ACTUAL_SPILT,
  CHARGE_SOURCE_CHANGE_CHARGE,
  CHARGE_SOURCE_FINANCE_COST_SHARE,
  CHARGE_SOURCE_FREIGHT_INSURANCE,
  CHARGE_SOURCE_SEA_HOUSE_VGM_PREPLAN,
  CHARGE_SOURCE_ENTRUST,
  CHARGE_SOURCE_OUT_PUSH,
  CHARGE_FRONT_WAREHOUSE,
  CHARGE_SOURCE_WSE_VGM_PREPLAN,
  CHARGE_SOURCE_CW_AMS_PREPLAN,
  CHARGE_FRONT_WAREHOUSE_SYNCHRONIZE,
  CHARGE_SOURCE_PROFIT_SHARE,
  CHARGE_ASSEMBLY_ALLOCATION,
  CHARGE_AUTO_GENERATED
]
/**
 * 岗位
 */
export const POST_SALES_COMMISSION = new CommonState(0, '销售提成', 'sales commission')
export const POST_OPERATION_COMMISSION = new CommonState(1, '操作提成', 'operation commission')
export const POST_CS_COMMISSION = new CommonState(2, '客服提成', 'cs commission')
/**
 * 岗位
 */
export const POST_SOURCES = [
  POST_SALES_COMMISSION,
  POST_OPERATION_COMMISSION,
  POST_CS_COMMISSION
]

/**
 * 所属系统
 */
export const AD_SYSTEM_CW = new CommonState('cargoWare', 'cargoWare', 'cargoWare')
export const AD_SYSTEM_WL_Support = new CommonState('wlSupport', '沃联之家Support', '沃联Support')
export const AD_SYSTEM_WL = new CommonState('wl', '沃行之家', '沃联')

export const AD_SYSTEM_LIST = new Set([
  AD_SYSTEM_CW,
  AD_SYSTEM_WL_Support,
  AD_SYSTEM_WL
])

/**
 * 模块
 */
export const AD_MODULE_INDEX = new CommonState('index', '首页', 'index')

export const AD_MODULE_LIST = new Set([
  AD_MODULE_INDEX
])

/**
 * 客户类型 沃联
 */
export const AD_CUSTOMER = new CommonState(1, '客户', 'customer')

export const AD_List = new Set([
  AD_CUSTOMER
])
/**
 * 所属页面
 */
export const AD_PAGE_INDEX = new CommonState('index', '首页', 'index')

export const AD_PAGE_LIST = new Set([
  AD_PAGE_INDEX
])

/**
 * 首页顶部
 */
export const AD_PAGE_INDEX_TOP = new CommonState('indexTop', '首页顶部', 'index top')

export const AD_INDEX_LIST = new Set([
  AD_PAGE_INDEX_TOP
])

/**
 * 状态
 */
export const AD_STATUS_DRAFT = new CommonState('0', '草稿', 'draft')
export const AD_STATUS_TO_BE_EFFECTIVE = new CommonState('1', '待生效', 'To be effective')
export const AD_STATUS_PROMOTION = new CommonState('2', '推广中', 'promotion')
export const AD_STATUS_INVALID = new CommonState('3', '已失效', 'invalid')

export const AD_STATUS_LIST = new Set([
  AD_STATUS_DRAFT,
  AD_STATUS_TO_BE_EFFECTIVE,
  AD_STATUS_PROMOTION,
  AD_STATUS_INVALID
])

export const ADS_STATUS_IN_USE = new CommonState('1', '使用中', 'In use')
export const ADS_STATUS_TO_BE_USED = new CommonState('2', '待使用', 'to be used')
export const ADS_STATUS_DEACTIVATED = new CommonState('3', '停用', 'deactivated')

export const ADS_STATUS_LIST = new Set([
  ADS_STATUS_IN_USE,
  ADS_STATUS_TO_BE_USED,
  ADS_STATUS_DEACTIVATED
])

export const WT_USER_TYPE_TENANT = new CommonState('1', '租户', 'tenant')
export const WT_USER_TYPE_SERVICE_PROVIDER = new CommonState('2', '服务商', 'Service provider')
export const WT_USER_TYPE_CUSTOMER = new CommonState('3', '客户', 'customer')
export const WT_USER_TYPE_PERSONAL = new CommonState('4', '个人', 'personal')

export const WT_USER_TYPE_LIST = new Set([
  WT_USER_TYPE_TENANT,
  WT_USER_TYPE_SERVICE_PROVIDER,
  WT_USER_TYPE_CUSTOMER,
  WT_USER_TYPE_PERSONAL
])

export const BUSINESS_MARK_0 = new CommonState(0, '直单', 'Direct order')
export const BUSINESS_MARK_1 = new CommonState(1, '转运', 'Transshipment')
export const BUSINESS_MARK_2 = new CommonState(2, '分批', 'Batching')
export const BUSINESS_MARK_3 = new CommonState(3, '特价', 'Special price')
export const BUSINESS_MARK_4 = new CommonState(4, 'Allocation', 'Allocation')
export const BUSINESS_MARK_5 = new CommonState(5, '现舱', 'Available cabin space')
export const BUSINESS_MARK_LIST = new Set([
  BUSINESS_MARK_0,
  BUSINESS_MARK_1,
  BUSINESS_MARK_2,
  BUSINESS_MARK_3,
  BUSINESS_MARK_4,
  BUSINESS_MARK_5
])

export const CHARGE_INPUT_YES = new CommonState(1, '已录入', 'The fee has been entered.')
export const CHARGE_INPUT_NO = new CommonState(0, '未录入', 'The fee is not entered.')
export const CHARGE_INPUT_LIST = new Set([
  CHARGE_INPUT_YES,
  CHARGE_INPUT_NO
])

// 群组类型
export const GROUP_TYPE_ALL = new CommonState(-1, '-请选择-', 'All')
export const GROUP_TYPE_COMMON = new CommonState(0, '公共', 'Common')
export const GROUP_TYPE_PERSONAL = new CommonState(1, '私人', 'Personal')

export const GROUP_TYPE_LIST = [
  GROUP_TYPE_ALL,
  GROUP_TYPE_COMMON,
  GROUP_TYPE_PERSONAL
]

// 群组场景
export const GROUP_SCENE_ALL = new CommonState('', '', '')
export const GROUP_SCENE_CONSIGNEE = new CommonState(0, '收件人', 'Consignee')
export const GROUP_SCENE_CC_PERSON = new CommonState(1, '抄送人', 'Cc person')

export const GROUP_SCENE_LIST = [
  GROUP_SCENE_ALL,
  GROUP_SCENE_CONSIGNEE,
  GROUP_SCENE_CC_PERSON
]

// 仓库类型
export const NORMAL = new CommonState(0, '普通', 'Normal')
export const SUPERVISE = new CommonState(1, '监管', 'Supervise')
export const STUFFY_BACK_UP_WAREHOUSE = new CommonState(2, '前置仓', 'Backup Warehouse')

export const WARE_HOUSE_TYPE_LIST = [NORMAL, SUPERVISE, STUFFY_BACK_UP_WAREHOUSE]

// 日期类型 --已废弃，请使用ContractConstants中的日期类型
// export const ETD = new CommonState('ETD', 'ETD', 'ETD')
// export const ETA = new CommonState('ETA', 'ETA', 'ETA')
// export const ATD = new CommonState('ATD', 'ATD', 'ATD')
// export const BUSINESS_DATE = new CommonState('businessDate', '业务日期', 'Business Date')
// export const INVOICE_DATE = new CommonState('invoiceDate', '发票日期', 'Invoice Date')
// export const STATEMENT_DATE = new CommonState('billingDate', '账单日期', 'statement date')
// export const EXPENSE_FINANCIAL_DATE = new CommonState('accountingDate', '费用财务日期', 'Expense financial date')
// export const DATA_TYPE_LIST = [ETD, ETA, ATD, BUSINESS_DATE, INVOICE_DATE, STATEMENT_DATE, EXPENSE_FINANCIAL_DATE]

// 结算方式
export const MONTHLY_SETTLEMENT = new CommonState(-1, '按月结算', 'Monthly settlement')
export const WEEKLY_SETTLEMENT = new CommonState(-2, '按周结算', 'Weekly settlement')
export const MONTHLY_SPECIFIED_DATE = new CommonState(0, '每月指定日期', 'Monthly specified date')
export const SEMILUNAR_KNOT = new CommonState(-3, '半月结', 'Semilunar knot')
export const SETTLEMENT_BY_DAY = new CommonState(-4, '按天结算', 'Settlement by day')
export const SETTLEMENT_TYPE = [MONTHLY_SETTLEMENT, WEEKLY_SETTLEMENT, MONTHLY_SPECIFIED_DATE, SEMILUNAR_KNOT, SETTLEMENT_BY_DAY]

// 黑名单
export const YES = new CommonState(true, '是', 'yes')
export const NO = new CommonState(false, '否', 'no')
export const BLACK_LIST = [YES, NO]

// 揽货类型
export const SALES_CANVASS = new CommonState('SC', '自揽货', 'Free Hand')
export const NOMINATED_CARGO = new CommonState('NC', '指定货', 'Nominated Cargo')
export const CARGO_SALES_TYPE = [SALES_CANVASS, NOMINATED_CARGO]

// 邮件模板推送环节
export const MBL_INVITATION_STATEMENT = 2 // MBL邀请对单
export const HBL_INVITATION_STATEMENT = 3 // HBL邀请对单
export const SE_BATCH_PRINT = 4 // 海运出口批量打印
export const FILE_HISTORY = 7 // 文件历史
export const SEND_DESTINATIOIN_PORT_AGENT = 16 // 发送目的港代理
export const SEND_PACKAGE_AGENT = 17 // 自拼箱发送套单港代理
export const BB_SEND_DESTINATIOIN_PORT_AGENT = 18 // 委托拼箱发送目的港代理文件

export const BB_SEND_DESTINATION_PORT_AGENT_STRING = '18' // 委托拼箱发送目的港代理文件

// 运价规则匹配类型
export const MATCH_TYPE_ALL = new CommonState(1, '满足所有规则', '满足所有规则')
export const MATCH_TYPE_ANY = new CommonState(2, '满足任一规则', '满足任一规则')
export const MATCH_TYPES = [MATCH_TYPE_ALL, MATCH_TYPE_ANY]

// 运价类型
export const APPLICATION_FCL = new CommonState('FCL', '整箱运价', 'FCL')
export const APPLICATION_LCL = new CommonState('LCL', '拼箱运价', 'LCL')
export const APPLICATION_PRC_AIR = new CommonState('PRC_AIR', '空运运价', 'PRC_AIR')
export const APPLICATION_FCL_SURCHARGE = new CommonState('FCL_SURCHARGE', '整箱附加费', 'FCL_SURCHARGE')
export const APPLICATION_AIR_SURCHARGE = new CommonState('AIR_SURCHARGE', '空运附加费', 'AIR_SURCHARGE')
export const PRICE_APPLICATIONS = [APPLICATION_FCL, APPLICATION_LCL, APPLICATION_PRC_AIR, APPLICATION_FCL_SURCHARGE, APPLICATION_AIR_SURCHARGE]

export const SENDING_YT = new CommonState('YT', '亿通', '亿通')
export const SENDING_CARGOSMART = new CommonState('cargosmart', 'CARGOSMART', 'CARGOSMART')
export const SENDING_INTTRA = new CommonState('inttra', 'INTTRA', 'INTTRA')
export const SENDING_ZL = new CommonState('ZL', '船公司', '船公司')
export const SENDING_SHARED_CENTER = new CommonState('sharedCenter', '共享中心', 'Shared Center')
export const SENDING_EFREIGHT = new CommonState('efreight', '一飞', 'Efreight')
export const SENDING_TRADETECH = new CommonState('tradetech', '企泰', 'Tradetech')
export const SENDING_DECARTS = new CommonState('decarts', '笛卡尔', 'Decarts')
export const SENDING_DCDW = new CommonState('DCDW', '订舱代理', '订舱代理')
export const SENDING_CARRIER_AGENT = new CommonState('carrierAgent', '船代', '船代')
export const SENDING_DESTINATIONAGENT = new CommonState('destinationAgent', '目的港代理', '目的港代理')
export const SENDING_MTGS = new CommonState('MTGS', '码头公司', '码头公司')
export const SENDING_NBDZKA = new CommonState('NBDZKA', '宁波电子口岸', '宁波电子口岸')
export const WSE_MANIFEST = new CommonState('wseManifest', '未斯舱单', 'WseManifest')
export const SEA_HOUSE_MANIFEST = new CommonState('seaHouseManifest', '海管家舱单', 'SeaHouseManifest')

export const CABIN_SPACE_IMPORT = new CommonState('cabinSpaceImport', '舱位导入', 'Sea export cabin space import document')
export const SENDING_JS = new CommonState('JS', '劲升', 'Crimsonlogic')
export const SENDING_MS = new CommonState('MS', '民生', '民生')

export const SENDING_SHA_WHARF = new CommonState('CNSHA_WHARF', '上海港码头', '上海港码头')
export const SENDING_NBG_WHARF = new CommonState('CNNGB_WHARF', '宁波港码头', '宁波港码头')
export const SENDING_XMG_WHARF = new CommonState('CNXMN_WHARF', '厦门港码头', '厦门港码头')
export const SENDING_SZG_WHARF = new CommonState('CNSZX_WHARF', '深圳港码头', '深圳港码头')
export const SENDING_QDG_WHARF = new CommonState('CNTAO_WHARF', '青岛港码头', '青岛港码头')
export const SENDING_TJG_WHARF = new CommonState('CNTXG_WHARF', '天津港码头', '天津港码头')
export const SENDING_NSG_WHARF = new CommonState('CNNSA_WHARF', '广州南沙港码头', '广州南沙港码头')
export const SENDING_XHQ = new CommonState('XHQ', '信号旗', '信号旗')

export const SENDING_XHQ2 = new CommonState('xhq', '信号旗', '信号旗')
export const SENDING_MNH = new CommonState('mnh', '美能华', 'huami can')
export const SENDING_BY = new CommonState('by', '笔云', 'Google Keep')
export const SENDING_CWMI = new CommonState('cwmi', 'CW-多模态识别', 'CW Multimodal Identification')

export const SENDING_THAILAND = new CommonState('THAILAND', '泰国舱单', 'Thailand')
export const SENDING_GEEK_YUM = new CommonState('GeekYum', '极羽/GeekYum', '极羽/GeekYum')
export const SENDING_ONE_STACK = new CommonState('OneStack', '壹沓', '壹沓')
export const SENDING_JY = new CommonState('JY', '精谕', '精谕')
export const SENDING_ACCPAC_CL_AR = new CommonState('ACCPAC_CL_AR', 'Accpac_CL_AR', 'Accpac_CL_AR')
export const SENDING_ACCPAC_CL_AP = new CommonState('ACCPAC_CL_AP', 'Accpac_CL_AP', 'Accpac_CL_AP')
export const SENDING_JCL = new CommonState('JCL', 'JCL预报', 'JCL Forecast')
export const SENDING_NB_HJS = new CommonState('NB_HJS', '宁波航交所', 'Ningbo Shipping Exchange')
export const SENDING_SHIPPING_FILING = new CommonState('SHIPPING_FILING', '航交所公布运价', 'shipping filing')
export const SENDING_LINK = new CommonState('link', 'Link', 'Link')

// 发送平台
export const SENDING_PLATFORMS = [SENDING_YT, SENDING_CARGOSMART, SENDING_INTTRA, SENDING_ZL, SENDING_SHARED_CENTER,
  SENDING_DCDW, SENDING_CARRIER_AGENT, SENDING_DESTINATIONAGENT, SENDING_MTGS, SENDING_NBDZKA,
  SENDING_EFREIGHT, SENDING_TRADETECH, SENDING_DECARTS, SENDING_SHA_WHARF, SENDING_NBG_WHARF, SENDING_XMG_WHARF, SENDING_SZG_WHARF, SENDING_QDG_WHARF, SENDING_TJG_WHARF, SENDING_NSG_WHARF, SENDING_XHQ,
  SENDING_THAILAND, SENDING_GEEK_YUM, SENDING_ONE_STACK, SENDING_JY, WSE_MANIFEST, SEA_HOUSE_MANIFEST, SENDING_JS, SENDING_MS, CABIN_SPACE_IMPORT, SENDING_ACCPAC_CL_AR, SENDING_ACCPAC_CL_AP, SENDING_JCL, SENDING_NB_HJS, SENDING_SHIPPING_FILING, SENDING_LINK
]

// 托书平台
export const CONSIGNMENT_NOTE_PLATFORMS = [SENDING_XHQ2, SENDING_MNH, SENDING_BY, SENDING_CWMI]

// 空出 托书平台
export const CONSIGNMENT_NOTE_PLATFORMS_AE = [SENDING_CWMI]

// 提单平台
export const BILL_PLATFORMS = [SENDING_BY]

// 空运 提单平台
export const BILL_PLATFORMS_AIR = [SENDING_CWMI]

// 报关单平台
export const CUSTOMS_PLATFORMS = [SENDING_CWMI]

// 反恐舱单ENS平台
export const AMS_ENS_PLATFORMS = [SENDING_CWMI]

// OC支付状态
export const OCPAYMENT_STATUS_0 = new CommonState(0, '未支付', 'Unpaid')
export const OCPAYMENT_STATUS_1 = new CommonState(1, '已支付', 'Paid')
export const OCPAYMENT_STATUS_2 = new CommonState(2, '支付中', 'Payment pending')
export const OCPAYMENT_STATUS_3 = new CommonState(3, '支付失败', 'Payment failed')
export const OCPAYMENT_STATUS_4 = new CommonState(4, '部分支付', 'Partial payment')
export const OCPAYMENT_STATUS = new Set([OCPAYMENT_STATUS_0, OCPAYMENT_STATUS_1, OCPAYMENT_STATUS_2, OCPAYMENT_STATUS_3, OCPAYMENT_STATUS_4])

// OC付款方式
export const OCPAYMENT_METHOD_0 = new CommonState(0, 'PayPal', 'PayPal')
export const OCPAYMENT_METHOD_1 = new CommonState(1, 'Payoneer', 'Payoneer')
export const OCPAYMENT_METHOD_2 = new CommonState(2, '支付宝、微信', 'Alipay, WeChat Pay')
export const OCPAYMENT_METHOD_3 = new CommonState(3, 'ISID扣款', 'ISID deduction')
export const OCPAYMENT_METHOD_4 = new CommonState(4, '线下转账', 'Offline transfer')
export const OCPAYMENT_METHOD = new Set([OCPAYMENT_METHOD_0, OCPAYMENT_METHOD_1, OCPAYMENT_METHOD_2, OCPAYMENT_METHOD_3, OCPAYMENT_METHOD_4])

/**
 *  EDI状态
 */

// 上传完成，处理中
export const EDI_STATUS_PROCESSING = 1
// 上传成功
export const EDI_STATUS_UPLOAD_SUCCESS = 2
// 处理成功
export const EDI_STATUS_CONFIRM_SUCCESS = 3
// 处理失败
export const EDI_STATUS_CONFIRM_FAILURE = 4
// 导出成功
export const EDI_STATUS_EXPORT_SUCCESS = 5

/**
 * EDI编辑状态
 */

// 新增
export const EDI_EDIT_STATUS_NEW = 9
// 修改
export const EDI_EDIT_STATUS_UPDATE = 4

// 订舱性质
export const SELF_BOOKING = new CommonState('SB', '自订舱', 'Self booking')
export const COMMISSIONED_BOOKING = new CommonState('DB', '委托订舱', 'Commissioned booking')
export const CUSTOMER_SELF_BOOKING = new CommonState('CB', '客户自订舱', 'Customer self Booking')

export const BOOKING_NATURE = new Set([SELF_BOOKING, COMMISSIONED_BOOKING, CUSTOMER_SELF_BOOKING])

// 级别
export const HIGHEST = new CommonState(0, '最高', 'highest')
export const HIGH = new CommonState(1, '高', 'high')
export const MIDDLE = new CommonState(2, '中', 'middle')
export const LOW = new CommonState(3, '低', 'low')
export const LEVELS = new Set([HIGHEST, HIGH, MIDDLE, LOW])

// 是否需要
export const NEED = new CommonState('1', '需要', 'need')
export const NO_NEED = new CommonState('0', '不需要', 'Commissioned booking')

export const NEEDS = [NEED, NO_NEED]

// 备案类型
export const BP = new CommonState('1', '招标采购', 'Bidding procurement')
export const NBP = new CommonState('2', '非招标采购', 'Non bidding procurement')
export const PF = new CommonState('3', '平台备案', 'Platform filing')
export const NPI = new CommonState('4', '不涉及平台实施', 'No platform implementation involved')

export const SEND_REMARK_TYPES = [BP, NBP, PF, NPI]

// 支付分公司
export const HEADQUARTERS = new CommonState('0', '总部', 'headquarters')
export const HONG_KONG = new CommonState('1', '香港', 'Hong Kong')
export const HAINAN = new CommonState('2', '海南', 'Hainan')

export const PAYMENT_BRANCH_TYPE = [HEADQUARTERS, HONG_KONG, HAINAN]

// 出库状态[未入库、已入库、部分出库、全部出库]
export const NO_OUT_WAREHOUSE = new CommonState(0, '未出库', 'Not delivered')
export const HAD_OUT_WAREHOUSE = new CommonState(1, '已出库', 'Delivered')
export const PART_OUT_WAREHOUSE = new CommonState(2, '部分出库', 'Partial delivery')
export const ALL_OUT_WAREHOUSE = new CommonState(3, '全部出库', 'All stock out')
export const OUT_WAREHOUSE_STATUS = [NO_OUT_WAREHOUSE, HAD_OUT_WAREHOUSE, PART_OUT_WAREHOUSE, ALL_OUT_WAREHOUSE]

// OC异常说明
export const OCABNORMAL_STATE_1 = new CommonState(1, '1.入账金额与申请金额不符', '1.入账金额与申请金额不符')
export const OCABNORMAL_STATE_2 = new CommonState(2, '2.请上传与申请金额、时间对应信息正确的附件', '2.请上传与申请金额、时间对应信息正确的附件')
export const OCABNORMAL_STATE_3 = new CommonState(3, '3.重复提交', '3.重复提交')
export const OCABNORMAL_STATE_4 = new CommonState(4, '4.未查到该笔进款或信息不符', '4.未查到该笔进款或信息不符')
export const OCABNORMAL_STATE_5 = new CommonState(5, '5.其它', '5.其它')
export const OCABNORMAL_STATE = new Set([OCABNORMAL_STATE_1, OCABNORMAL_STATE_2, OCABNORMAL_STATE_3, OCABNORMAL_STATE_4, OCABNORMAL_STATE_5])

// 税号类型
export const VAT_NO_VAT = new CommonState('VAT', 'VAT', 'VAT')
export const VAT_NO_SDT = new CommonState('SDT', 'SDT', 'SDT')
export const VAT_NO_FTZ = new CommonState('FTZ', 'FTZ', 'FTZ')
export const VAT_NO_DAN = new CommonState('DAN', 'DAN', 'DAN')
export const VAT_NO_TAN = new CommonState('TAN', 'TAN', 'TAN')
export const VAT_NO_DTF = new CommonState('DTF', 'DTF', 'DTF')
export const VAT_NO_CNP = new CommonState('CNP', 'CNP', 'CNP')
export const VAT_NO_DUN = new CommonState('DUN', 'DUN', 'DUN')
export const VAT_NO_EIN = new CommonState('EIN', 'EIN', 'EIN')
export const VAT_NO_EOR = new CommonState('EOR', 'EOR', 'EOR')
export const VAT_NO_SSN = new CommonState('SSN', 'SSN', 'SSN')
export const VAT_NO_TYPES = [VAT_NO_VAT, VAT_NO_SDT, VAT_NO_FTZ, VAT_NO_DAN, VAT_NO_TAN, VAT_NO_DTF, VAT_NO_CNP, VAT_NO_DUN, VAT_NO_EIN, VAT_NO_EOR, VAT_NO_SSN]

// 核单状态
export const CHECKLIST_PASS = new CommonState(1, '通过', 'PASS')
export const CHECKLIST_NO_PASS = new CommonState(0, '不通过', 'NO PASS')
export const CHECKLIST_STATUS = [CHECKLIST_PASS, CHECKLIST_NO_PASS]

// 进位规则
export const CARRY_RULE_ROUNDING = new CommonState(0, '四舍五入', 'Rounding')
export const CARRY_RULE_TRUNCATION = new CommonState(1, '舍位', 'Truncation')
export const CARRY_RULES = [CARRY_RULE_ROUNDING, CARRY_RULE_TRUNCATION]

// 审核状态
export const ZC_VERIFYING = new CommonState(0, '待审核', 'To be reviewed')
export const ZC_TRANSFERRED = new CommonState(1, '待调运', 'To be transferred')
export const ZC_ISSUED = new CommonState(1, '已出库', 'Issued')
export const ZC_STATUS = [ZC_VERIFYING, ZC_TRANSFERRED, ZC_ISSUED]

// msc补充类型
export const MSC_SUPPLEMENT_TYPE_0 = new CommonState(0, '无', 'none')
export const MSC_SUPPLEMENT_TYPE_1 = new CommonState(1, 'MSC订舱补充信息页签', 'MSC booking supplementary information tab')
export const MSC_SUPPLEMENT_TYPE_LIST = [MSC_SUPPLEMENT_TYPE_0, MSC_SUPPLEMENT_TYPE_1]

// 协作状态
export const COOPERATE_STATUS_PENDING = new CommonState(0, '待审核', 'Pending')
export const COOPERATE_STATUS_APPROVED = new CommonState(1, '已审核', 'Approved')
export const COOPERATE_STATUS_REFUSED = new CommonState(2, '已拒绝', 'Refused')
export const COOPERATE_STATUS_RETURNED = new CommonState(3, '已退回', 'Returned')
export const COOPERATE_STATUS = [COOPERATE_STATUS_PENDING, COOPERATE_STATUS_APPROVED, COOPERATE_STATUS_REFUSED, COOPERATE_STATUS_RETURNED]

// 业务/费用状态
export const BUSINESS_STATUS_OPERATING = new CommonState(1, '正操作', 'Operating')
export const BUSINESS_STATUS_FINISHED = new CommonState(2, '已完成', 'Finished')
export const BUSINESS_STATUS = [BUSINESS_STATUS_OPERATING, BUSINESS_STATUS_FINISHED]

export const STATUSTYPE_COOPERATE = new CommonState(1, '协作状态', 'cooperate')
export const STATUSTYPE_BUSINESS = new CommonState(2, '业务状态', 'business')
export const STATUSTYPE_CHARGE = new CommonState(3, '费用状态', 'charge')
export const STATUSTYPE = [STATUSTYPE_COOPERATE, STATUSTYPE_BUSINESS, STATUSTYPE_CHARGE]

// 操作要求操作类型
export const TYPE_STORAGE = new CommonState(1, '仓储', 'storage')
export const TYPE_TRANSPORT = new CommonState(2, '运输', 'transport')
export const TYPE_CUSTOMS = new CommonState(3, '报关', 'customs')
export const TYPE_HANDLING_INFO = new CommonState(4, 'Handling Info', 'Handling Info')
export const OPERATION_REQUIREMENT_TYPES = [TYPE_STORAGE, TYPE_TRANSPORT, TYPE_CUSTOMS, TYPE_HANDLING_INFO]

// 业务模块key， 用于关闭模块时做校验，是否可以关闭此模块
export const CLOSE_MODULE_SE = 'SeaBooking'
export const CLOSE_MODULE_SI = 'SiBooking'
export const CLOSE_MODULE_AE = 'AeBooking'
export const CLOSE_MODULE_AI = 'AiBooking'
export const CLOSE_MODULE_RE = 'ReBooking'
export const CLOSE_MODULE_IE = 'IEBooking'

// 机型类型
export const AIRPLANE_MODEL_WIDE_BODY = new CommonState('1', '宽体', 'Wide body')
export const AIRPLANE_MODEL_NARROW_BODY = new CommonState('2', '窄体', 'Narrow body')
export const AIRPLANE_MODEL_TYPES = [AIRPLANE_MODEL_WIDE_BODY, AIRPLANE_MODEL_NARROW_BODY]

// 集装器类型
export const AIRPLANE_CONTAINER_CONTAINER = new CommonState(1, '集装箱', 'CONTAINER')
export const AIRPLANE_CONTAINER_PALLET = new CommonState(2, '集装板', 'PALLET')
export const AIRPLANE_CONTAINER_TYPES = [AIRPLANE_CONTAINER_CONTAINER, AIRPLANE_CONTAINER_PALLET]
// 包机包板
export const CHARTER_EMPTY = new CommonState(0, '否', 'empty')
export const CHARTER_FLIGHT = new CommonState(1, '包机', 'charter flight')
export const CHARTER_VESSELS = new CommonState(2, '包板', 'charter vessel')
export const CHARTER_FLIGHT_OR_VESSELS = [CHARTER_EMPTY, CHARTER_FLIGHT, CHARTER_VESSELS]
// 包机包板
export const CHARTER_ALL = new CommonState(null, '全部', 'all')
export const ADVANCE_CHARTER_FLIGHT_OR_VESSELS = [CHARTER_ALL, CHARTER_FLIGHT, CHARTER_VESSELS]

// 企泰支持的AMS运输条款
export const CY_CY = new CommonState('CY-CY', 'CY/CY', 'CY/CY')
export const CY_DOOR = new CommonState('CY-DOOR', 'CY/DOOR', 'CY/DOOR')
export const DOOR_CY = new CommonState('DOOR-CY', 'DOOR/CY', 'DOOR/CY')
export const DOOR_DOOR = new CommonState('DOOR-DOOR', 'DOOR/DOOR', 'DOOR/DOOR')
export const CFS_CFS = new CommonState('CFS-CFS', 'CFS/CFS', 'CFS/CFS')
export const CFS_DOOR = new CommonState('CFS-DOOR', 'CFS/DOOR', 'CFS/DOOR')
export const DOOR_CFS = new CommonState('DOOR-CFS', 'DOOR/CFS', 'DOOR/CFS')
export const CFS_CY = new CommonState('CFS-CY', 'CFS/CY', 'CFS/CY')
export const CY_CFS = new CommonState('CY-CFS', 'CY/CFS', 'CY/CFS')
export const AMS_FREIGHT_TERM = [CY_CY, CY_DOOR, DOOR_CY, DOOR_DOOR, CFS_CFS, CFS_DOOR, DOOR_CFS, CFS_CY, CY_CFS]

// 发送共享中心状态
export const SHARED_TYPE_UN_PUSHED = new CommonState(1, '未推送', 'un Pushed')
export const SHARED_TYPE_PUSH_FAILURE = new CommonState(2, '推送失败', 'Push failure')
export const SHARED_TYPE_PUSHED = new CommonState(3, '已推送', 'pushed')
export const SHARED_EXAMINE_SUBMITTED = new CommonState(4, '已提交', 'submitted')
export const SHARED_EXAMINE_APPROVE = new CommonState(5, '审批通过', 'approve')
export const SHARED_EXAMINE_FAIL = new CommonState(-1, '审批不通过', 'Fail to approve')
export const SHARED_TYPES = [SHARED_TYPE_UN_PUSHED, SHARED_TYPE_PUSH_FAILURE, SHARED_TYPE_PUSHED, SHARED_EXAMINE_SUBMITTED, SHARED_EXAMINE_APPROVE, SHARED_EXAMINE_FAIL]

export const SHARED_CHARGE_OFF = new CommonState(-1, '未付款', 'non-payment')
export const SHARED_CHARGE_OFF_4 = new CommonState(4, '部分付款', 'partial payment')
export const SHARED_CHARGE_OFF_5 = new CommonState(5, '已付款', 'account paid')
export const SHARED_CHARGE_OFF_6 = new CommonState(6, '无需付款', 'no payment')

export const SHARED_CHARGE_OFF_LIST = [SHARED_CHARGE_OFF, SHARED_CHARGE_OFF_4, SHARED_CHARGE_OFF_5, SHARED_CHARGE_OFF_6]

export const MAPPING_INVOICE_TITLE = new CommonState('SHARED_IT', '开票抬头', 'invoice title')
export const MAPPING_CHARGE_ITEM = new CommonState('SHARED_PI', '业务类型收费项目', 'Service type charge item')
export const MAPPING_ACCOUNT_CODE = new CommonState('SHARED_LC', '分公司账套编码', 'Branch account set code')
export const MAPPING_RECEIPT_OR_PAYMENT = new CommonState('SHARED_RP', '收付款方式', 'Method of receipt and payment')
export const MAPPING_TYPES = [MAPPING_INVOICE_TITLE, MAPPING_CHARGE_ITEM, MAPPING_ACCOUNT_CODE, MAPPING_RECEIPT_OR_PAYMENT]

// 推送共享中心日志类型
export const SHARED_LOG_BLUE = new CommonState('invoiceB', '推送财务应收单(蓝票)', 'Push financial receivables (blue ticket)')
export const SHARED_LOG_RED = new CommonState('invoiceR', '推送财务应收单(红票)', 'Push financial receivables (red note)')
export const SHARED_LOG_PRELIMINARY = new CommonState('preliminary', '推送预估单', 'Push estimate sheet')
export const SHARED_LOG_FINANCIAL_PAY = new CommonState('financialAP', '推送财务应付单', 'Push financial pay')
export const SHARED_LOG_PAYMENT_REQUEST = new CommonState('billPayment', '推送付款申请单', 'Push payment request')
export const SHARED_LOG_TYPES = [SHARED_LOG_BLUE, SHARED_LOG_RED, SHARED_LOG_PRELIMINARY, SHARED_LOG_FINANCIAL_PAY, SHARED_LOG_PAYMENT_REQUEST]

export const errorMapping_1 = new CommonState('no data', '没有数据', 'no data')
export const errorMapping_2 = new CommonState('login error', '登录失败', 'no data')
export const errorMapping_3 = new CommonState('office no mapping', '公司无映射', 'office no mapping')
export const errorMapping_4 = new CommonState('mapping is miss', '缺少映射', 'mapping is miss')
export const errorMapping_5 = new CommonState('stateError', '请选择尚未推送的数据', 'Please select data that has not yet been pushed')
export const errorMapping_6 = new CommonState('fileError', '发票推送需要包含附件,请核实', 'The invoice push needs to contain attachments, please check')
export const errorMapping_7 = new CommonState('not update', '没有数据发生变更', 'No data has changed')
export const ERROR_MAPPING_TYPE = [errorMapping_1, errorMapping_2, errorMapping_3, errorMapping_4, errorMapping_5, errorMapping_6, errorMapping_7]

export const asyncMapping_1 = new CommonState('repeatClick', '后端正在处理，请稍后', 'The rear end is processing, please wait')
export const asyncMapping_2 = new CommonState('asyncDo', '提交成功，后端正在处理，请稍后刷新页面查看', 'The submission is successful, and the end is being processed. Please refresh the page later to check')
export const ASYNC_MAPPING_TYPE = [asyncMapping_1, asyncMapping_2]

export const PRIORITY_0 = new CommonState(0, '普通', 'common')
export const PRIORITY_1 = new CommonState(1, '加急', 'urgent')
export const PRIORITY_TYPE = [PRIORITY_0, PRIORITY_1]

export const PREPAY_0 = new CommonState(0, '无', 'none')
export const PREPAY_1 = new CommonState(1, '预付', 'collection')
export const PREPAY_2 = new CommonState(2, '托收', 'prepay')
export const PREPAY_TYPE = [PREPAY_0, PREPAY_1, PREPAY_2]

export const FINANCE_AP_INVOICE_TYPE_1 = new CommonState(1, '电子发票', 'Electronic Invoice')
export const FINANCE_AP_INVOICE_TYPE_2 = new CommonState(2, '纸质发票', 'Paper Invoice')
export const FINANCE_AP_INVOICE_TYPE = [
  FINANCE_AP_INVOICE_TYPE_1,
  FINANCE_AP_INVOICE_TYPE_2
]

export const INVOICE_POOL_INVOICE_TYPE_BLUE = new CommonState(1, '蓝票', 'blue ticket')
export const INVOICE_POOL_INVOICE_TYPE_RED = new CommonState(2, '红票', 'red ticket')
export const INVOICE_POOL_INVOICE_TYPES = new Set([
  INVOICE_POOL_INVOICE_TYPE_BLUE,
  INVOICE_POOL_INVOICE_TYPE_RED
])

/** 发票池-百望发票种类编码 */
export const INVOICE_POOL_TYPE_CODE_01 = new CommonState('01', '电子发票(增值税专用发票)', 'Electronic invoice (VAT special)')
export const INVOICE_POOL_TYPE_CODE_02 = new CommonState('02', '电子发票(普通发票)', 'Electronic invoice (ordinary)')
export const INVOICE_POOL_TYPE_CODE_85 = new CommonState('85', '纸质发票(增值税专用发票)', 'Paper invoice (VAT special)')
export const INVOICE_POOL_TYPE_CODE_86 = new CommonState('86', '纸质发票(普通发票)', 'Paper invoice (ordinary)')
export const INVOICE_POOL_TYPE_CODE_004 = new CommonState('004', '增值税专用发票', 'VAT special invoice')
export const INVOICE_POOL_TYPE_CODE_005 = new CommonState('005', '机动车销售统一发票', 'Motor vehicle sales uniform invoice')
export const INVOICE_POOL_TYPE_CODE_006 = new CommonState('006', '二手车销售统一发票', 'Used car sales uniform invoice')
export const INVOICE_POOL_TYPE_CODE_007 = new CommonState('007', '增值税普通发票', 'VAT ordinary invoice')
export const INVOICE_POOL_TYPE_CODE_025 = new CommonState('025', '增值税普通发票(卷式)', 'VAT ordinary invoice (roll)')
export const INVOICE_POOL_TYPE_CODE_026 = new CommonState('026', '增值税电子普通发票', 'VAT electronic ordinary invoice')
export const INVOICE_POOL_TYPE_CODE_028 = new CommonState('028', '增值税电子专用发票', 'VAT electronic special invoice')
export const INVOICE_POOL_TYPE_CODE_51 = new CommonState('51', '电子发票(铁路电子客票)', 'Electronic invoice (railway e-ticket)')
export const INVOICE_POOL_TYPE_CODE_61 = new CommonState('61', '电子发票(航空运输客票电子行程单)', 'Electronic invoice (air e-itinerary)')
export const INVOICE_POOL_INVOICE_TYPE_CODES = new Set([
  INVOICE_POOL_TYPE_CODE_01,
  INVOICE_POOL_TYPE_CODE_02,
  INVOICE_POOL_TYPE_CODE_85,
  INVOICE_POOL_TYPE_CODE_86,
  INVOICE_POOL_TYPE_CODE_004,
  INVOICE_POOL_TYPE_CODE_005,
  INVOICE_POOL_TYPE_CODE_006,
  INVOICE_POOL_TYPE_CODE_007,
  INVOICE_POOL_TYPE_CODE_025,
  INVOICE_POOL_TYPE_CODE_026,
  INVOICE_POOL_TYPE_CODE_028,
  INVOICE_POOL_TYPE_CODE_51,
  INVOICE_POOL_TYPE_CODE_61
])

// 运价类型
export const RATE_TYPE_DIRECT_TRANSPORT = new CommonState('DT', '直拖', 'Direct Transport')
export const RATE_TYPE_FEEDER_SERVICE = new CommonState('FL', '支线', 'Feeder Line')
export const RATE_TYPE = new Set([
  RATE_TYPE_DIRECT_TRANSPORT,
  RATE_TYPE_FEEDER_SERVICE
])
// 核单状态
export const INVOICE_CHANNEL_0 = new CommonState(0, '未启用', 'not enabled')
export const INVOICE_CHANNEL_1 = new CommonState(1, '诺诺网全电发票:NUONUO', 'Nuonuo\'s full electronic invoice: Nuonuo')
export const INVOICE_CHANNEL_2 = new CommonState(2, '百旺金穗云:BWJSY', 'Baiwang Jinsui Cloud: BWJSY')
export const INVOICE_CHANNEL_STATUS = [INVOICE_CHANNEL_0, INVOICE_CHANNEL_1, INVOICE_CHANNEL_2]

export const INVOICE_CLOUD_STATE_0 = new CommonState(0, '未上传', 'Not yet upload')
export const INVOICE_CLOUD_STATE_1 = new CommonState(1, '已上传', 'edit by platinum')
export const INVOICE_CLOUD_STATE_LIST = [INVOICE_CLOUD_STATE_0, INVOICE_CLOUD_STATE_1]

/**
 * 长期保函状态：0-无保函，1-生效中，2-已失效
 * 单票保函状态：0-未上传，1-已上传，2-无需上传
 */
// 长期保函状态
export const LONG_TERM_GUARANTEE_STATE_NONE = new CommonState(0, 'No Guarantee', 'No Guarantee')
export const LONG_TERM_GUARANTEE_STATE_INEFFECT = new CommonState(1, 'In Effect', 'In Effect')
export const LONG_TERM_GUARANTEE_STATE_EXPIRED = new CommonState(2, 'Expired', 'Expired')
// 单票保函状态
export const SINGLE_TICKET_GUARANTEE_STATE_NOT_UPLOADED = new CommonState(0, 'Not Uploaded', 'Not Uploaded')
export const SINGLE_TICKET_GUARANTEE_STATE_UPLOADED = new CommonState(1, 'Uploaded', 'Uploaded')
export const SINGLE_TICKET_GUARANTEE_STATE_NO_REQUIRED = new CommonState(2, 'Not Required', 'Not Required')

// 保函状态 map
export const LONG_TERM_GUARANTEE_STATE_MAP = new Map([
  [LONG_TERM_GUARANTEE_STATE_NONE.code, lang.t('SeaExport.NoGuarantee')],
  [LONG_TERM_GUARANTEE_STATE_INEFFECT.code, lang.t('SeaExport.InEffect')],
  [LONG_TERM_GUARANTEE_STATE_EXPIRED.code, lang.t('SeaExport.Expired')]
])
export const SINGLE_TICKET_GUARANTEE_STATE_MAP = new Map([
  [SINGLE_TICKET_GUARANTEE_STATE_NOT_UPLOADED.code, lang.t('SeaExport.NotUploaded')],
  [SINGLE_TICKET_GUARANTEE_STATE_UPLOADED.code, lang.t('SeaExport.Uploaded')],
  [SINGLE_TICKET_GUARANTEE_STATE_NO_REQUIRED.code, lang.t('SeaExport.NoUploadRequired')]

])

export const WAREHOUSE_TYPE_0 = new CommonState(0, '代理库', 'Agency warehouse')
export const WAREHOUSE_TYPE_1 = new CommonState(1, '自操作', 'Self-operation')
export const WAREHOUSE_TYPE_2 = new CommonState(2, '外包操作', 'Outsourced operation')

export const WAREHOUSE_TYPE_LIST = [WAREHOUSE_TYPE_0, WAREHOUSE_TYPE_1, WAREHOUSE_TYPE_2]

export const LOCATION_TYPE_0 = new CommonState(0, '待入暂存库位', 'Pending inbound temporary storage location')
export const LOCATION_TYPE_1 = new CommonState(1, '待出暂存库位', 'Pending outbound temporary storage location')
export const LOCATION_TYPE_2 = new CommonState(2, '高值库位', 'High-value storage location')
export const LOCATION_TYPE_3 = new CommonState(3, '查验库位', 'Inspection storage location')
export const LOCATION_TYPE_4 = new CommonState(4, '特货库位', 'Special cargo storage location')
export const LOCATION_TYPE_5 = new CommonState(5, '存储库位', 'Storage location')

export const LOCATION_TYPE_LIST = [LOCATION_TYPE_0, LOCATION_TYPE_1, LOCATION_TYPE_2, LOCATION_TYPE_3, LOCATION_TYPE_4, LOCATION_TYPE_5]

export const LOCATION_STATE_0 = new CommonState(0, '未使用', 'Not in use')
export const LOCATION_STATE_1 = new CommonState(1, '可使用', 'Available')
export const LOCATION_STATE_2 = new CommonState(2, '已占用', 'Occupied')
export const LOCATION_STATE_LIST = [LOCATION_STATE_0, LOCATION_STATE_1, LOCATION_STATE_2]

export const PACKING_CONDITION_0 = new CommonState(0, '-请选择-', '-')
export const PACKING_CONDITION_1 = new CommonState(1, '外包装破损', 'Damaged outer packaging')
export const PACKING_CONDITION_2 = new CommonState(2, '外包装潮湿', 'Wet outer packaging')
export const PACKING_CONDITION_3 = new CommonState(3, '外包装有油', 'Oily outer packaging')
export const PACKING_CONDITION_4 = new CommonState(4, '有易碎签', 'Fragile sign')
export const PACKING_CONDITION_5 = new CommonState(5, '有危险品', 'Dangerous goods sign')
export const PACKING_CONDITION_6 = new CommonState(6, '有电池签', 'Battery sign')
export const PACKING_CONDITION_7 = new CommonState(7, '有变色签', 'Color change sign')

export const PACKING_CONDITION_LIST = [PACKING_CONDITION_0, PACKING_CONDITION_1, PACKING_CONDITION_2,
  PACKING_CONDITION_3, PACKING_CONDITION_4, PACKING_CONDITION_5, PACKING_CONDITION_6, PACKING_CONDITION_7]

export const SPECIAL_HANDLING_0 = new CommonState(0, '-请选择-', '-')
export const SPECIAL_HANDLING_1 = new CommonState(1, '需打包带', 'Need strapping')
export const SPECIAL_HANDLING_2 = new CommonState(2, '需加底', 'Need base')
export const SPECIAL_HANDLING_3 = new CommonState(3, '需换托', 'Need pallet exchange')
export const SPECIAL_HANDLING_4 = new CommonState(4, '需打托', 'Need palletizing')
export const SPECIAL_HANDLING_5 = new CommonState(5, '需缠膜', 'Need wrapping')
export const SPECIAL_HANDLING_6 = new CommonState(6, '需套编织袋', 'Need woven bag')
export const SPECIAL_HANDLING_7 = new CommonState(7, '需打三脚架', 'Need tripod')
export const SPECIAL_HANDLING_8 = new CommonState(8, '需打木箱', 'Need wooden box')

export const SPECIAL_HANDLING_LIST = [SPECIAL_HANDLING_0, SPECIAL_HANDLING_1, SPECIAL_HANDLING_2,
  SPECIAL_HANDLING_3, SPECIAL_HANDLING_4, SPECIAL_HANDLING_5, SPECIAL_HANDLING_6, SPECIAL_HANDLING_7, SPECIAL_HANDLING_8]

export const TRAY_MATERIAL_0 = new CommonState(0, 'HTTP托盘', 'HTTP Tray')
export const TRAY_MATERIAL_1 = new CommonState(1, '塑料托盘', 'Plastic Tray')
export const TRAY_MATERIAL_2 = new CommonState(2, '熏蒸托盘', 'Fumigated Tray')
export const TRAY_MATERIAL_3 = new CommonState(3, '免熏蒸托盘', 'Non-fumigated Tray')
export const TRAY_MATERIAL_4 = new CommonState(4, '泡沫托盘', 'Foam Tray')
export const TRAY_MATERIAL_LIST = [TRAY_MATERIAL_0, TRAY_MATERIAL_1, TRAY_MATERIAL_2, TRAY_MATERIAL_3, TRAY_MATERIAL_4]

export const RECYCLE_TYPE_0 = new CommonState(0, '循环', 'Recycle')
export const RECYCLE_TYPE_1 = new CommonState(1, '回收', 'Cycle')
export const RECYCLE_TYPE_LIST = [RECYCLE_TYPE_0, RECYCLE_TYPE_1]

// 发送状态
export const SEND_STATUS_SUCCESS = new CommonState(1, '成功', 'success')
export const SEND_STATUS_FAIL = new CommonState(2, '失败', 'fail')
export const SEND_STATUS_ALL = new CommonState('', '全部', 'all')
export const SEND_STATUS = [SEND_STATUS_SUCCESS, SEND_STATUS_FAIL, SEND_STATUS_ALL]
// 发送类型
export const SEND_TYPE_ORIGINAL = new CommonState(1, '原费用', 'Original cost')
export const SEND_TYPE_ADD = new CommonState(2, '增加调整', 'Add adjustments')
export const SEND_TYPE_MODIFY = new CommonState(3, '修改调整', 'Modify the adjustment')
export const SEND_TYPE_DELETE = new CommonState(4, '删除调整', 'Delete adjustments')
export const SEND_TYPE_CHANGE_ORDER_REVIEW = new CommonState(5, '改单审核费用', 'Change order review charge')
export const SEND_TYPE = [SEND_TYPE_ORIGINAL, SEND_TYPE_ADD, SEND_TYPE_MODIFY, SEND_TYPE_DELETE, SEND_TYPE_CHANGE_ORDER_REVIEW]

// 智能托书-来源
export const INTELLIGENT_DOCUMENT_SOURCE_SE = new CommonState(0, '海运出口', 'Sea freight booking')
export const INTELLIGENT_DOCUMENT_SOURCE_REMOTE_SE = new CommonState(1, '远程订舱-海运', 'Remote booking - sea freight')
export const INTELLIGENT_DOCUMENT_SOURCE_2 = new CommonState(2, 'OCR智能识别(SE)', 'ocr intelligent identification')
export const INTELLIGENT_DOCUMENT_SOURCE_3 = new CommonState(3, 'OCR智能识别(SI)', 'ocr intelligent identification')
export const INTELLIGENT_DOCUMENT_SOURCE_4 = new CommonState(4, '海运进口', 'Import by sea')
export const INTELLIGENT_DOCUMENT_SOURCE_5 = new CommonState(5, '海出MBL识别提单', 'MBL Identification bill of lading')
export const INTELLIGENT_DOCUMENT_SOURCE_6 = new CommonState(6, 'MBL邀请对单', 'MBL Invitation list')
export const INTELLIGENT_DOCUMENT_SOURCE_7 = new CommonState(7, '海出HBL识别提单', 'HBL Identification bill of lading')
export const INTELLIGENT_DOCUMENT_SOURCE_8 = new CommonState(8, 'HBL邀请对单', 'HBL Invitation list')
export const INTELLIGENT_DOCUMENT_SOURCE_9 = new CommonState(9, '海出-报关', 'Sea Export Customs Declaration')
export const INTELLIGENT_DOCUMENT_SOURCE_10 = new CommonState(10, '空出-报关', 'Air Export Customs Declaration')
export const INTELLIGENT_DOCUMENT_SOURCE_11 = new CommonState(11, 'OCR智能识别', 'ocr intelligent identification')
export const INTELLIGENT_DOCUMENT_SOURCE_12 = new CommonState(12, '空运出口', 'Export by air')
export const INTELLIGENT_DOCUMENT_SOURCE_13 = new CommonState(13, '空运进口', 'Import by air')
export const INTELLIGENT_DOCUMENT_SOURCE_REMOTE_AE = new CommonState(14, '远程订舱-空运', 'Remote booking - air freight')
export const INTELLIGENT_DOCUMENT_SOURCE_15 = new CommonState(15, '反恐舱单-ENS', 'Anti-terrorism Manifest ENS')
export const INTELLIGENT_DOCUMENT_SOURCE_16 = new CommonState(16, '海出形式分单提单', 'Sea Export Split Bill of Lading')
export const INTELLIGENT_DOCUMENT_SOURCE_17 = new CommonState(18, '箱单识别', 'Box list recognition')

export const INTELLIGENT_DOCUMENT_SOURCE_LIST = [
  INTELLIGENT_DOCUMENT_SOURCE_SE,
  INTELLIGENT_DOCUMENT_SOURCE_REMOTE_SE,
  INTELLIGENT_DOCUMENT_SOURCE_2,
  INTELLIGENT_DOCUMENT_SOURCE_3,
  INTELLIGENT_DOCUMENT_SOURCE_4,
  INTELLIGENT_DOCUMENT_SOURCE_5,
  INTELLIGENT_DOCUMENT_SOURCE_6,
  INTELLIGENT_DOCUMENT_SOURCE_7,
  INTELLIGENT_DOCUMENT_SOURCE_8,
  INTELLIGENT_DOCUMENT_SOURCE_9,
  INTELLIGENT_DOCUMENT_SOURCE_10,
  INTELLIGENT_DOCUMENT_SOURCE_11,
  INTELLIGENT_DOCUMENT_SOURCE_12,
  INTELLIGENT_DOCUMENT_SOURCE_13,
  INTELLIGENT_DOCUMENT_SOURCE_REMOTE_AE,
  INTELLIGENT_DOCUMENT_SOURCE_16,
  INTELLIGENT_DOCUMENT_SOURCE_17
]

export const SENDING = new CommonState(-1, '全部', 'all')
export const SENDING_0 = new CommonState(0, '海出托书', 'Seaborne exports orders')
export const SENDING_1 = new CommonState(1, '海进提单', 'Inward bill of lading')
export const SENDING_2 = new CommonState(2, '海出提单', 'Sea out pairs of orders')
export const SENDING_3 = new CommonState(3, '报关单识别', 'Customs declaration identification')
export const SENDING_4 = new CommonState(4, '空出托书', 'Air export consignment note')
export const SENDING_5 = new CommonState(5, '空进提单', 'Air freight import bill of lading')
export const SENDING_6 = new CommonState(6, '反恐舱单ENS', 'Anti-terrorism manifest ENS')
export const SENDING_7 = new CommonState(7, '箱单识别', 'Box list recognition')

export const IDENTIFICATION_TYPE_1 = [SENDING_0, SENDING_1]
export const IDENTIFICATION_TYPE_2 = [SENDING_0, SENDING_1, SENDING_2, SENDING_3, SENDING_4, SENDING_5, SENDING_7]
export const IDENTIFICATION_TYPE_3 = [SENDING_0, SENDING_1, SENDING_2]
export const IDENTIFICATION_TYPE_4 = [SENDING_4, SENDING_5]
// ocr工具助手 进入时的下拉列表
export const IDENTIFICATION_TYPE_DEFAULT = [SENDING_0, SENDING_1, SENDING_4, SENDING_5]

export const IDENTIFY_TYPE_0 = new CommonState('0', '海出托书识别', 'Seaborne exports orders')
export const IDENTIFY_TYPE_1 = new CommonState('1', '海运提单识别', 'Inward bill of lading')
export const IDENTIFY_TYPE_2 = new CommonState('2', '报关单识别', 'Customs declaration identification')
export const IDENTIFY_TYPE_3 = new CommonState('3', '空运托书识别', 'Airway bill recognition')
export const IDENTIFY_TYPE_4 = new CommonState('4', '空运提单识别', 'Airway bill of lading recognition')
export const IDENTIFY_TYPE_5 = new CommonState('5', '反恐舱单ENS识别', 'Anti-terrorism manifest ENS')
export const IDENTIFY_TYPE_6 = new CommonState('6', 'BC件识别', 'BC part identification')
export const IDENTIFY_TYPE_7 = new CommonState('7', '箱单识别', 'Box list recognition')

export const IDENTIFY_TYPE_LIST = [IDENTIFY_TYPE_0, IDENTIFY_TYPE_1, IDENTIFY_TYPE_2, IDENTIFY_TYPE_3, IDENTIFY_TYPE_4, IDENTIFY_TYPE_5, IDENTIFY_TYPE_6, IDENTIFY_TYPE_7]

export const ANALYSIS_STATUS_0 = new CommonState(0, '未解析', 'Not Parsed')
export const ANALYSIS_STATUS_1 = new CommonState(1, '正在解析', 'Parsing in Progress')
export const ANALYSIS_STATUS_2 = new CommonState(2, '解析完成', 'Parsing Completed')
export const ANALYSIS_STATUS_3 = new CommonState(3, '解析失败', 'Parsing Failed')

export const ANALYSIS_STATUS_LIST = [ANALYSIS_STATUS_0, ANALYSIS_STATUS_1, ANALYSIS_STATUS_2, ANALYSIS_STATUS_3]

export const BPM_STATES_UN_APPROVED = new CommonState(0, '未审批', 'UnApproved')
export const BPM_STATES_IN_APPROVAL = new CommonState(1, '审批中', 'InApproval')
export const BPM_STATES_PARTIAL_APPROVAL = new CommonState(2, '部分审批', 'PartialApproval')
export const BPM_STATES_APPROVED = new CommonState(3, '审批通过', 'Approved')

// bpm审批状态（仅cargoware使用，workflow不使用）
export const BPM_STATES = new Set([BPM_STATES_UN_APPROVED, BPM_STATES_IN_APPROVAL, BPM_STATES_PARTIAL_APPROVAL, BPM_STATES_APPROVED])

// 行为日志 operationSource
// ---------- 海出 -----------
export const LOG_SE_SEA_BOOKING = new CommonState('seSeaBooking', '海出-海运订舱', 'seSeaBooking')
export const LOG_SE_SEA_BOOKING_BASIC = new CommonState('seSeaBookingBasic', '海出-海运订舱-基本', 'seSeaBookingBasic')
export const LOG_SE_SEA_BOOKING_BASIC_SEA_EQ = new CommonState('seSeaBookingBasicSeaEQ', '海出-海运订舱-基本-箱型箱种', 'seSeaBookingBasicSeaEQ')
export const LOG_SE_SEA_BOOKING_BASIC_CARGO_BULK_DETAIL = new CommonState('seSeaBookingBasicCargoBulkDetail', '海出-海运订舱-基本-散杂货', 'seSeaBookingBasicCargoBulkDetail')
export const LOG_SE_SEA_BOOKING_CHARGE = new CommonState('seSeaBookingCharge', '海出-海运订舱-费用', 'seSeaBookingCharge')
export const LOG_SE_SEA_BOOKING_CHARGE_ADVANCE = new CommonState('seSeaBookingChargeAdvance', '海出-海运订舱-代收垫付', 'seSeaBookingChargeAdvance')
export const LOG_SE_SEA_BOOKING_FILE_HISTORY = new CommonState('seSeaBookingFileHistory', '海出-海运订舱-文件历史', 'seSeaBookingFileHistory')
export const LOG_SE_SEA_BOOKING_BASIC_TRANSPORTATION_METHOD = new CommonState('seSeaBookingBasicTransportationMethod', '海出-海运订舱-基本-转运方式', 'seSeaBookingBasicTransportationMethod')
// ---------- 空出 -----------
export const LOG_AE_AIR_BOOKING = new CommonState('aeAirBooking', '空出-空运订舱', 'aeAirBooking')
export const LOG_AE_AIR_BOOKING_BASIC = new CommonState('aeAirBookingBasic', '空出-空运订舱-基本', 'aeAirBookingBasic')
export const LOG_AE_AIR_BOOKING_BASIC_AIR_ULD = new CommonState('aeAirBookingAirUld', '空出-空运订舱-基本-集装器代码', 'aeAirBookingAirUld')
export const LOG_AE_AIR_BOOKING_CHARGE = new CommonState('aeAirBookingCharge', '空出-空运订舱-费用', 'aeAirBookingCharge')
export const LOG_AE_AIR_BOOKING_CHARGE_ADVANCE = new CommonState('aeAirBookingChargeAdvance', '空出-空运订舱-代收垫付', 'aeAirBookingChargeAdvance')
export const LOG_AE_SEA_BOOKING_FILE_HISTORY = new CommonState('aeSeaBookingFileHistory', '空出-空运订舱-文件历史', 'aeSeaBookingFileHistory')
// ---------- 空出 API-----------
export const LOG_AE_AIR_BOOKING_API = new CommonState('aeAirBookingApi', '空出-空运订舱-外部接口', 'aeAirBookingApi')
// ---------- 海进 -----------
export const LOG_SI_SEA_BOOKING = new CommonState('siSeaBooking', '海进-海运操作', 'siSeaBooking')
export const LOG_SI_SEA_BOOKING_BASIC = new CommonState('siSeaBookingBasic', '海进-海运操作-基本', 'siSeaBookingBasic')
export const LOG_SI_SEA_BOOKING_BASIC_SEA_EQ = new CommonState('siSeaBookingBasicSeaEQ', '海进-海运操作-基本-箱型箱种', 'siSeaBookingBasicSeaEQ')
export const LOG_SI_SEA_BOOKING_BASIC_CARGO_BULK_DETAIL = new CommonState('siSeaBookingBasicCargoBulkDetail', '海进-海运操作-基本-散杂货', 'siSeaBookingBasicCargoBulkDetail')
export const LOG_SI_SEA_BOOKING_CHARGE = new CommonState('siSeaBookingCharge', '海进-海运操作-费用', 'siSeaBookingCharge')
export const LOG_SI_SEA_BOOKING_CHARGE_ADVANCE = new CommonState('siSeaBookingChargeAdvance', '海进-海运操作-代收垫付', 'siSeaBookingChargeAdvance')
export const LOG_SI_SEA_BOOKING_FILE_HISTORY = new CommonState('siSeaBookingFileHistory', '海进-海运操作-文件历史', 'siSeaBookingFileHistory')
// ---------- 空进 -----------
export const LOG_AI_AIR_BOOKING = new CommonState('aiAirBooking', '空进-空运操作', 'aiAirBooking')
export const LOG_AI_AIR_BOOKING_MASTER_INFO = new CommonState('aiAirBookingMasterInfo', '空进-空运操作-主票信息（主票）', 'aiAirBookingMasterInfo')
export const LOG_AI_AIR_BOOKING_AIR_OPERATION = new CommonState('aiAirBookingAirOperation', '空进-空运操作-空运操作（小票）', 'aiAirBookingAirOperation')
export const LOG_AI_AIR_BOOKING_CHARGE = new CommonState('aiAirBookingCharge', '空进-空运操作-费用', 'aiAirBookingCharge')
export const LOG_AI_AIR_BOOKING_CHARGE_ADVANCE = new CommonState('aiAirBookingChargeAdvance', '空进-空运操作-代收垫付', 'aiAirBookingChargeAdvance')
export const LOG_AI_SEA_BOOKING_FILE_HISTORY = new CommonState('aiSeaBookingFileHistory', '空进-空运操作-文件历史', 'aiSeaBookingFileHistory')
// ---------- 铁路业务 -----------
export const LOG_RE_RAILWAY_BOOKING = new CommonState('reRailwayBooking', '铁路业务-铁路操作', 'reRailwayBooking')
export const LOG_RE_RAILWAY_BOOKING_BASIC = new CommonState('reRailwayBookingBasic', '铁路业务-铁路操作-基本', 'reRailwayBookingBasic')
export const LOG_RE_RAILWAY_BOOKING_BASIC_SEA_EQ = new CommonState('reRailwayBookingBasicSeaEQ', '铁路业务-铁路操作-基本-箱型箱种', 'reRailwayBookingBasicSeaEQ')
export const LOG_RE_RAILWAY_BOOKING_BASIC_SEA_EQ2 = new CommonState('reRailwayBookingBasicSeaEQ2', '铁路业务-铁路操作-基本-箱型', 'reRailwayBookingBasicSeaEQ2')
export const LOG_RE_RAILWAY_BOOKING_CHARGE = new CommonState('reRailwayBookingCharge', '铁路业务-铁路操作-费用', 'reRailwayBookingCharge')
export const LOG_RE_RAILWAY_BOOKING_CHARGE_ADVANCE = new CommonState('reRailwayBookingChargeAdvance', '铁路业务-铁路操作-代收垫付', 'reRailwayBookingChargeAdvance')
export const LOG_RE_SEA_BOOKING_FILE_HISTORY = new CommonState('reSeaBookingFileHistory', '铁路业务-铁路操作-文件历史', 'reSeaBookingFileHistory')
// ---------- 结转 -----------
export const LOG_CARRY_FORWARD = new CommonState('carryForward', '结转', 'carryForward')
export const LOG_CARRY_FORWARD_CHARGE = new CommonState('carryForwardCharge', '结转-费用', 'carryForwardCharge')
export const LOG_CARRY_FORWARD_CHARGE_ADVANCE = new CommonState('carryForwardChargeAdvance', '结转-代收垫付', 'carryForwardChargeAdvance')
// ---------- 财务审核 -----------
export const LOG_FINANCIAL_REVIEW = new CommonState('financialReview', '财务审核', 'financialReview')
export const LOG_FINANCIAL_REVIEW_CHARGE = new CommonState('financialReviewCharge', '财务审核-费用', 'financialReviewCharge')
export const LOG_FINANCIAL_REVIEW_CHARGE_ADVANCE = new CommonState('financialReviewChargeAdvance', '财务审核-代收垫付', 'financialReviewChargeAdvance')
// ---------- 对账 -----------
export const LOG_RECONCILIATION = new CommonState('reconciliation', '对账', 'reconciliation')
export const LOG_RECONCILIATION_CHARGE = new CommonState('reconciliationCharge', '对账-费用', 'reconciliationCharge')
export const LOG_RECONCILIATION_CHARGE_ADVANCE = new CommonState('reconciliationChargeAdvance', '对账-代收垫付', 'reconciliationChargeAdvance')
// ---------- 开票 -----------
export const LOG_MAKE_INVOICE = new CommonState('makeInvoice', '开票', 'makeInvoice')
export const LOG_MAKE_INVOICE_CHARGE = new CommonState('makeInvoiceCharge', '开票-费用', 'makeInvoiceCharge')
export const LOG_MAKE_INVOICE_CHARGE_ADVANCE = new CommonState('makeInvoiceChargeAdvance', '开票-代收垫付', 'makeInvoiceChargeAdvance')

export const LOG_API_CALL_BACK_CHARGE = new CommonState('apiCallBackCharge', '开票-发票号回调-api回调-费用', 'apiCallBackCharge')
export const LOG_API_CALL_BACK_CHARGE_ADVANCE = new CommonState('apiCallBackChargeAdvance', '开票-发票号回调-api回调-代收垫付', 'apiCallBackChargeAdvance')
export const LOG_BWJS_CHARGE = new CommonState('bwjsCharge', '开票-发票号回调-百旺金穗云-费用', 'bwjsCharge')
export const LOG_BWJS_CHARGE_ADVANCE = new CommonState('bwjsChargeAdvance', '开票-发票号回调-百旺金穗云-代收垫付', 'bwjsChargeAdvance')
export const LOG_NUONUO_CHARGE = new CommonState('nuoNuoCharge', '开票-发票号回调-诺诺全电-费用', 'nuoNuoCharge')
export const LOG_AISINO_EI_CHARGE = new CommonState('aisinoEiCharge', '开票-发票号回调-航信全电-费用', 'aisinoEiCharge')
export const LOG_TAX_EASY_CHARGE = new CommonState('taxEasyCharge', '开票-发票号回调-容津-费用', 'taxEasyCharge')
export const LOG_TAX_EASY_CHARGE_ADVANCE = new CommonState('taxEasyChargeAdvance', '开票-发票号回调-容津-代收垫付', 'taxEasyChargeAdvance')
export const LOG_YGSH_CHARGE = new CommonState('ygshCharge', '开票-发票号回调-阳光速航-费用', 'ygshCharge')
export const LOG_YGSH_CHARGE_ADVANCE = new CommonState('ygshChargeAdvance', '开票-发票号回调-阳光速航-代收垫付', 'ygshChargeAdvance')
export const LOG_BAI_HUI_CHARGE = new CommonState('baiHuiCharge', '开票-发票号回调-柏辉金壬-费用', 'baiHuiCharge')
export const LOG_BAI_HUI_CHARGE_ADVANCE = new CommonState('baiHuiChargeAdvance', '开票-发票号回调-柏辉金壬-代收垫付', 'baiHuiChargeAdvance')
// ---------- 付款申请 -----------
export const LOG_BILL_PAYMENT = new CommonState('billPayment', '付款申请', 'billPayment')
export const LOG_BILL_PAYMENT_CHARGE = new CommonState('billPaymentCharge', '付款申请-费用', 'billPaymentCharge')
export const LOG_BILL_PAYMENT_CHARGE_ADVANCE = new CommonState('billPaymentChargeAdvance', '付款申请-代收垫付', 'billPaymentChargeAdvance')
// ---------- 销账 -----------
export const LOG_WRITE_OFF = new CommonState('writeOff', '销账', 'writeOff')
export const LOG_WRITE_OFF_CHARGE = new CommonState('writeOffCharge', '销账-费用', 'writeOffCharge')
export const LOG_WRITE_OFF_CHARGE_ADVANCE = new CommonState('writeOffChargeAdvance', '销账-代收垫付', 'writeOffChargeAdvance')
// ---------- 水单认领 -----------
export const LOG_CLAIM_BANK_RECEIPT = new CommonState('claimBankReceipt', '水单认领', 'claimBankReceipt')
export const LOG_CLAIM_BANK_RECEIPT_CHARGE = new CommonState('claimBankReceiptCharge', '水单认领-费用', 'claimBankReceiptCharge')
export const LOG_CLAIM_BANK_RECEIPT_CHARGE_ADVANCE = new CommonState('claimBankReceiptChargeAdvance', '水单认领-代收垫付', 'claimBankReceiptChargeAdvance')
// ---------- 海外结算中心 -----------
export const LOG_OVERSEAS_SETTLEMENT_CENTER = new CommonState('overseasSettlementCenter', '海外结算中心', 'overseasSettlementCenter')
export const LOG_OVERSEAS_SETTLEMENT_CENTER_CHARGE = new CommonState('overseasSettlementCenterCharge', '海外结算中心-费用', 'overseasSettlementCenterCharge')
export const LOG_OVERSEAS_SETTLEMENT_CENTER_CHARGE_ADVANCE = new CommonState('overseasSettlementCenterChargeAdvance', '海外结算中心-代收垫付', 'overseasSettlementCenterChargeAdvance')
// ---------- 业务-费用导入 -----------
export const LOG_CHARGE_IMPORT = new CommonState('chargeImport', '费用导入', 'chargeImport')
export const LOG_CHARGE_IMPORT_CHARGE = new CommonState('chargeImportCharge', '费用导入-费用', 'chargeImportCharge')
export const LOG_CHARGE_IMPORT_CHARGE_ADVANCE = new CommonState('chargeImportChargeAdvance', '费用导入-代收垫付', 'chargeImportChargeAdvance')
// ---------- 出口转进口的业务，【被同步方】的位置 -----------
// ---------- 海出业务 -----------
export const LOG_FROM_IMPORT_BASIC = new CommonState('fromImportBasic', '来自进口-基本', 'fromImportBasic')
export const LOG_FROM_IMPORT_BASIC_SEA_EQ = new CommonState('fromImportBasicSeaEQ', '来自进口-基本-箱型箱种', 'fromImportBasicSeaEQ')
export const LOG_FROM_IMPORT_BASIC_CARGO_BULK_DETAIL = new CommonState('fromImportBasicCargoBulkDetail', '来自进口-基本-散杂货', 'fromImportBasicCargoBulkDetail')
export const LOG_FROM_IMPORT_CHARGE = new CommonState('fromImportCharge', '来自进口-费用', 'fromImportCharge')
export const LOG_FROM_IMPORT_CHARGE_ADVANCE = new CommonState('fromImportChargeAdvance', '来自进口-代收垫付', 'fromImportChargeAdvance')
// ---------- 出口转进口的业务，【被同步方】的位置 -----------
// ---------- 海进业务 -----------
export const LOG_FROM_EXPORT_BASIC = new CommonState('fromExportBasic', '来自出口-基本', 'fromExportBasic')
export const LOG_FROM_EXPORT_BASIC_SEA_EQ = new CommonState('fromExportBasicSeaEQ', '来自出口-基本-箱型箱种', 'fromExportBasicSeaEQ')
export const LOG_FROM_EXPORT_BASIC_CARGO_BULK_DETAIL = new CommonState('fromExportBasicCargoBulkDetail', '来自出口-基本-散杂货', 'fromExportBasicCargoBulkDetail')
export const LOG_FROM_EXPORT_CHARGE = new CommonState('fromExportCharge', '来自出口-费用', 'fromExportCharge')
export const LOG_FROM_EXPORT_CHARGE_ADVANCE = new CommonState('fromExportChargeAdvance', '来自出口-代收垫付', 'fromExportChargeAdvance')
// ---------- 自定义表单 -----------
export const LOG_BOOKING_CUSTOM_FORM = new CommonState('bookingCustomForm', '业务订舱-自定义表单', 'bookingCustomForm')

// 行为日志
export const LOG_OPERATION_SOURCE = new Set([LOG_SE_SEA_BOOKING, LOG_SE_SEA_BOOKING_BASIC, LOG_SE_SEA_BOOKING_BASIC_SEA_EQ, LOG_SE_SEA_BOOKING_BASIC_CARGO_BULK_DETAIL,
  LOG_SE_SEA_BOOKING_CHARGE, LOG_AE_AIR_BOOKING, LOG_AE_AIR_BOOKING_API, LOG_AE_AIR_BOOKING_BASIC, LOG_AE_AIR_BOOKING_BASIC_AIR_ULD, LOG_SI_SEA_BOOKING, LOG_SI_SEA_BOOKING_BASIC, LOG_SI_SEA_BOOKING_BASIC_SEA_EQ,
  LOG_SI_SEA_BOOKING_BASIC_CARGO_BULK_DETAIL, LOG_AI_AIR_BOOKING, LOG_AI_AIR_BOOKING_MASTER_INFO, LOG_AI_AIR_BOOKING_AIR_OPERATION, LOG_RE_RAILWAY_BOOKING, LOG_RE_RAILWAY_BOOKING_BASIC,
  LOG_RE_RAILWAY_BOOKING_BASIC_SEA_EQ, LOG_RE_RAILWAY_BOOKING_BASIC_SEA_EQ2, LOG_AE_AIR_BOOKING_CHARGE, LOG_SI_SEA_BOOKING_CHARGE, LOG_AI_AIR_BOOKING_CHARGE, LOG_RE_RAILWAY_BOOKING_CHARGE,
  LOG_SE_SEA_BOOKING_CHARGE_ADVANCE, LOG_AE_AIR_BOOKING_CHARGE_ADVANCE, LOG_SI_SEA_BOOKING_CHARGE_ADVANCE, LOG_AI_AIR_BOOKING_CHARGE_ADVANCE, LOG_RE_RAILWAY_BOOKING_CHARGE_ADVANCE,
  LOG_CARRY_FORWARD_CHARGE, LOG_CARRY_FORWARD_CHARGE_ADVANCE, LOG_FINANCIAL_REVIEW_CHARGE, LOG_FINANCIAL_REVIEW_CHARGE_ADVANCE, LOG_RECONCILIATION_CHARGE, LOG_RECONCILIATION_CHARGE_ADVANCE,
  LOG_MAKE_INVOICE_CHARGE, LOG_MAKE_INVOICE_CHARGE_ADVANCE, LOG_BILL_PAYMENT_CHARGE, LOG_BILL_PAYMENT_CHARGE_ADVANCE, LOG_WRITE_OFF_CHARGE, LOG_WRITE_OFF_CHARGE_ADVANCE, LOG_API_CALL_BACK_CHARGE, LOG_API_CALL_BACK_CHARGE_ADVANCE, LOG_BWJS_CHARGE,
  LOG_NUONUO_CHARGE, LOG_AISINO_EI_CHARGE,
  LOG_BWJS_CHARGE_ADVANCE, LOG_TAX_EASY_CHARGE, LOG_TAX_EASY_CHARGE_ADVANCE, LOG_YGSH_CHARGE, LOG_YGSH_CHARGE_ADVANCE, LOG_BAI_HUI_CHARGE, LOG_BAI_HUI_CHARGE_ADVANCE, LOG_CLAIM_BANK_RECEIPT_CHARGE,
  LOG_CLAIM_BANK_RECEIPT_CHARGE_ADVANCE, LOG_OVERSEAS_SETTLEMENT_CENTER_CHARGE, LOG_OVERSEAS_SETTLEMENT_CENTER_CHARGE_ADVANCE, LOG_CHARGE_IMPORT_CHARGE, LOG_CHARGE_IMPORT_CHARGE_ADVANCE,
  LOG_FROM_IMPORT_BASIC, LOG_FROM_IMPORT_BASIC_SEA_EQ, LOG_FROM_IMPORT_BASIC_CARGO_BULK_DETAIL, LOG_FROM_IMPORT_CHARGE, LOG_FROM_IMPORT_CHARGE_ADVANCE, LOG_FROM_EXPORT_BASIC,
  LOG_FROM_EXPORT_BASIC_SEA_EQ, LOG_FROM_EXPORT_BASIC_CARGO_BULK_DETAIL, LOG_FROM_EXPORT_CHARGE, LOG_FROM_EXPORT_CHARGE_ADVANCE, LOG_SE_SEA_BOOKING_FILE_HISTORY,
  LOG_AE_SEA_BOOKING_FILE_HISTORY, LOG_SI_SEA_BOOKING_FILE_HISTORY, LOG_AI_SEA_BOOKING_FILE_HISTORY, LOG_RE_SEA_BOOKING_FILE_HISTORY, LOG_SE_SEA_BOOKING_BASIC_TRANSPORTATION_METHOD, LOG_BOOKING_CUSTOM_FORM])

// jump财务审核
export const LOG_JUMP_FINANCE = new Set([LOG_FINANCIAL_REVIEW_CHARGE, LOG_FINANCIAL_REVIEW_CHARGE_ADVANCE, LOG_RECONCILIATION_CHARGE, LOG_RECONCILIATION_CHARGE_ADVANCE,
  LOG_MAKE_INVOICE_CHARGE, LOG_MAKE_INVOICE_CHARGE_ADVANCE, LOG_BILL_PAYMENT_CHARGE, LOG_BILL_PAYMENT_CHARGE_ADVANCE, LOG_WRITE_OFF_CHARGE, LOG_WRITE_OFF_CHARGE_ADVANCE, LOG_API_CALL_BACK_CHARGE, LOG_API_CALL_BACK_CHARGE_ADVANCE, LOG_BWJS_CHARGE,
  LOG_NUONUO_CHARGE, LOG_AISINO_EI_CHARGE,
  LOG_BWJS_CHARGE_ADVANCE, LOG_TAX_EASY_CHARGE, LOG_TAX_EASY_CHARGE_ADVANCE, LOG_YGSH_CHARGE, LOG_YGSH_CHARGE_ADVANCE, LOG_BAI_HUI_CHARGE, LOG_BAI_HUI_CHARGE_ADVANCE,
  LOG_OVERSEAS_SETTLEMENT_CENTER_CHARGE, LOG_OVERSEAS_SETTLEMENT_CENTER_CHARGE_ADVANCE, LOG_CLAIM_BANK_RECEIPT_CHARGE, LOG_CLAIM_BANK_RECEIPT_CHARGE_ADVANCE])

export const LOG_OPERATION_TYPE_DELETE = new CommonState('1', '删除', 'delete')
export const LOG_OPERATION_TYPE_ADD = new CommonState('2', '新增', 'add')
export const LOG_OPERATION_TYPE_UPDATE = new CommonState('3', '编辑', 'update')

// 计费系统计费项目
export const SHIPPING_COMPANY_CARGO_TRACKING = 15 // 船公司货物追踪计费项
export const TYPE_Shipping = 7 // 船公司货物追踪计费项
export const TYPE_CUSTOMS_ANALYSIS = 59 // 报关单解析
export const TYPE_SI_DOC = 39 // 海进提单识别
export const TYPE_SE_DOC = 40 // 海出提单对单
export const TYPE_AE_BOOKING_NOTE = 79 // 空出托书识别
export const TYPE_AI_LADING_BILL = 80 // 空进提单识别
export const TYPE_BOX_LIST = 87 // 箱单识别
export const TYPE_AMS = 54 // 反恐舱单AMS 发送
export const TYPE_AFR = 56 // 反恐舱单AFR 发送
export const TYPE_ENS = 58 // 反恐舱单ENS发送

export const DOC_PAGE_SOURCE = 'ocr'

export const BS_ITEM_MAP = new Map([
  [SENDING_0.code, TYPE_Shipping],
  [SENDING_1.code, TYPE_SI_DOC],
  [SENDING_2.code, TYPE_SE_DOC],
  [SENDING_4.code, TYPE_AE_BOOKING_NOTE],
  [SENDING_5.code, TYPE_AI_LADING_BILL],
  [SENDING_7.code, TYPE_BOX_LIST]
])

// 归档状态
export const ARCHIVEABLE = new CommonState(1, '可归档', 'Archiveable')
export const NOT_ARCHIVEABLE = new CommonState(0, '不可归档', 'Not archiveable')

export const ARCHIVEABLE_STATUS = new Set([
  ARCHIVEABLE,
  NOT_ARCHIVEABLE
])

/**
 * 提醒类型
 */
export const NO_REMINDERS = new CommonState(0, '不提醒', 'No reminders')
export const REMINDER_ONLY = new CommonState(1, '仅提醒', 'Reminder only')
export const STRONG_VERIFICATION = new CommonState(2, '强校验', 'Strong verification')
export const ALERT_TYPE = [
  NO_REMINDERS,
  REMINDER_ONLY,
  STRONG_VERIFICATION
]

/**
 * 禁止类型
 */
export const NOT_PROHIBITED = new CommonState(0, '不禁止', 'Not prohibited')
export const FORBID = new CommonState(1, '禁止', 'forbid')
export const PROHIBITED_TYPE = [
  NOT_PROHIBITED,
  FORBID
]

// 信号旗接口名称
export const CREATE_BILL_OF_LADING = new CommonState('XHQ_TDSJGXJK', '提单数据更新接口', 'Create bill of lading interface')
export const UPLOAD_BILL_OF_LADING_FILE = new CommonState('XHQ_TDWJSCJK', '提单文件上传接口', 'Upload bill of lading file interface')
export const BILL_OF_LADING_DATA_RETURN = new CommonState('XHQ_TDSJHCJK', '提单数据回传接口', 'Bill of lading data return interface')
export const XHQ_INTERFACE = new Set([CREATE_BILL_OF_LADING, UPLOAD_BILL_OF_LADING_FILE, BILL_OF_LADING_DATA_RETURN])

// 精谕接口名称
export const POST_OUT_WHS_INFO = new CommonState('JY_FSFHZLJK', '发送放货指令接口', 'Post Warehouse Out interface')
export const POST_RLS_INFO = new CommonState('JY_FSFDDZLJK', '发送放单指令接口', 'Post Release Order interface')
export const POST_TAKE_CONT_PLAN = new CommonState('JY_FSTXZLJK', '发送提箱指令接口', 'Post Take Container interface')
export const POST_CONT_PRELOAD_DATA = new CommonState('JY_FSZXZLJK', '发送装箱指令接口', 'Post Container Preload interface')
export const CANCEL_CONT_PRELOAD_DATA = new CommonState('JY_QXZXZLJK', '取消装箱指令接口', 'Cancel Container Preload interface')
export const CONT_PRELOAD_NOTICE = new CommonState('JY_ZXWCTZJK', '装箱完成通知接口', 'Container Preload Notice interface')
export const TAKE_CONT_NOTICE = new CommonState('JY_TXWCTZJK', '提箱完成通知接口', 'Take Container Notice interface')
export const OUT_WHS_NOTICE = new CommonState('JY_FHWCTZJK', '放货完成通知接口', 'Warehouse Our Notice interface')
export const SEND_PORT_NOTICE = new CommonState('JY_SGTZJK', '送港通知接口', 'Send port Notice interface')
export const JY_INTERFACE = new Set([
  POST_OUT_WHS_INFO, POST_RLS_INFO, POST_TAKE_CONT_PLAN, POST_CONT_PRELOAD_DATA, CANCEL_CONT_PRELOAD_DATA,
  CONT_PRELOAD_NOTICE, TAKE_CONT_NOTICE, OUT_WHS_NOTICE, SEND_PORT_NOTICE
])

// API接口数据流向
export const CW_TO_XHQ = new CommonState('CW_TO_XHQ', 'CargoWare->信号旗', 'CargoWare->xinHaoQi')
export const XHQ_TO_CW = new CommonState('XHQ_TO_CW', '信号旗->CargoWare', 'xinHaoQi->CargoWare')
export const CW_TO_JY = new CommonState('CW_TO_JY', 'CargoWare->精谕', 'CargoWare->JingYu')
export const JY_TO_CW = new CommonState('JY_TO_CW', '精谕->CargoWare', 'JingYu->CargoWare')
export const API_DATA_FLOW_DIRECTION = new Set([CW_TO_XHQ, XHQ_TO_CW, CW_TO_JY, JY_TO_CW])

// 费用确认同步来源
export const EXPORT_TO_IMPORT = new CommonState(0, '出口转进口', 'export to import')

export const ENTRUST = new CommonState(1, '委托', 'entrust')

export const CHARGE_CONFIRM_SYNC_SOURCE = new Set([EXPORT_TO_IMPORT, ENTRUST])

// 待我方确认
export const WAITING_FOR_CONFIRMATION = new CommonState(-1, '待我方确认', 'waiting for confirmation')
// 我方已确认
export const WE_HAVE_CONFIRMED = new CommonState(-2, '我方已确认', 'we have confirmed')
// 我方已拒绝
export const WE_HAVE_REFUSED = new CommonState(-3, '我方已拒绝', 'we have refused')
// 待对方确认
export const WAITING_FOR_THE_OTHER_PARTY_TO_CONFIRM = new CommonState(0, '待对方确认', 'waiting for the other party to confirm')
// 对方已确认
export const THE_OTHER_PARTY_HAS_CONFIRMED = new CommonState(1, '对方已确认', 'the other party has confirmed')
// 对方已拒绝
export const THE_OTHER_PARTY_HAS_REFUSED = new CommonState(2, '对方已拒绝', 'the other party has refused')
// 费用确认同步状态
export const CHARGE_CONFIRM_SYNC_STATUS = new Set([WAITING_FOR_CONFIRMATION, WE_HAVE_REFUSED, WE_HAVE_CONFIRMED, WAITING_FOR_THE_OTHER_PARTY_TO_CONFIRM, THE_OTHER_PARTY_HAS_REFUSED, THE_OTHER_PARTY_HAS_CONFIRMED])

export const ADDED_SERVICES_INSURE = new CommonState('insure', '保险', 'insure')
export const ADDED_SERVICES_CUSTOMS = new CommonState('customs', '报关', 'customs')
export const ADDED_SERVICES_VGM_DECLARATION = new CommonState('vgmDeclaration', 'VGM 申报', 'VGM declaration')
export const ADDED_SERVICES_ANTI_TERRORISM_MANIFEST = new CommonState('antiTerrorismManifest', '反恐舱单', 'anti Terrorism Manifest')
export const ADDED_SEA_RAILWAY_TRANSPORTATION = new CommonState('seaRailwayTransportation', '海铁联运', 'Sea Rail Transport')

// 增值服务
export const ADDED_SERVICES = new Set([ADDED_SERVICES_INSURE, ADDED_SERVICES_CUSTOMS, ADDED_SERVICES_VGM_DECLARATION, ADDED_SERVICES_ANTI_TERRORISM_MANIFEST, ADDED_SEA_RAILWAY_TRANSPORTATION])

export const POD_SERVICES_DISPATCH_VEHICLES_AT_DESTINATION = new CommonState('dispatchVehiclesAtDestination', '目的港派车', 'delivery of vehicles to the destination port')
export const POD_SERVICES_US_CUSTOMS_CLEARANCE = new CommonState('usCustomsClearance', '美国清关', 'us customs clearance')

// 目的港服务
export const POD_SERVICES = new Set([POD_SERVICES_DISPATCH_VEHICLES_AT_DESTINATION, POD_SERVICES_US_CUSTOMS_CLEARANCE])

// 合作伙伴类型
export const PARTNER_TYPE_CUSTOMER = new CommonState('IF_CUSTOMER', '客户', 'Customer')
export const PARTNER_TYPE_SUPPLIER = new CommonState('IF_Supplier', '供应商', 'Supplier')

export const PARTNER_TYPE = new Set([PARTNER_TYPE_CUSTOMER, PARTNER_TYPE_SUPPLIER])
export const CHECK_PARTNER_TYPE = new Set([PARTNER_TYPE_CUSTOMER])
// 主单号状态
export const MBL_STATE_0 = new CommonState(0, '新建', 'new')
export const MBL_STATE_1 = new CommonState(1, '使用', 'use')
export const MBL_STATE_2 = new CommonState(2, '作废', 'cancellation')

export const MBL_STATE_TYPE_LIST = new Set([MBL_STATE_0, MBL_STATE_1, MBL_STATE_2])

// 放单申请状态-未申请、未申请
export const REQUEST_RELEASE_STATE_NO = new CommonState(0, '未申请', 'not applied for')
export const REQUEST_RELEASE_STATE_YES = new CommonState(1, '已申请', 'applied for')
export const REQUEST_RELEASE_STATE = new Set([REQUEST_RELEASE_STATE_YES, REQUEST_RELEASE_STATE_NO])

// 海出托书识别文字映射类型：1港口2船司3提单形式4整拼类型5运费条款6委托类型7贸易条款8箱型
export const OCR_MAPPER_TYPE_PORT = new CommonState(1, '港口', 'port')
export const OCR_MAPPER_TYPE_CARRIER = new CommonState(2, '船公司', 'shipping company')
export const OCR_MAPPER_TYPE_BL_TYPE = new CommonState(3, '提单形式', 'Bill of Lading Form')
export const OCR_MAPPER_TYPE_LOAD_TYPE = new CommonState(4, '整拼类型', 'Integral type')
export const OCR_MAPPER_TYPE_SHIPPING_TERM = new CommonState(5, '运输条款', 'Transportation terms')
export const OCR_MAPPER_TYPE_PAYMENT_TERM = new CommonState(6, '运费条款', 'freight clause')
export const OCR_MAPPER_TYPE_INCO_TERM = new CommonState(7, '贸易条款', 'Trade Terms')
export const OCR_MAPPER_TYPE_EQ = new CommonState(8, '箱型', 'Box')
export const OCR_MAPPER_TYPE_CUSTOMER = new CommonState(9, '委托单位', 'client')
export const OCR_MAPPER_TYPE_PACKING = new CommonState(10, '包装', 'packing')
export const OCR_MAPPER_TYPES = [OCR_MAPPER_TYPE_PORT, OCR_MAPPER_TYPE_CARRIER, OCR_MAPPER_TYPE_BL_TYPE, OCR_MAPPER_TYPE_LOAD_TYPE, OCR_MAPPER_TYPE_SHIPPING_TERM, OCR_MAPPER_TYPE_PAYMENT_TERM, OCR_MAPPER_TYPE_INCO_TERM, OCR_MAPPER_TYPE_EQ, OCR_MAPPER_TYPE_CUSTOMER, OCR_MAPPER_TYPE_PACKING]

// OCR额外录单字段
export const OCR_FIELD_CARGOSOURCE = new CommonState('cargoSource', '揽货类型', 'cargoSource')
export const OCR_FIELD_ARRIVEDATE = new CommonState('arriveDate', '预计到货日期', 'arriveDate')
export const OCR_FIELD_CUSTOMCUTOFF = new CommonState('customCutoff', '截关日期', 'customCutoff')
export const OCR_FIELD_CUSTOMERCUTOFF = new CommonState('customerCutoff', '客户截关日期', 'customerCutoff')
export const OCR_FIELD_CUSTOMERSHUTOUT = new CommonState('customerShutout', '客户退关日期', 'customerShutout')
export const OCR_FIELD_CUSTOMERFILECUTOFF = new CommonState('customerFileCutoff', '客户截单时间', 'customerFileCutoff')
export const OCR_FIELD_CSR = new CommonState('csr', '客服', 'csr')
export const OCR_FIELD_DC = new CommonState('dc', '单证', 'dc')
export const OCR_FIELD_INSIDEQUANTITY = new CommonState('insideQuantity', '小件数', 'insideQuantity')
export const OCR_FIELD_INSIDEPACKING = new CommonState('insidePacking', '小件包装', 'insidePacking')
export const OCR_FIELD_CHARGEWEIGHT = new CommonState('chargeWeight', '计费重量RT', 'chargeWeight')
export const OCR_FIELD_CARGOCHINESENAME = new CommonState('cargoChineseName', '中文品名', 'cargoChineseName')
export const OCR_FIELD_USERDEFINEDFIELD1 = new CommonState('userDefinedField1', '自定义字段1', 'userDefinedField1')
export const OCR_FIELD_USERDEFINEDFIELD2 = new CommonState('userDefinedField2', '自定义字段2', 'userDefinedField2')
export const OCR_FIELD_USERDEFINEDFIELD3 = new CommonState('userDefinedField3', '自定义字段3', 'userDefinedField3')
export const OCR_FIELD_USERDEFINEDFIELD4 = new CommonState('userDefinedField4', '自定义字段4', 'userDefinedField4')

export const OCR_FIELD_SC_NO = new CommonState('scNo', '约号', 'Contract No')
export const OCR_FIELD_SALES = new CommonState('sales', '销售', 'Sales')
export const OCR_FIELD_OP = new CommonState('op', '操作', 'Operation')
export const OCR_FIELD_CARGO_TYPE = new CommonState('cargoType', '货物类型', 'Type of goods')
export const OCR_FIELD_SALES_OFFICE = new CommonState('salesOffice', '销售公司', 'Sales company')
export const OCR_FIELD_SALES_DEPARTMENT = new CommonState('salesDepartment', '销售部门', 'Sales Dept')
export const OCR_FIELD_OP_OFFICE = new CommonState('opOffice', '操作公司', 'Operating company')
export const OCR_FIELD_OP_DEPARTMENT = new CommonState('opDepartment', '操作部门', 'Operations Department')
export const OCR_FIELD_BOOKING_AGENT = new CommonState('bookingAgent', '订舱代理', 'Booking Agent')
export const OCR_FIELD_VESSEL_CODE = new CommonState('vesselCode', '船舶呼号', 'Ship call sign')
export const OCR_FIELD_IF_AUTO_BOOKING = new CommonState('ifAutoBooking', '是否自动订舱', 'Is it automatic booking')
export const OCR_FIELD_NOVCC = new CommonState('novcc', 'NOVCC', 'NOVCC')
export const OCR_FIELD_TLI_NO = new CommonState('tliNo', 'TLI NO', 'TLI NO')
export const OCR_FIELD_CARGO_AMOUNT = new CommonState('amount', '货值', 'Cargo amount')
export const OCR_FIELD_CARGO_CURRENCY = new CommonState('currency', '货币', 'Cargo currency')
export const OCR_FIELD_CUSTOMER_RESERVE_VOYAGE = new CommonState('customerReserveVoyage', '客户预定航次', 'Customer reserve voyage')
export const OCR_FIELD_PAGE_NUM = new CommonState('copyNumber', '生成业务份数', 'Generate the number of business copies')

export const USER_DEFINED_ROLE_ID_1 = new CommonState('userDefinedRoleId1', '自定义岗位1', 'Custom position 1')
export const USER_DEFINED_ROLE_ID_2 = new CommonState('userDefinedRoleId2', '自定义岗位2', 'Custom position 2')
export const OVERSEA_OP = new CommonState('overseaOp', '海外客服', 'Over Sea Customer Service')
export const PLANNER = new CommonState('planner', '航线负责人', 'Route supervisor')
export const DESTINATION_AGENT = new CommonState('destinationAgent', '目的港代理', 'Destination agent')
export const EXCHANGE_AGENT = new CommonState('exChangeAgent', '换单代理', 'Delivery Agent')
export const CARRIER_AGENT_ID = new CommonState('carrierAgentId', '船代', 'Carrier Agent')
export const SUPPLIER_ID = new CommonState('warehouseCmp', '仓库供应商', 'Warehouse Supplier')
export const WAREHOUSE = new CommonState('warehouseInfo', '仓库名称', 'Warehouse Name')
export const CUSTOMS_BROKER = new CommonState('customsBroker', '报关行', 'Customs broker')
export const SITE_OP = new CommonState('siteOP', '现场操作', 'Spot Operation')

export const CARRIER_VOYAGE = new CommonState('carrierVoyage', '船司内部航次', 'Carrier\'s internal voyage')
export const MBL_NO = new CommonState('mbl', 'MB/L No.', 'MB/L No.')
export const SO_NO = new CommonState('soNo', 'S/O No.', 'S/O No.')
export const ROUTE_CODE = new CommonState('routeCode', '航线代码', 'Route code')
export const BUSINESS_MARK = new CommonState('businessMark', '业务标记', 'business marking')

// 【非cwmi】目前支持的【录单字段】
export const OCR_FIELDS = [OCR_FIELD_CARGOSOURCE, OCR_FIELD_ARRIVEDATE, OCR_FIELD_CUSTOMCUTOFF, OCR_FIELD_CUSTOMERCUTOFF, OCR_FIELD_CUSTOMERSHUTOUT,
  OCR_FIELD_CUSTOMERFILECUTOFF, OCR_FIELD_CSR, OCR_FIELD_DC, OCR_FIELD_INSIDEQUANTITY, OCR_FIELD_INSIDEPACKING, OCR_FIELD_CHARGEWEIGHT, OCR_FIELD_CARGOCHINESENAME,
  OCR_FIELD_USERDEFINEDFIELD1, OCR_FIELD_USERDEFINEDFIELD2, OCR_FIELD_USERDEFINEDFIELD3, OCR_FIELD_USERDEFINEDFIELD4]

// OCR识别字段
export const OCR_FIELD_CUSTOMER_ID = new CommonState('customerId', '委托单位', 'Consignor')
export const OCR_FIELD_WAREHOUSE_NO = new CommonState('warehouseNo', '进仓编号', 'Warehouse-in no')
export const OCR_FIELD_SHIPPER = new CommonState('shipper', '发货人', 'Shipper')
export const OCR_FIELD_CONSIGNEE = new CommonState('consignee', '收货人', 'Consignee')
export const OCR_FIELD_NOTIFY = new CommonState('notify', '通知人', 'Notify party')
export const OCR_FIELD_CARRIER = new CommonState('carrierId', '船公司', 'Shipping Company')
export const OCR_FIELD_VESSEL = new CommonState('vessel', '船名', 'Vessel name')
export const OCR_FIELD_VOYAGE = new CommonState('voyageFlight', '航次', 'Voyage')
export const OCR_FIELD_ETD = new CommonState('etd', '开航日期', 'Sailing date')
export const OCR_FIELD_PAYMENT_TERM = new CommonState('paymentTermMBL', '运费条款', 'Freight clause')
export const OCR_FIELD_CONTAINER_INFOS = new CommonState('seaEQ', '箱型箱量', 'Container Type & Quantity')
export const OCR_FIELD_INCO_TERM = new CommonState('incoTerm', '贸易条款', 'Trade Terms')
export const OCR_FIELD_CUSTOMER_CONTACT = new CommonState('customerContact', '联系人', 'Contact Person')
export const OCR_FIELD_MEASUREMENTS = new CommonState('measurements', '货物尺寸', 'Goods Size')
export const OCR_FIELD_LOADING_PORT_CODE = new CommonState('loadingPortCode', '起运港', 'POL')
export const OCR_FIELD_TRANSFER_PORT_CODE = new CommonState('transferPortCode', '中转港', 'Transit Port')
export const OCR_FIELD_DISCHARGING_PORT_CODE = new CommonState('dischargingPortCode', '卸货港', 'POD')
export const OCR_FIELD_DESTINATION_PORT_CODE = new CommonState('destinationPortCode', '交货地', 'Place of delivery')
export const OCR_FIELD_QUANTITY = new CommonState('quantityContract', '件数', 'Quantity')
export const OCR_FIELD_PACKING = new CommonState('packing', '包装', 'Package')
export const OCR_FIELD_CUBAGE = new CommonState('cubageContract', '体积', 'CBM')
export const OCR_FIELD_GROSS_WEIGHT = new CommonState('weightContract', '毛重', 'Gross weight')
export const OCR_FIELD_MARK = new CommonState('mark', '唛头', 'Marks')
export const OCR_FIELD_GOOD_NAME = new CommonState('cargoEnglishName', '品名', 'Commodity name')
export const OCR_FIELD_REMARKS = new CommonState('remarks', '备注', 'Remarks')
export const OCR_FIELD_ORDER_TYPE = new CommonState('orderType', '提单形式', 'Bill of Lading Form')
export const OCR_FIELD_CONTAINER_LOAD_TYPE = new CommonState('containerLoadType', '整箱拼箱', 'FCL LCL')
export const OCR_FIELD_FREIGHT_TERM = new CommonState('freightTerm', '运输条款', 'Shipping terms')
export const OCR_FIELD_CUSTOMER_REF_NO = new CommonState('customerRefNo', '业务参考号', 'Business reference number')
export const OCR_FIELD_LOADING_TERM = new CommonState('loadingTerm', '本地服务', 'Local Svc')
export const OCR_FIELD_LOADING_DATE = new CommonState('trucking.loadingDate', '门点服务-提货时间', 'Door service - pick-up time')
export const OCR_FIELD_DOOR_ADDR = new CommonState('trucking.doorAddr', '门点服务-门点地址', 'Door service - Door Address')
export const OCR_FIELD_DOOR_MAN = new CommonState('trucking.doorMan', '门点服务-联系人', 'Door service - Door Contact Person')
export const OCR_FIELD_DRIVER_TEL = new CommonState('trucking.driverTel', '门点服务-联系电话', 'Door service - Tel')
export const OCR_FIELD_HBL = new CommonState('hbl', '分单号', 'HBL No.')
export const OCR_FIELD_OPERATE_TYPE = new CommonState('operateType', '操作模式', 'Operate Type')
export const OCR_FIELD_ISSUED_BY = new CommonState('cargoDoc.issuedBy', 'Issued By', 'Issued By')
export const OCR_FIELD_ACCOUNTING_INFO = new CommonState('cargoDoc.accountingInfo', 'Accounting Information', 'Accounting Information')
export const OCR_FIELD_SIGN_DATE_BL = new CommonState('cargoDoc.signDateBL', '签发日期', 'Date of issue')
export const OCR_FIELD_SIGN_PLACE_BL = new CommonState('cargoDoc.signPlaceBL', '签发地点', 'Place of issue')
export const OCR_FIELD_QUANTITY_ACTUAL = new CommonState('quantityActual', '件数', 'Quantity')
export const OCR_FIELD_WEIGHT_ACTUAL = new CommonState('weightActual', '毛重', 'Gross weight')
export const OCR_FIELD_KGLB = new CommonState('cargoDoc.kglb', 'KG-LB', 'KG-LB')
export const OCR_FIELD_CUBAGE_ACTUAL = new CommonState('cubageActual', '体积', 'CBM')
export const OCR_FIELD_CARRIAGE_DV = new CommonState('cargoDoc.carriageDv', '声明价值', 'Declared value')
export const OCR_FIELD_DVFOR_CUSTOMS = new CommonState('cargoDoc.dvForCustoms', '海关声明价值', 'Declared value for customs')
export const OCR_FIELD_RATE_CLASS = new CommonState('cargoDoc.rateClass', '费率等级', 'Rate level')
// export const OCR_FIELD_C_WEIGHT = new CommonState('cargoDoc.cWeight', '计费重量', 'Billing weight')
export const OCR_FIELD_RATE_CHARGE = new CommonState('cargoDoc.rateCharge', 'Rate Charge', 'Rate Charge')
export const OCR_FIELD_C_TOTAL = new CommonState('cargoDoc.cTotal', 'Total', 'Total')
export const OCR_FIELD_DIMENSION = new CommonState('cargoDoc.dimension', 'Dimension', 'Dimension')
export const OCR_FIELD_CURRENCY = new CommonState('cargoDoc.currency', 'Currency', 'Currency')
export const OCR_FIELD_WT_VAL = new CommonState('cargoDoc.wtVal', 'WT/VAL', 'WT/VAL')
export const OCR_FIELD_SIGN_BY_SHIPPER = new CommonState('cargoDoc.signByShipper', 'Signature of Shipper or his Agent', 'Signature of Shipper or his Agent')
export const OCR_FIELD_SHIPPER_CODE = new CommonState('shipperCode', '发货人code', 'Shipper code')
export const OCR_FIELD_CONSIGNEE_CODE = new CommonState('consigneeCode', '收货人code', 'Consignee code')
export const OCR_FIELD_NOTIFY_CODE = new CommonState('notifyCode', '通知人code', 'Notify party code')
export const OCR_FIELD_DISCHARGE_PORT_CODE = new CommonState('portCode', '卸货港代码', 'POD')
export const OCR_FIELD_BOOKING_TERM = new CommonState('bookingTerm', '约价性质', 'Contract Rate Come From')

export const FIELD_PREFIX_TRUCKING = 'trucking.'
export const FIELD_PREFIX_CARGO_DOC = 'cargoDoc.'

export const FIELD_DEFAULT_NAME = 'defaultName'

export const OCR_FIELD_BILL_NO = new CommonState('billNo', '提单号', 'Bill of lading number.')
export const OCR_FIELD_BL_NUMBER = new CommonState('blNumber', '正本份数', 'Number of copies of the bill of lading')
export const OCR_FIELD_PAYMENT_PLACE_BL = new CommonState('paymentPlaceBL', '付款地点', 'Paid Place')
export const OCR_FIELD_TD_SIGN_PLACE_BL = new CommonState('signPlaceBL', '签发地点', 'Place of issue')
export const OCR_FIELD_TD_SIGN_DATE_BL = new CommonState('signDateBL', '签发日期', 'Date of Issue')
export const OCR_FIELD_HS_CODE = new CommonState('hsCode', 'HSCode', 'Hs Code')
export const OCR_FIELD_DISPATCHING_PLACE = new CommonState('dispatchingPlace', '发货地', 'POR')
export const OCR_FIELD_LOADING_PORT = new CommonState('loadingPort', '起运港', 'POL')
export const OCR_FIELD_DISCHARGING_PORT = new CommonState('dischargingPort', '卸货港', 'POD')
export const OCR_FIELD_DESTINATION_PORT = new CommonState('destinationPort', '交货地', 'Place of delivery')
export const OCR_FIELD_INSIDE_QUANTITY = new CommonState('insideQuantity', '小件数', 'Pieces')
export const OCR_FIELD_INSIDE_PACKING = new CommonState('insidePacking', '小件包装', 'Pieces Type')
export const OCR_FIELD_CONTAINER_DATA = new CommonState('container', '装箱信息', 'Packing information')
export const OCR_FIELD_TD_CUBAGE = new CommonState('cubage', '体积', 'CBM')
export const OCR_FIELD_TD_QUANTITY = new CommonState('quantity', '件数', 'Quantity')
export const OCR_FIELD_TD_WEIGHT = new CommonState('weight', '毛重', 'Gross weight')

// OCR识别字段 map
export const OCR_FIELD_MAP = new Map([
  // ---------- 海出 -----------
  [OCR_FIELD_CUSTOMER_ID.code, lang.t('SeaExport.ConsignationCompany')],
  [OCR_FIELD_WAREHOUSE_NO.code, lang.t('SeaExport.WarehouseNo')],
  [OCR_FIELD_SHIPPER.code, lang.t('Message.Shipper')],
  [OCR_FIELD_CONSIGNEE.code, lang.t('Message.Consignee')],
  [OCR_FIELD_NOTIFY.code, lang.t('Message.Notify')],
  [OCR_FIELD_CARRIER.code, new Map([[FIELD_DEFAULT_NAME, lang.t('SeaExport.ShippingCompany')], [SENDING_4.code, lang.t('SeaExport.AirlineCompany')], [SENDING_5.code, lang.t('SeaExport.AirlineCompany')]])],
  [OCR_FIELD_VESSEL.code, lang.t('Payment.vessel')],
  [OCR_FIELD_VOYAGE.code, new Map([[FIELD_DEFAULT_NAME, lang.t('Payment.voyage')], [SENDING_4.code, lang.t('SeaExport.FlightNo')], [SENDING_5.code, lang.t('SeaExport.FlightNo')]])],
  [OCR_FIELD_ETD.code, lang.t('queryJob.dateOfDeparture')],
  [OCR_FIELD_PAYMENT_TERM.code, lang.t('SeaExport.FreightTerm')],
  [OCR_FIELD_CONTAINER_INFOS.code, lang.t('CargoMsg.Cargo_CartonQuantity')],
  [OCR_FIELD_INCO_TERM.code, lang.t('queryJob.IncoTerm')],
  [OCR_FIELD_CUSTOMER_CONTACT.code, lang.t('Payment.contactPerson')],
  [OCR_FIELD_MEASUREMENTS.code, lang.t('SeaExport.CargoSize')],
  [OCR_FIELD_LOADING_PORT_CODE.code, new Map([[FIELD_DEFAULT_NAME, lang.t('Payment.portOfLoading')], [SENDING_4.code, lang.t('AirExport.StartingStation')], [SENDING_5.code, lang.t('AirExport.StartingStation')]])],
  [OCR_FIELD_TRANSFER_PORT_CODE.code, lang.t('Payment.portOfTransfer')],
  [OCR_FIELD_DISCHARGING_PORT_CODE.code, new Map([[FIELD_DEFAULT_NAME, lang.t('queryJob.dischargingPortCode')], [SENDING_5.code, lang.t('AirExport.DestinationStation')]])],
  [OCR_FIELD_DESTINATION_PORT_CODE.code, new Map([[FIELD_DEFAULT_NAME, lang.t('queryJob.placeOfDelivery')], [SENDING_4.code, lang.t('AirExport.DestinationStation')]])],
  [OCR_FIELD_QUANTITY.code, lang.t('SeaExport.Quantity')],
  [OCR_FIELD_PACKING.code, lang.t('SeaExport.Package')],
  [OCR_FIELD_CUBAGE.code, lang.t('SeaExport.Cubage')],
  [OCR_FIELD_GROSS_WEIGHT.code, lang.t('SeaExport.Weight')],
  [OCR_FIELD_MARK.code, lang.t('SeaExport.Marks')],
  [OCR_FIELD_GOOD_NAME.code, lang.t('Pricing.Goods')],
  [OCR_FIELD_REMARKS.code, lang.t('Payment.remarks')],
  [OCR_FIELD_ORDER_TYPE.code, lang.t('SeaExport.BLForm')],
  [OCR_FIELD_CONTAINER_LOAD_TYPE.code, lang.t('SeaExport.LCL')],
  [OCR_FIELD_FREIGHT_TERM.code, lang.t('SeaExport.TransportationClause')],
  [OCR_FIELD_CUSTOMER_REF_NO.code, lang.t('CargoMsg.Cargo_BusinessReferenceNo')],
  [OCR_FIELD_LOADING_TERM.code, lang.t('SeaExport.LocalService')],
  [OCR_FIELD_LOADING_DATE.code, lang.t('CargoMsg.Cargo_LoadingDate')],
  [OCR_FIELD_DOOR_ADDR.code, lang.t('CargoMsg.Cargo_DoorAddr')],
  [OCR_FIELD_DOOR_MAN.code, lang.t('CargoMsg.Cargo_DoorMan')],
  [OCR_FIELD_DRIVER_TEL.code, lang.t('CargoMsg.Cargo_DriverTel')],
  [OCR_FIELD_HBL.code, lang.t('CargoMsg.Cargo_SeparateNumber')],
  [OCR_FIELD_OPERATE_TYPE.code, lang.t('SeaExport.OperateType')],
  [OCR_FIELD_ISSUED_BY.code, 'Issued By'],
  [OCR_FIELD_ACCOUNTING_INFO.code, 'Accounting Information'],
  [OCR_FIELD_SIGN_DATE_BL.code, lang.t('SeaExport.DateOfIssue')],
  [OCR_FIELD_SIGN_PLACE_BL.code, lang.t('SeaExport.PlaceOfIssue')],
  [OCR_FIELD_QUANTITY_ACTUAL.code, lang.t('SeaExport.Quantity')],
  [OCR_FIELD_WEIGHT_ACTUAL.code, lang.t('SeaExport.Weight')],
  [OCR_FIELD_KGLB.code, 'KG-LB'],
  [OCR_FIELD_CUBAGE_ACTUAL.code, lang.t('CargoMsg.Cargo_Cubage')],
  [OCR_FIELD_CARRIAGE_DV.code, lang.t('CargoMsg.Cargo_DeclaredValue')],
  [OCR_FIELD_DVFOR_CUSTOMS.code, lang.t('CargoMsg.Cargo_DeclaredValueForCustoms')],
  [OCR_FIELD_RATE_CLASS.code, lang.t('CargoMsg.Cargo_RateLevel')],
  // [OCR_FIELD_C_WEIGHT.code, lang.t('CargoMsg.Cargo_ChargedWeight')],
  [OCR_FIELD_RATE_CHARGE.code, 'Rate Charge'],
  [OCR_FIELD_C_TOTAL.code, 'Total'],
  [OCR_FIELD_DIMENSION.code, 'Dimension'],
  [OCR_FIELD_CURRENCY.code, 'Currency'],
  [OCR_FIELD_WT_VAL.code, 'WT/VAL'],
  [OCR_FIELD_SIGN_BY_SHIPPER.code, 'Signature of Shipper or his Agent'],
  [OCR_FIELD_PAGE_NUM.code, lang.t('CargoMsg.Cargo_GenerateNumberOfBusiness')],
  [OCR_FIELD_CARGOSOURCE.code, lang.t('CargoMsg.Cargo_SolicitationType')],
  [OCR_FIELD_ARRIVEDATE.code, lang.t('SeaExport.CargosExpectedArrivalDate')],
  [OCR_FIELD_CUSTOMCUTOFF.code, lang.t('CargoMsg.Cargo_CYCutOffDate')],
  [OCR_FIELD_CUSTOMERCUTOFF.code, lang.t('SeaExport.CustomerCyCutOffDate')],
  [OCR_FIELD_CUSTOMERSHUTOUT.code, lang.t('SeaExport.CustomerShutOutDate')],
  [OCR_FIELD_CUSTOMERFILECUTOFF.code, lang.t('SeaExport.CustomerClosingTime')],
  [OCR_FIELD_CSR.code, lang.t('CargoMsg.Cargo_CustomerService')],
  [OCR_FIELD_DC.code, lang.t('CargoMsg.Cargo_Documents')],
  [OCR_FIELD_SC_NO.code, lang.t('SeaExport.ContractNo')],
  [OCR_FIELD_INSIDEQUANTITY.code, lang.t('CargoMsg.Cargo_InsideQuantity')],
  [OCR_FIELD_INSIDEPACKING.code, lang.t('CargoMsg.Cargo_InsidePacking')],
  [OCR_FIELD_CHARGEWEIGHT.code, new Map([[FIELD_DEFAULT_NAME, lang.t('SeaExport.ChargedWeightRT')], [SENDING_4.code, lang.t('CargoMsg.Cargo_ChargedWeight')], [SENDING_5.code, lang.t('CargoMsg.Cargo_ChargedWeight')]])],
  [OCR_FIELD_CARGOCHINESENAME.code, lang.t('CargoMsg.Cargo_ChineseCargoName')],
  [OCR_FIELD_USERDEFINEDFIELD1.code, lang.t('CargoMsg.Cargo_CustomizedField1')],
  [OCR_FIELD_USERDEFINEDFIELD2.code, lang.t('CargoMsg.Cargo_CustomizedField2')],
  [OCR_FIELD_USERDEFINEDFIELD3.code, lang.t('CargoMsg.Cargo_CustomizedField3')],
  [OCR_FIELD_USERDEFINEDFIELD4.code, lang.t('CargoMsg.Cargo_CustomizedField4')],
  [OCR_FIELD_SALES.code, lang.t('SeaExport.Sales')],
  [OCR_FIELD_OP.code, lang.t('SeaExport.Operation')],
  [OCR_FIELD_CARGO_TYPE.code, lang.t('SeaExport.CargoType')],
  [OCR_FIELD_SALES_OFFICE.code, lang.t('SeaExport.SalesCompany')],
  [OCR_FIELD_SALES_DEPARTMENT.code, lang.t('SeaExport.SalesDepartment')],
  [OCR_FIELD_OP_OFFICE.code, lang.t('SeaExport.OperationCompany')],
  [OCR_FIELD_OP_DEPARTMENT.code, lang.t('SeaExport.OperationDepartment')],
  [OCR_FIELD_BOOKING_AGENT.code, lang.t('SeaExport.BookingAgent')],
  [OCR_FIELD_VESSEL_CODE.code, lang.t('SeaExport.BookingShipCallSign')],
  [OCR_FIELD_IF_AUTO_BOOKING.code, lang.t('CargoMsg.Cargo_IfAutoBooking')],
  [OCR_FIELD_NOVCC.code, 'NOVCC'],
  [OCR_FIELD_TLI_NO.code, 'TLI NO'],
  [OCR_FIELD_CARGO_AMOUNT.code, lang.t('CargoMsg.Cargo_CargoAmount')],
  [OCR_FIELD_CARGO_CURRENCY.code, lang.t('CargoMsg.Cargo_CargoCurrency')],
  [OCR_FIELD_CUSTOMER_RESERVE_VOYAGE.code, lang.t('CargoMsg.Cargo_CustomerReserveVoyage')],

  [USER_DEFINED_ROLE_ID_1.code, lang.t('CargoMsg.Cargo_userDefinedRole1')],
  [USER_DEFINED_ROLE_ID_2.code, lang.t('CargoMsg.Cargo_userDefinedRole2')],
  [OVERSEA_OP.code, lang.t('CargoMsg.Cargo_CustomerServiceOverSea')],
  [PLANNER.code, lang.t('CargoMsg.Cargo_AirlinePerson')],
  [DESTINATION_AGENT.code, lang.t('CargoMsg.Cargo_DestinationAgent')],
  [EXCHANGE_AGENT.code, lang.t('SeaExport.BillExchangeAgent')],
  [CARRIER_AGENT_ID.code, lang.t('SeaExport.CarrierAgent')],
  [SUPPLIER_ID.code, lang.t('SeaExport.WarehouseSupplier')],
  [WAREHOUSE.code, lang.t('SeaExport.WareHouseName')],
  [CUSTOMS_BROKER.code, lang.t('CargoMsg.Cargo_CustomsBroker')],
  [SITE_OP.code, lang.t('SeaExport.FieldOperation')],
  [CARRIER_VOYAGE.code, lang.t('SeaExport.CarrierVoyage')],
  [MBL_NO.code, new Map([[FIELD_DEFAULT_NAME, lang.t('SeaExport.MblNo2')], [SENDING_5.code, 'MAWB']])],
  [SO_NO.code, lang.t('SeaExport.SoNo1')],
  [ROUTE_CODE.code, lang.t('CargoMsg.Cargo_AirlineCode')],
  [BUSINESS_MARK.code, lang.t('CargoMsg.Cargo_BusinessMark')],

  [OCR_FIELD_BILL_NO.code, lang.t('CargoMsg.Cargo_BLNo')],
  [OCR_FIELD_BL_NUMBER.code, lang.t('CargoMsg.Cargo_NumberOfOriginalCopies')],
  [OCR_FIELD_PAYMENT_PLACE_BL.code, lang.t('SeaExport.PlaceOfPayment')],
  [OCR_FIELD_TD_SIGN_PLACE_BL.code, lang.t('SeaExport.PlaceOfIssue')],
  [OCR_FIELD_TD_SIGN_DATE_BL.code, lang.t('SeaExport.DateOfIssue')],
  [OCR_FIELD_HS_CODE.code, lang.t('SeaExport.HsCode')],
  [OCR_FIELD_DISPATCHING_PLACE.code, lang.t('SeaExport.PlaceOfReceipt')],
  [OCR_FIELD_LOADING_PORT.code, lang.t('SeaExport.PortOfLoadingAI')],
  [OCR_FIELD_DISCHARGING_PORT.code, lang.t('SeaExport.dischargingPort')],
  [OCR_FIELD_DESTINATION_PORT.code, lang.t('SeaExport.PlaceOfDelivery')],
  [OCR_FIELD_INSIDE_QUANTITY.code, lang.t('SeaExport.Pieces')],
  [OCR_FIELD_INSIDE_PACKING.code, lang.t('SeaExport.PiecesType2')],
  [OCR_FIELD_CONTAINER_DATA.code, lang.t('SeaExport.ContainerInfo')],
  [OCR_FIELD_TD_CUBAGE.code, lang.t('CargoMsg.Cargo_Cubage')],
  [OCR_FIELD_TD_QUANTITY.code, lang.t('CargoMsg.Cargo_ItemsNBR')],
  [OCR_FIELD_TD_WEIGHT.code, lang.t('SeaExport.Weight')]
])

// 外部费用确认同步状态
export const WAITING_CONFIRMATION_OUT = new CommonState(0, '待确认', 'waiting for confirmation')
export const HAVE_CONFIRMED_OUT = new CommonState(1, '已确认', 'have confirmed')
export const HAVE_REFUSED_OUT = new CommonState(2, '已拒绝', 'have refused')
export const CHARGE_CONFIRM_SYNC_STATUS_OUT = new Set([WAITING_CONFIRMATION_OUT, HAVE_CONFIRMED_OUT, HAVE_REFUSED_OUT])
// 费用确认同步来源
export const CHARGE_PUSH_SOURCE_XHQ = new CommonState(1, '信号旗', 'export to import')
export const CHARGE_PUSH_SOURCE_JY = new CommonState(2, '精谕', 'entrust')
export const CHARGE_PUSH_SOURCE = new Set([CHARGE_PUSH_SOURCE_XHQ, CHARGE_PUSH_SOURCE_JY])

/* -----sop工作任务看板 start------*/
// 岗位
export const POSITIONS_SALES = new CommonState('sales', '销售', 'Sales')
export const POSITIONS_OP = new CommonState('op', '操作', 'OP')
export const POSITIONS_CSR = new CommonState('csr', '客服', 'CS')
export const POSITIONS_OVERSEAOP = new CommonState('overseaOp', '海外客服', 'OverSea CS')
export const POSITIONS_DC = new CommonState('doc', '单证', 'DOC')
export const POSITIONS_PLANNER = new CommonState('planner', '航线负责人', 'Lane PIC') // 对应三个shape seaLine/airline/railwayLine
export const POSITIONS_CARGOSALES = new CommonState('salesOfGoods', '揽货销售', 'Sales of goods')
export const POSITIONS_SITEOP = new CommonState('siteOp', '现场操作', 'AirportSite')
export const POSITIONS_USERDEFINEDROLEID1 = new CommonState('userDefinedRole1', '自定义岗位1', 'Custom position 1')
export const POSITIONS_USERDEFINEDROLEID2 = new CommonState('userDefinedRole2', '自定义岗位2', 'Custom position 2')
export const POSITIONS_USERDEFINEDROLEID3 = new CommonState('userDefinedRole3', '自定义岗位3', 'Custom position 3')
export const POSITIONS_USERDEFINEDROLEID4 = new CommonState('userDefinedRole4', '自定义岗位4', 'Custom position 4')
export const POSITIONS_USERDEFINEDROLEID5 = new CommonState('userDefinedRole5', '自定义岗位5', 'Custom position 5')
export const POSITIONS_USERDEFINEDROLEID6 = new CommonState('userDefinedRole6', '自定义岗位6', 'Custom position 6')
export const POSITIONS_USERDEFINEDROLEID7 = new CommonState('userDefinedRole7', '自定义岗位7', 'Custom position 7')
// 人员
export const POSITIONS_PERSONNEL = new CommonState('personnel', '指定人员', 'Designated personnel')

// 业务类型
export const BUSINESS_TYPES = [
  { label: lang.t('Sop.SeaExport'), name: 'SE', popVisible: false },
  { label: lang.t('Sop.SeaImport'), name: 'SI', popVisible: false },
  { label: lang.t('Sop.AirExport'), name: 'AE', popVisible: false },
  { label: lang.t('Sop.AirImport'), name: 'AI', popVisible: false },
  { label: lang.t('Sop.RailwayExport'), name: 'RE', popVisible: false },
  { label: lang.t('Sop.RailwayImport'), name: 'RI', popVisible: false },
  { label: lang.t('Sop.IntegratedJob'), name: 'IE', popVisible: false }
]

// 优先级级别
export const PRIORITY_NONE = new CommonState(0, '无优先级（前置节点达标）', 'No Priority (Front Node Meets Standards)')
export const PRIORITY_LOW = new CommonState(1, '低', 'Low')
export const PRIORITY_MEDIUM = new CommonState(2, '中', 'Medium')
export const PRIORITY_HIGH = new CommonState(3, '高', 'High')

export const PRIORITIES = [PRIORITY_LOW, PRIORITY_MEDIUM, PRIORITY_HIGH]
/* -----sop工作任务看板 end------*/

// 中邮运输方式
export const WHOLE_COURSE = new CommonState(1, '全程', 'The entire journey')
export const DOMESTIC = new CommonState(2, '分段', 'Segmented')
export const FULL_OR_INSIDE = new Set([WHOLE_COURSE, DOMESTIC])

// 字段展示 1-业务模块 2-付款申请模块
export const FIELD_DISPLAY_BUSINESS_MODULE = new CommonState(1, '业务模块', 'business module')
export const FIELD_DISPLAY_PAYMENT_REQUEST_MODULE = new CommonState(2, '付款申请模块', 'payment request module')

export const FIELD_DISPLAY_MODULES = [
  FIELD_DISPLAY_BUSINESS_MODULE,
  FIELD_DISPLAY_PAYMENT_REQUEST_MODULE
]

// 控件选择 1-文本框 2-下拉框
export const WIDGET_TYPE_TEXTBOX = new CommonState(1, '文本框', 'textbox')
export const WIDGET_TYPE_DROPDOWN = new CommonState(2, '下拉框', 'dropdown')

export const WIDGET_TYPES = [
  WIDGET_TYPE_TEXTBOX,
  WIDGET_TYPE_DROPDOWN
]

// 自定义字段显示
export const CUSTOM_FIELD_1 = new CommonState(1, '自定义字段1', 'Custom Field 1')
export const CUSTOM_FIELD_2 = new CommonState(2, '自定义字段2', 'Custom Field 2')
export const CUSTOM_FIELD_3 = new CommonState(3, '自定义字段3', 'Custom Field 3')
export const CUSTOM_FIELD_4 = new CommonState(4, '自定义字段4', 'Custom Field 4')
export const CUSTOM_POSITION_1 = new CommonState(5, '自定义岗位1', 'Custom Position 1')
export const CUSTOM_POSITION_2 = new CommonState(6, '自定义岗位2', 'Custom Position 2')
export const CUSTOM_FIELD_5 = new CommonState(7, '自定义字段5', 'Custom Field 5')
export const CUSTOM_FIELD_6 = new CommonState(8, '自定义字段6', 'Custom Field 6')

export const CUSTOM_FIELDS = new Set([CUSTOM_FIELD_1, CUSTOM_FIELD_2, CUSTOM_FIELD_3, CUSTOM_FIELD_4, CUSTOM_FIELD_5, CUSTOM_FIELD_6, CUSTOM_POSITION_1, CUSTOM_POSITION_2])

// 业务模块
export const CUSTOM_FIELDS_BUSINESS = [CUSTOM_FIELD_1, CUSTOM_FIELD_2, CUSTOM_FIELD_3, CUSTOM_FIELD_4, CUSTOM_POSITION_1, CUSTOM_POSITION_2]

// 付款申请模块
export const CUSTOM_FIELDS_PAYMENT_REQUEST = [CUSTOM_FIELD_1, CUSTOM_FIELD_2, CUSTOM_FIELD_3, CUSTOM_FIELD_4, CUSTOM_FIELD_5, CUSTOM_FIELD_6]

// 批量【打印模板】操作指令 支持的模板类
export const CUSTOM_FIELDS_PAYMENT_REQUEST_MAP = new Map([
  [CUSTOM_FIELD_1.code, 'userDefinedField1'],
  [CUSTOM_FIELD_2.code, 'userDefinedField2'],
  [CUSTOM_FIELD_3.code, 'userDefinedField3'],
  [CUSTOM_FIELD_4.code, 'userDefinedField4'],
  [CUSTOM_FIELD_5.code, 'userDefinedField5'],
  [CUSTOM_FIELD_6.code, 'userDefinedField6']
])

// 订舱代理级别
export const ACTUAL_CARRIER_OR_SALES_GENERAL_AGENT = new CommonState(1, '实际承运人/销售总代理', 'Actual carrier/Sales general agent')
export const FIRST_GENERATION = new CommonState(2, '一代', 'First generation')
export const NON_FIRST_GENERATION = new CommonState(3, '非一代', 'Non first generation')
export const BOOKING_AGENT_LEVEL = new Set([ACTUAL_CARRIER_OR_SALES_GENERAL_AGENT, FIRST_GENERATION, NON_FIRST_GENERATION])

// 名单同步状态(中邮)
export const ADVANCEPAYMENT_STATE_DEFAULT = new CommonState(0, '未同步名单', 'Not Synchronized')
export const ADVANCEPAYMENT_STATE_SENT = new CommonState(1, '已发送名单', 'Has Been Sent')
export const ADVANCEPAYMENT_STATE_SYNCED = new CommonState(2, '名单已同步', 'Synchronized')
export const ADVANCEPAYMENT_STATES = new Set([ADVANCEPAYMENT_STATE_DEFAULT, ADVANCEPAYMENT_STATE_SENT, ADVANCEPAYMENT_STATE_SYNCED])

// 余额变动类型(中邮)
export const ADVANCEPAYMENT_CHANGETYPE_DEDUCTIONS = new CommonState(1, '业务扣减', 'Business Deductions')
export const ADVANCEPAYMENT_CHANGETYPE_RECHARGE = new CommonState(2, '充值', 'Recharge')
export const ADVANCEPAYMENT_CHANGETYPE_INITIALIZE = new CommonState(3, '初始化余额', 'Initialize')
export const ADVANCEPAYMENT_CHANGETYPES = new Set([ADVANCEPAYMENT_CHANGETYPE_DEDUCTIONS, ADVANCEPAYMENT_CHANGETYPE_RECHARGE, ADVANCEPAYMENT_CHANGETYPE_INITIALIZE])
// 客户结算方式(中邮)
export const ADVANCEPAYMENT_CUSTSETTLEMENT_0 = new CommonState('0', '现结', 'Cash settlement')
export const ADVANCEPAYMENT_CUSTSETTLEMENT_1 = new CommonState('1', '记欠', 'Remembering debts')
export const ADVANCEPAYMENT_CUSTSETTLEMENT_2 = new CommonState('2', '预收', 'Collect in advance')
export const ADVANCEPAYMENT_CUSTSETTLEMENT_4 = new CommonState('4', '散户', 'Retail investors')
export const ADVANCEPAYMENT_CUSTSETTLEMENTS = new Set([ADVANCEPAYMENT_CUSTSETTLEMENT_0, ADVANCEPAYMENT_CUSTSETTLEMENT_1, ADVANCEPAYMENT_CUSTSETTLEMENT_2, ADVANCEPAYMENT_CUSTSETTLEMENT_4])

// 业务类型
export const ADVANCEPAYMENT_ORDERTYPE_10 = new CommonState('10', '预订预售', 'Booking pre-sales')
export const ADVANCEPAYMENT_ORDERTYPE_30 = new CommonState('30', '寄递储值卡', 'Sending stored value cards')
export const ADVANCEPAYMENT_ORDERTYPE_40 = new CommonState('40', '寄递代金券', 'Delivery voucher')
export const ADVANCEPAYMENT_ORDERTYPE_99 = new CommonState('99', '协议客户预存款', 'Agreed customer pre deposit')
export const ADVANCEPAYMENT_ORDERTYPES = new Set([ADVANCEPAYMENT_ORDERTYPE_10, ADVANCEPAYMENT_ORDERTYPE_30, ADVANCEPAYMENT_ORDERTYPE_40, ADVANCEPAYMENT_ORDERTYPE_99])

export const CONTRACT_RULE_COLUMN_OP_OFFICE = new CommonState('job.opOffice', '操作分公司', 'Operating branch')
export const CONTRACT_RULE_COLUMN_LOB = new CommonState('job.lob', '业务类型', 'Business Type')
export const CONTRACT_RULE_COLUMN_CUSTOM_JOB_TYPE = new CommonState('job.customJobType', '自定义业务类型', 'Customized Job Type')

// 合同规则-条件项-下拉
export const CONTRACT_RULE_COLUMNS = [CONTRACT_RULE_COLUMN_OP_OFFICE, CONTRACT_RULE_COLUMN_LOB, CONTRACT_RULE_COLUMN_CUSTOM_JOB_TYPE]

// 合同规则-条件规则-下拉
export const CONTRACT_RULE_OPERATORS = [OPERATOR_EQUAL, OPERATOR_UNEQUAL]

// 合同规则-条件值-下拉【业务类型】
export const CONTRACT_RULE_VALUES_LOBS = new Set([SE, SI, AE, AI, RE, RI, FBA_SE, FBA_AE, IE])

export const RULE_CONDITIONS_ALL = new CommonState(1, '全部满足', 'All satisfied')
export const RULE_CONDITIONS_ONE = new CommonState(2, '满足其一', 'Satisfy one of them')

// 合同规则-应用条件-下拉
export const RULE_CONDITIONS = new Set([
  RULE_CONDITIONS_ALL, RULE_CONDITIONS_ONE
])

/**
 * 海关状态
 * @type {CommonState}
 */
export const CUSTOMS_SUCCESS = new CommonState('7', '申报成功', 'Declaration Successful')
export const CUSTOMS_VISA = new CommonState('a', '签证', 'Visa')
export const CUSTOMS_ABNORMAL_HANDLING = new CommonState('A', '海关放行前删除或者异常处理', 'Pre-clearance deletion or abnormal handling')
export const CUSTOMS_GUARANTEED_RELEASE = new CommonState('B', '担保放行', 'Guaranteed release')
export const CUSTOMS_EXPORT_INSPECTION_NOTICE = new CommonState('C', '出口查验通知', 'Export inspection notice')
export const CUSTOMS_DELETE_ORDER = new CommonState('D', '海关删单', 'Customs delete order')
export const CUSTOMS_RETURN_ORDER = new CommonState('E', '海关退单/不受理回执', 'Customs return order / Not accepted receipt')
export const CUSTOMS_RELEASE_DOCUMENTS = new CommonState('F', '放行交单', 'Release documents')
export const CUSTOMS_APPROVED = new CommonState('G', '报关单已审结', 'Customs approved')
export const CUSTOMS_SUSPENDED = new CommonState('H', '海关挂起，需手工申报', 'Customs suspended, manual declaration required')
export const CUSTOMS_PAPERLESS_RELEASE = new CommonState('I', '海关无纸放行通知', 'Customs paperless release notification')
export const CUSTOMS_PAPERLESS_CLEARANCE_RECEIPT = new CommonState('J', '通关无纸化审结回执', 'Paperless clearance receipt')
export const CUSTOMS_PAPERLESS_GUARANTEED_CLEARANCE = new CommonState('K', '通关无纸化担保放行', 'Paperless guaranteed clearance')
export const CUSTOMS_RECEIVED = new CommonState('L', '海关已接收', 'Customs received')
export const CUSTOMS_REEXAMINE_CUSTOMS_DECLARATION = new CommonState('M', '报关单重审', 'Re-examine customs declaration')
export const CUSTOMS_REUPLOAD_DOCUMENTS = new CommonState('N', '重传文件', 'Reupload documents')
export const CUSTOMS_PERMIT_ENTRY = new CommonState('O', '准予进卡', 'Permit entry')
export const CUSTOMS_CLEARED = new CommonState('P', '海关已放行', 'Customs cleared')
export const CUSTOMS_COMPLETED = new CommonState('R', '已结关', 'Customs completed')
export const CUSTOMS_INSPECT = new CommonState('S', '施检', 'Inspect')
export const CUSTOMS_PAY_TAXES_FEES = new CommonState('T', '需交税费', 'Pay taxes/fees')
export const CUSTOMS_PAPERLESS_CLEARANCE_NOTICE = new CommonState('W', '海关无纸验放通知', 'Customs paperless clearance notice')
export const CUSTOMS_PERMIT_ENTRY_PORT = new CommonState('X', '海关准予进港回执', 'Customs permit entry port')
export const CUSTOMS_DECLARATION_FAILED = new CommonState('Y', '申报失败', 'Declaration failed')
export const CUSTOMS_RETURN_FOR_MODIFICATIONS = new CommonState('Z', '退回修改', 'Return for modifications')

export const CUSTOMS_STATUS = [CUSTOMS_SUCCESS, CUSTOMS_VISA, CUSTOMS_ABNORMAL_HANDLING, CUSTOMS_GUARANTEED_RELEASE, CUSTOMS_EXPORT_INSPECTION_NOTICE, CUSTOMS_DELETE_ORDER, CUSTOMS_RETURN_ORDER,
  CUSTOMS_RELEASE_DOCUMENTS, CUSTOMS_APPROVED, CUSTOMS_SUSPENDED, CUSTOMS_PAPERLESS_RELEASE, CUSTOMS_PAPERLESS_CLEARANCE_RECEIPT, CUSTOMS_PAPERLESS_GUARANTEED_CLEARANCE, CUSTOMS_RECEIVED,
  CUSTOMS_REEXAMINE_CUSTOMS_DECLARATION, CUSTOMS_REUPLOAD_DOCUMENTS, CUSTOMS_PERMIT_ENTRY, CUSTOMS_CLEARED, CUSTOMS_COMPLETED, CUSTOMS_INSPECT, CUSTOMS_PAY_TAXES_FEES, CUSTOMS_PAPERLESS_CLEARANCE_NOTICE,
  CUSTOMS_PERMIT_ENTRY_PORT, CUSTOMS_DECLARATION_FAILED, CUSTOMS_RETURN_FOR_MODIFICATIONS]

// 劲升箱属
export const JS_AFR_CONTAINER_OWNER_1 = new CommonState('1', 'Shipper supplied', 'Shipper supplied')
export const JS_AFR_CONTAINER_OWNER_2 = new CommonState('2', 'Carrier supplied', 'Carrier supplied')
export const JS_AFR_CONTAINER_OWNER_3 = new CommonState('3', 'Consolidator supplied', 'Consolidator supplied')
export const JS_AFR_CONTAINER_OWNER_4 = new CommonState('4', 'Deconsolidator supplied', 'Deconsolidator supplied')
export const JS_AFR_CONTAINER_OWNER_5 = new CommonState('5', 'Third party supplied', 'Third party supplied')
export const JS_AFR_CONTAINER_OWNER = new Set([JS_AFR_CONTAINER_OWNER_1, JS_AFR_CONTAINER_OWNER_2, JS_AFR_CONTAINER_OWNER_3, JS_AFR_CONTAINER_OWNER_4, JS_AFR_CONTAINER_OWNER_5])

// 箱型箱属
export const JS_AFR_2B = new CommonState('2B', '20\' CLOSED TOP', '20\' CLOSED TOP')
export const JS_AFR_4B = new CommonState('4B', '40\' CLOSED TOP', '40\' CLOSED TOP')
export const JS_AFR_20 = new CommonState('20', '20\' OPEN TOP', '20\' OPEN TOP')
export const JS_AFR_40 = new CommonState('40', '40\' OPEN TOP', '40\' OPEN TOP')
export const JS_AFR_CN = new CommonState('CN', 'CONTAINER', 'CONTAINER')
export const JS_AFR_CZ = new CommonState('2', 'REFRIGERATED CONTAINER', 'REFRIGERATED CONTAINER')
export const JS_AFR_CONTAINER_SIZE = new Set([JS_AFR_2B, JS_AFR_4B, JS_AFR_20, JS_AFR_40, JS_AFR_CN, JS_AFR_CZ])

// 劲升箱种
export const JS_AFR_GP = new CommonState('GP', 'Dry container', 'Dry container')
export const JS_AFR_RT = new CommonState('RT', 'Reefer container', 'Reefer container')
export const JS_AFR_UT = new CommonState('UT', 'Open top container', 'Open top container')
export const JS_AFR_PF = new CommonState('PF', 'Flat rack container', 'Flat rack container')
export const JS_AFR_PL = new CommonState('PL', 'Platform container', 'Platform container')
export const JS_AFR_TN = new CommonState('TN', 'Tank container', 'Tank container')
export const JS_AFR_SN = new CommonState('SN', 'Others', 'Others')
export const JS_AFR_CONTAINER_TYPE = new Set([JS_AFR_GP, JS_AFR_RT, JS_AFR_UT, JS_AFR_PF, JS_AFR_PL, JS_AFR_TN, JS_AFR_SN])

// 劲升箱高度
export const JS_AFR_HEIGHT_0 = new CommonState('0', '8\'', '8\'')
export const JS_AFR_HEIGHT_2 = new CommonState('2', '8\'6\'\'', '8\'6\'\'')
export const JS_AFR_HEIGHT_4 = new CommonState('4', '9\'', '9\'')
export const JS_AFR_HEIGHT_5 = new CommonState('5', '9\'6\'\'', '9\'6\'\'')
export const JS_AFR_HEIGHT_6 = new CommonState('6', '> 9\'6\'', '> 9\'6\'')
export const JS_AFR_HEIGHT_8 = new CommonState('8', '4\'3\'\'', '4\'3\'\'')
export const JS_AFR_HEIGHT_9 = new CommonState('9', '≦4\'', '≦4\'')
export const JS_AFR_CONTAINER_HEIGHT = new Set([JS_AFR_HEIGHT_0, JS_AFR_HEIGHT_2, JS_AFR_HEIGHT_4, JS_AFR_HEIGHT_5, JS_AFR_HEIGHT_6, JS_AFR_HEIGHT_8, JS_AFR_HEIGHT_9])

// 劲升AFR删除原因
export const JS_AFR_DELETE_1 = new CommonState('1', 'Cancelation of loading', 'Cancelation of loading')
export const JS_AFR_DELETE_3 = new CommonState('3', 'Change of B/L number', 'Change of B/L number')
export const JS_AFR_DELETE_4 = new CommonState('4', 'Misregistration', 'Misregistration')
export const JS_AFR_DELETE_5 = new CommonState('5', 'Other reasons', 'Other reasons')
export const JS_AFR_DELETE = [JS_AFR_DELETE_1, JS_AFR_DELETE_3, JS_AFR_DELETE_4, JS_AFR_DELETE_5]

// 客户
export const MAIL_ACCOUNT_1 = new CommonState(1, '客户', 'Customer')
// 船司
export const MAIL_ACCOUNT_2 = new CommonState(2, '船司', 'Shipper')
// 订舱代理
export const MAIL_ACCOUNT_3 = new CommonState(3, '订舱代理', 'Booking agent')
// 本地代理
export const MAIL_ACCOUNT_4 = new CommonState(4, '本地代理', 'Local agent')
// 起/目的港代理
export const MAIL_ACCOUNT_5 = new CommonState(5, '起/目的港代理', 'Origin/destination port agent')
// 指定货代理
export const MAIL_ACCOUNT_6 = new CommonState(6, '指定货代理', 'Designated goods agent')
// 车队
export const MAIL_ACCOUNT_7 = new CommonState(7, '车队', 'Fleet')
// 仓库
export const MAIL_ACCOUNT_8 = new CommonState(8, '仓库', 'Warehouse')
// 发货人
export const MAIL_ACCOUNT_10 = new CommonState(10, '发货人', 'Shipper')
// 收货人
export const MAIL_ACCOUNT_11 = new CommonState(11, '收货人', 'Consignee')
// 通知人
export const MAIL_ACCOUNT_12 = new CommonState(12, '通知人', 'Notify')
export const MAIL_ACCOUNT_TYPE = new Set([MAIL_ACCOUNT_1, MAIL_ACCOUNT_2, MAIL_ACCOUNT_3, MAIL_ACCOUNT_4, MAIL_ACCOUNT_5, MAIL_ACCOUNT_6, MAIL_ACCOUNT_7, MAIL_ACCOUNT_8, MAIL_ACCOUNT_10, MAIL_ACCOUNT_11, MAIL_ACCOUNT_12])

// 一飞ENS提单类型
export const EF_ENS_BL_TYPE_1 = new CommonState('1', 'House level filing', 'House level filing')
export const EF_ENS_BL_TYPE_2 = new CommonState('2', 'Sub-house level filing', 'Sub-house level filing')
export const EF_ENS_BL_TYPE = [EF_ENS_BL_TYPE_1, EF_ENS_BL_TYPE_2]

export const EF_ENS_BL_TYPE_1_AI = new CommonState('1', 'House level', 'House level')
export const EF_ENS_BL_TYPE_2_AI = new CommonState('2', 'Sub-house level', 'Sub-house level')
export const EF_ENS_BL_TYPE_AI = [EF_ENS_BL_TYPE_1_AI, EF_ENS_BL_TYPE_2_AI]

// 一飞ENS 箱属
export const EF_ENS_CONTAINER_OWNER_1 = new CommonState('1', 'Shipper supplied', 'Shipper supplied')
export const EF_ENS_CONTAINER_OWNER_2 = new CommonState('2', 'Carrier supplied', 'Carrier supplied')
export const EF_ENS_CONTAINER_OWNER = new Set([EF_ENS_CONTAINER_OWNER_1, EF_ENS_CONTAINER_OWNER_2])

export const EF_ENS_CONTAINER_OWNER_1_AI = new CommonState('1', 'Carrier Supplied  |  COC 船东箱', 'Carrier Supplied  |  COC')
export const EF_ENS_CONTAINER_OWNER_2_AI = new CommonState('2', 'Shipper Supplied  |  SOC 自备箱', 'Shipper Supplied  |  SOC')
export const EF_ENS_CONTAINER_OWNER_AI = new Set([EF_ENS_CONTAINER_OWNER_1_AI, EF_ENS_CONTAINER_OWNER_2_AI])

// 一飞ENS 箱型
export const EF_ENS_CONTAINER_SIZE_22G0 = new CommonState('22G0', '20 Standard Dry', '20 Standard Dry')
export const EF_ENS_CONTAINER_SIZE_22H0 = new CommonState('22H0', '20 Insulated', '20 Insulated')
export const EF_ENS_CONTAINER_SIZE_22P1 = new CommonState('22P1', '20 Flat Rack', '20 Flat Rack')
export const EF_ENS_CONTAINER_SIZE_22P3 = new CommonState('22P3', '20 Platform (collapsible)', '20 Platform (collapsible)')
export const EF_ENS_CONTAINER_SIZE_22R1 = new CommonState('22R1', '20 Reefer', '20 Reefer')
export const EF_ENS_CONTAINER_SIZE_22R9 = new CommonState('22R9', '20 Reefer (non food)', '20 Reefer (non food)')
export const EF_ENS_CONTAINER_SIZE_22T0 = new CommonState('22T0', '20 Tank (non-dangerous)', '20 Tank (non-dangerous)')
export const EF_ENS_CONTAINER_SIZE_22T5 = new CommonState('22T5', '20 Tank 8.5\' (dangerous - 4bar)', '20 Tank 8.5\' (dangerous - 4bar)')
export const EF_ENS_CONTAINER_SIZE_22T6 = new CommonState('22T6', '20 Tank (dangerous - 6 bar)', '20 Tank (dangerous - 6 bar)')
export const EF_ENS_CONTAINER_SIZE_22U0 = new CommonState('22U0', '20 Open Top', '20 Open Top')
export const EF_ENS_CONTAINER_SIZE_22U6 = new CommonState('22U6', '20 Hard Top', '20 Hard Top')
export const EF_ENS_CONTAINER_SIZE_22V0 = new CommonState('22V0', '20 Ventilated', '20 Ventilated')
export const EF_ENS_CONTAINER_SIZE_25G0 = new CommonState('25G0', '20 High Cube', '20 High Cube')
export const EF_ENS_CONTAINER_SIZE_25R1 = new CommonState('25R1', '20 Reefer High Cube', '20 Reefer High Cube')
export const EF_ENS_CONTAINER_SIZE_29P0 = new CommonState('29P0', '20 Platform', '20 Platform')
export const EF_ENS_CONTAINER_SIZE_42G0 = new CommonState('42G0', '40 Standard Dry', '40 Standard Dry')
export const EF_ENS_CONTAINER_SIZE_42H0 = new CommonState('42H0', '40 Insulated', '40 Insulated')
export const EF_ENS_CONTAINER_SIZE_42P1 = new CommonState('42P1', '40 Flat Rack', '40 Flat Rack')
export const EF_ENS_CONTAINER_SIZE_42P3 = new CommonState('42P3', '40 Platform (collapsible)', '40 Platform (collapsible)')
export const EF_ENS_CONTAINER_SIZE_42R1 = new CommonState('42R1', '40 Reefer', '40 Reefer')
export const EF_ENS_CONTAINER_SIZE_42R9 = new CommonState('42R9', '40 Reefer (non food)', '40 Reefer (non food)')
export const EF_ENS_CONTAINER_SIZE_42T0 = new CommonState('42T0', '40 Tank', '40 Tank')
export const EF_ENS_CONTAINER_SIZE_42U0 = new CommonState('42U0', '40 Open Top', '40 Open Top')
export const EF_ENS_CONTAINER_SIZE_42U6 = new CommonState('42U6', '40 Hard Top', '40 Hard Top')
export const EF_ENS_CONTAINER_SIZE_42V0 = new CommonState('42V0', '40 Ventilated', '40 Ventilated')
export const EF_ENS_CONTAINER_SIZE_45G0 = new CommonState('45G0', '40 High Cube', '40 High Cube')
export const EF_ENS_CONTAINER_SIZE_45P3 = new CommonState('45P3', '40 Platform High Cube', '40 Platform High Cube')
export const EF_ENS_CONTAINER_SIZE_45R1 = new CommonState('45R1', '40 Reefer High Cube', '40 Reefer High Cube')
export const EF_ENS_CONTAINER_SIZE_45R9 = new CommonState('45R9', '40 Reefer High Cube (non food)', '40 Reefer High Cube (non food)')
export const EF_ENS_CONTAINER_SIZE_45U6 = new CommonState('45U6', '40 High Cube Hard Top', '40 High Cube Hard Top')
export const EF_ENS_CONTAINER_SIZE_49P0 = new CommonState('49P0', '40 Platform', '40 Platform')
export const EF_ENS_CONTAINER_SIZE_L5G0 = new CommonState('L5G0', '45 High Cube', '45 High Cube')
export const EF_ENS_CONTAINER_SIZE_L5R1 = new CommonState('L5R1', '45 Reefer High Cube', '45 Reefer High Cube')
export const EF_ENS_CONTAINER_SIZE_M2G0 = new CommonState('M2G0', '48 Ft', '48 Ft')
export const EF_ENS_CONTAINER_SIZE_P2G0 = new CommonState('P2G0', '53 Ft', '53 Ft')
export const EF_ENS_CONTAINER_SIZE_P5G0 = new CommonState('P5G0', '53 Ft HQ', '53 Ft HQ')
export const EF_ENS_CONTAINER_SIZE = new Set([EF_ENS_CONTAINER_SIZE_22G0, EF_ENS_CONTAINER_SIZE_22H0, EF_ENS_CONTAINER_SIZE_22P1, EF_ENS_CONTAINER_SIZE_22P3, EF_ENS_CONTAINER_SIZE_22R1, EF_ENS_CONTAINER_SIZE_22R9, EF_ENS_CONTAINER_SIZE_22T0, EF_ENS_CONTAINER_SIZE_22T5,
  EF_ENS_CONTAINER_SIZE_22T6, EF_ENS_CONTAINER_SIZE_22U0, EF_ENS_CONTAINER_SIZE_22U6, EF_ENS_CONTAINER_SIZE_22V0, EF_ENS_CONTAINER_SIZE_25G0, EF_ENS_CONTAINER_SIZE_25R1, EF_ENS_CONTAINER_SIZE_29P0, EF_ENS_CONTAINER_SIZE_42G0, EF_ENS_CONTAINER_SIZE_42H0, EF_ENS_CONTAINER_SIZE_42P1, EF_ENS_CONTAINER_SIZE_42P3, EF_ENS_CONTAINER_SIZE_42R1,
  EF_ENS_CONTAINER_SIZE_42R9, EF_ENS_CONTAINER_SIZE_42T0, EF_ENS_CONTAINER_SIZE_42U0, EF_ENS_CONTAINER_SIZE_42U6, EF_ENS_CONTAINER_SIZE_42V0, EF_ENS_CONTAINER_SIZE_45G0, EF_ENS_CONTAINER_SIZE_45P3, EF_ENS_CONTAINER_SIZE_45R1, EF_ENS_CONTAINER_SIZE_45R9, EF_ENS_CONTAINER_SIZE_45U6, EF_ENS_CONTAINER_SIZE_49P0, EF_ENS_CONTAINER_SIZE_L5G0,
  EF_ENS_CONTAINER_SIZE_L5R1, EF_ENS_CONTAINER_SIZE_M2G0, EF_ENS_CONTAINER_SIZE_P2G0, EF_ENS_CONTAINER_SIZE_P5G0])

export const EF_ENS_CONTAINER_MAP = new Map()
EF_ENS_CONTAINER_MAP.set('20GP', EF_ENS_CONTAINER_SIZE_22G0.code)
EF_ENS_CONTAINER_MAP.set('40GP', EF_ENS_CONTAINER_SIZE_42G0.code)
EF_ENS_CONTAINER_MAP.set('20OT', EF_ENS_CONTAINER_SIZE_22U0.code)
EF_ENS_CONTAINER_MAP.set('40OT', EF_ENS_CONTAINER_SIZE_42U0.code)
EF_ENS_CONTAINER_MAP.set('20HQ', EF_ENS_CONTAINER_SIZE_25G0.code)
EF_ENS_CONTAINER_MAP.set('40HQ', EF_ENS_CONTAINER_SIZE_45G0.code)
EF_ENS_CONTAINER_MAP.set('45HQ', EF_ENS_CONTAINER_SIZE_L5G0.code)
EF_ENS_CONTAINER_MAP.set('20HC', EF_ENS_CONTAINER_SIZE_25G0.code)
EF_ENS_CONTAINER_MAP.set('40HC', EF_ENS_CONTAINER_SIZE_45G0.code)
EF_ENS_CONTAINER_MAP.set('45HC', EF_ENS_CONTAINER_SIZE_L5G0.code)
EF_ENS_CONTAINER_MAP.set('20RF', EF_ENS_CONTAINER_SIZE_22R1.code)
EF_ENS_CONTAINER_MAP.set('40RF', EF_ENS_CONTAINER_SIZE_42R1.code)
EF_ENS_CONTAINER_MAP.set('20RFN', EF_ENS_CONTAINER_SIZE_22R9.code)
EF_ENS_CONTAINER_MAP.set('40RFN', EF_ENS_CONTAINER_SIZE_42R9.code)
EF_ENS_CONTAINER_MAP.set('20RFB', EF_ENS_CONTAINER_SIZE_22R9.code)
EF_ENS_CONTAINER_MAP.set('40RFB', EF_ENS_CONTAINER_SIZE_42R9.code)
EF_ENS_CONTAINER_MAP.set('20FR', EF_ENS_CONTAINER_SIZE_22P1.code)
EF_ENS_CONTAINER_MAP.set('40FR', EF_ENS_CONTAINER_SIZE_42P1.code)
EF_ENS_CONTAINER_MAP.set('20RI', EF_ENS_CONTAINER_SIZE_22H0.code)
EF_ENS_CONTAINER_MAP.set('40RI', EF_ENS_CONTAINER_SIZE_42H0.code)
EF_ENS_CONTAINER_MAP.set('20PC', EF_ENS_CONTAINER_SIZE_22P3.code)
EF_ENS_CONTAINER_MAP.set('40PC', EF_ENS_CONTAINER_SIZE_42P3.code)
EF_ENS_CONTAINER_MAP.set('20TK', EF_ENS_CONTAINER_SIZE_22T0.code)
EF_ENS_CONTAINER_MAP.set('20HT', EF_ENS_CONTAINER_SIZE_22U6.code)
EF_ENS_CONTAINER_MAP.set('40HT', EF_ENS_CONTAINER_SIZE_42U6.code)
EF_ENS_CONTAINER_MAP.set('20VT', EF_ENS_CONTAINER_SIZE_22V0.code)
EF_ENS_CONTAINER_MAP.set('40VT', EF_ENS_CONTAINER_SIZE_42V0.code)
EF_ENS_CONTAINER_MAP.set('20RFH', EF_ENS_CONTAINER_SIZE_25R1.code)
EF_ENS_CONTAINER_MAP.set('40RFH', EF_ENS_CONTAINER_SIZE_45R1.code)
EF_ENS_CONTAINER_MAP.set('45RFH', EF_ENS_CONTAINER_SIZE_L5R1.code)
EF_ENS_CONTAINER_MAP.set('20RHC', EF_ENS_CONTAINER_SIZE_25R1.code)
EF_ENS_CONTAINER_MAP.set('40RHC', EF_ENS_CONTAINER_SIZE_45R1.code)
EF_ENS_CONTAINER_MAP.set('45RHC', EF_ENS_CONTAINER_SIZE_L5R1.code)
EF_ENS_CONTAINER_MAP.set('20PL', EF_ENS_CONTAINER_SIZE_29P0.code)
EF_ENS_CONTAINER_MAP.set('40PL', EF_ENS_CONTAINER_SIZE_49P0.code)
EF_ENS_CONTAINER_MAP.set('20Tank', EF_ENS_CONTAINER_SIZE_22T0.code)
EF_ENS_CONTAINER_MAP.set('48FT', EF_ENS_CONTAINER_SIZE_M2G0.code)
EF_ENS_CONTAINER_MAP.set('53FT', EF_ENS_CONTAINER_SIZE_P2G0.code)

/**
 * AMS_ENS 付款方式
 */
export const AMS_ENS_PAYMENT_A = new CommonState('A', '现金', 'Payment in cash')
export const AMS_ENS_PAYMENT_B = new CommonState('B', '信用卡支付', 'Payment by credit card')
export const AMS_ENS_PAYMENT_C = new CommonState('C', '支票支付', 'Payment by cheque')
export const AMS_ENS_PAYMENT_D = new CommonState('D', '其他', 'Other(e.g.direct debit to cash account)')
export const AMS_ENS_PAYMENT_H = new CommonState('H', '电子转账', 'Electronic funds transfer')
export const AMS_ENS_PAYMENT_Y = new CommonState('Y', '承运人账户', 'Account holder with carrier')
export const AMS_ENS_PAYMENT_Z = new CommonState('Z', '非预付', 'Not pre-paid')
export const AMS_ENS_PAYMENT_WIRE = new CommonState('Wire', 'Wire', 'Wire')
export const AMS_ENS_PAYMENT_ACH = new CommonState('ACH', 'ACH', 'ACH')

// 将所有支付方式存储在一个数组中
export const AMS_ENS_PAYMENT_METHODS = [
  AMS_ENS_PAYMENT_A,
  AMS_ENS_PAYMENT_B,
  AMS_ENS_PAYMENT_C,
  AMS_ENS_PAYMENT_D,
  AMS_ENS_PAYMENT_H,
  AMS_ENS_PAYMENT_Y,
  AMS_ENS_PAYMENT_Z,
  AMS_ENS_PAYMENT_WIRE,
  AMS_ENS_PAYMENT_ACH
]

/**
 * AMS_ENS 运输类型
 */
export const AMS_ENS_TRANSPORT_TYPE_I = new CommonState('I', 'Import', 'Import')
export const AMS_ENS_TRANSPORT_TYPE_F = new CommonState('F', 'Freight Remain on Board', 'Freight Remain on Board')

// 将所有运输类型存储在一个数组中
export const AMS_ENS_TRANSPORT_TYPES = [
  AMS_ENS_TRANSPORT_TYPE_I,
  AMS_ENS_TRANSPORT_TYPE_F
]

/**
 * AMS_ENS 付款方式AI
 */
export const AMS_ENS_TRANSPORT_TYPE_I_AI = new CommonState('I', '进口', 'Import')
export const AMS_ENS_TRANSPORT_TYPE_F_AI = new CommonState('F', '过境不下船', 'FROB')

// 将所有支付方式存储在一个数组中
export const AMS_ENS_TRANSPORT_TYPES_AI = [
  AMS_ENS_TRANSPORT_TYPE_I_AI,
  AMS_ENS_TRANSPORT_TYPE_F_AI
]

export const AMS_ENS_PROMPT_KEY_ADDRESS = new CommonState('ADDRESS', '收发通', 'ADDRESS')
export const AMS_ENS_PROMPT_KEY_CARGO = new CommonState('CARGO', '货物信息', ' CARGO')
export const AMS_ENS_PROMPT_KEY_CONTAINER = new CommonState('CONTAINER', '箱子信息', 'CONTAINER')
export const REGION_PROMPT_KEY = new CommonState('REGION', '起运地', 'REGION')
export const DELIVERY_ADDRESS_PROMPT_KEY = new CommonState('DELIVERY_ADDRESS', '配送地址', 'DELIVERY_ADDRESS')

// 反恐仓单AMS的AI识别
export const AMS_AMS_PROMPT_KEY_ADDRESS = new CommonState('ADDRESS_AMS', '收发通', 'ADDRESS')
export const AMS_AMS_PROMPT_KEY_CONTAINER = new CommonState('CARGO_AMS', '箱子信息', 'CONTAINER')

// 反恐舱单AFR的AI识别
export const AMS_AFR_PROMPT_KEY_ADDRESS = new CommonState('ADDRESS_AFR', '收发通', 'ADDRESS')
export const AMS_AFR_PROMPT_KEY_CONTAINER = new CommonState('CARGO_AFR', '箱子信息', 'CONTAINER')

// tip
export const REGION_PLACEHOLDER = new CommonState('例如：张三13166668888上海市虹口区周家嘴路669号中垠广场A座', '', '')
export const DELIVERY_ADDRESS_PLACEHOLDER = new CommonState('Ontario, Ca 91761 ONT8 或 Los Angeles, CA 90001', '', '')

/**
 * 报关行状态
 * @type {CommonState}
 */
export const BROKER_RECEIVED_ORDER = new CommonState('43', '已接单', 'Received order')
export const BROKER_WITHDRAWN = new CommonState('50', '已撤回', 'Withdrawn')
export const BROKER_PENDING_AUDIT_VERIFICATION = new CommonState('61', '待校验稿审核', 'Pending draft review')
export const BROKER_PRE_RECORD_COMPLETED = new CommonState('63', '预录完成', 'Pre recording completed')
export const BROKER_SUCCESS_DECLARATION = new CommonState('81', '申报成功', 'Declaration successful')

export const CUSTOMS_BROKER_STATUS = [BROKER_RECEIVED_ORDER, BROKER_WITHDRAWN, BROKER_PENDING_AUDIT_VERIFICATION, BROKER_PRE_RECORD_COMPLETED, BROKER_SUCCESS_DECLARATION]

export const FBA_JOBS = ['SE', 'AE', 'RE']

/**
 * GP说明
 */
export const GP_EXPLAIN_VALUE = new CommonState('1', '有值', 'Value')
export const GP_EXPLAIN_NULL_VALUE = new CommonState('0', '空值', 'Null Value')

export const GP_EXPLAIN_STATUS = new Set([GP_EXPLAIN_VALUE, GP_EXPLAIN_NULL_VALUE])

export const NOT_OPENED = new CommonState(0, '未开通', 'Not opened')
export const SEA_HOUSE = new CommonState(1, '海管家', 'SeaHouse')
export const WSE = new CommonState(2, '未斯', 'Wse')
export const RONGE_TONG = new CommonState(3, '荣e通', 'RongeTong')
export const ALL_CHANNEL = new CommonState('all', '全部', 'All')

export const VAS_CHANNEL_ONE = [ALL_CHANNEL, WSE, SEA_HOUSE, RONGE_TONG]
export const VAS_CHANNEL_TWO = [NOT_OPENED, WSE, SEA_HOUSE, RONGE_TONG]

export const DANGEROUS_GOODS_SEA_HOUSE = new CommonState('DR', '海管家危险品', 'SeaHouseDangerousGoods')
export const DANGEROUS_GOODS_WSE = new CommonState('D', '未斯危险品', 'WseDangerousGoods')

export const DANGEROUS_GOODS = [DANGEROUS_GOODS_WSE, DANGEROUS_GOODS_SEA_HOUSE]

/**
 * 客商所在地区
 */
export const U8C_AREA_01 = new CommonState('01', '01-国内', '01-Domestic')
export const U8C_AREA_02 = new CommonState('02', '02-国外', '02-Overseas')
export const U8C_AREA_03 = new CommonState('03', '03-集团内客商', '03-Customers within the group')
export const U8C_AREA_04 = new CommonState('04', '04-其他客商', '04-Other Customers')
export const U8C_AREAS = [U8C_AREA_01, U8C_AREA_02, U8C_AREA_03, U8C_AREA_04]

/**
 * 太平-拓客方式
 */
export const CUSTOMER_EXPAND_MODE_SC = new CommonState('SC', '自拓', 'Self Customer')
export const CUSTOMER_EXPAND_MODE_AC = new CommonState('AC', '分配', 'Assign Customer')
export const CUSTOMER_EXPAND_MODES = new Set([CUSTOMER_EXPAND_MODE_SC, CUSTOMER_EXPAND_MODE_AC])

/**
 * 认缴资金/实缴资金
 */
export const CAPITAL_01 = new CommonState('10', '1000万及以上', '≥ 10 million CNY')
export const CAPITAL_02 = new CommonState('8', '500（含）万元-1000万元以下', '5–10 million CNY (incl. 5M)')
export const CAPITAL_03 = new CommonState('6', '200（含）万元-500万元以下', '2–5 million CNY (incl. 2M)')
export const CAPITAL_04 = new CommonState('4', '200万元以下', '< 2 million CNY')
export const CAPITAL_LIST = [CAPITAL_01, CAPITAL_02, CAPITAL_03, CAPITAL_04]

/**
 * 纳税人信用等级
 */
export const TAX_01 = new CommonState('5', 'A级', 'Tax Rating A')
export const TAX_02 = new CommonState('3', 'B级及以下', 'Tax Rating B or below')
export const TAX_03 = new CommonState('-3', '失信惩戒对象', 'Dishonest taxpayer')
export const TAX_LIST = [TAX_01, TAX_02, TAX_03]

/**
 * 企业性质
 */
export const NATURE_01 = new CommonState('5', '央企、国际500强', 'Central SOE / Fortune Global 500')
export const NATURE_02 = new CommonState('4', '地方国企、境外企业、外企、上市企业', 'Local SOE / Overseas / Listed')
export const NATURE_03 = new CommonState('3', '民企', 'Private enterprise')
export const NATURE_LIST = [NATURE_01, NATURE_02, NATURE_03]

/**
 * 企业经营场地性质
 */
export const VENUE_01 = new CommonState('5', '自有产权', 'Self-owned property')
export const VENUE_02 = new CommonState('3', '租用', 'Leased property')
export const VENUE_LIST = [VENUE_01, VENUE_02]

/**
 * 合作年限及业务合作连续性
 */
export const COOP_01 = new CommonState('10', '5年及以上，业务持续合作无间断', '≥ 5 yrs, uninterrupted')
export const COOP_02 = new CommonState('9', '3-5年以下，业务持续合作无间断', '3–5 yrs, uninterrupted')
export const COOP_03 = new CommonState('8', '1-3年以下，业务持续合作无间断', '1–3 yrs, uninterrupted')
export const COOP_04 = new CommonState('7', '首次合作', 'First-time cooperation')
export const COOP_LIST = [COOP_01, COOP_02, COOP_03, COOP_04]

/**
 * 预计/历史应收账款回收天
 */
export const AR_DAYS_01 = new CommonState('25', '30天内', '≤ 30 days')
export const AR_DAYS_02 = new CommonState('20', '60天内', '31–60 days')
export const AR_DAYS_03 = new CommonState('15', '90天内', '61–90 days')
export const AR_DAYS_04 = new CommonState('10', '120天内', '91–120 days')
export const AR_DAYS_05 = new CommonState('5', '150天内', '121–150 days')
export const AR_DAYS_06 = new CommonState('0', '180天及以上', '≥ 180 days')
export const AR_DAYS_LIST = [AR_DAYS_01, AR_DAYS_02, AR_DAYS_03, AR_DAYS_04, AR_DAYS_05, AR_DAYS_06]

/**
 * 预计/历史月度应收账款发生额
 */
export const AR_AMT_01 = new CommonState('15', '500万元以上', '> 5 million CNY')
export const AR_AMT_02 = new CommonState('13', '50万元（含）-500万元', '0.5–5 million CNY')
export const AR_AMT_03 = new CommonState('11', '20万元（含）-50万元以下', '0.2–0.5 million CNY')
export const AR_AMT_04 = new CommonState('10', '5万元（含）-20万元以下', '50k–200k CNY')
export const AR_AMT_05 = new CommonState('8', '5万元以下', '< 50k CNY')
export const AR_AMT_LIST = [AR_AMT_01, AR_AMT_02, AR_AMT_03, AR_AMT_04, AR_AMT_05]

/**
 * 预计/历史毛利贡献率
 */
export const MARGIN_01 = new CommonState('20', '毛利贡献率8%以上', 'Gross margin > 8%')
export const MARGIN_02 = new CommonState('18', '毛利贡献率5%以上-8%', '5% < margin ≤ 8%')
export const MARGIN_03 = new CommonState('16', '毛利贡献率3%以上-5%', '3% < margin ≤ 5%')
export const MARGIN_04 = new CommonState('14', '毛利贡献率1%-3%', '1% ≤ margin ≤ 3%')
export const MARGIN_05 = new CommonState('12', '毛利贡献率1%以下', 'margin < 1%')
export const MARGIN_LIST = [MARGIN_01, MARGIN_02, MARGIN_03, MARGIN_04, MARGIN_05]

/**
 * 客户性质
 */
export const CUSTOMER_TYPE_01 = new CommonState('5', '直客', 'Direct customer')
export const CUSTOMER_TYPE_02 = new CommonState('3', '同行直客', 'Peer direct customer')
export const CUSTOMER_TYPE_03 = new CommonState('1', '同行订舱客户', 'Peer booking customer')
export const CUSTOMER_TYPE_LIST = [CUSTOMER_TYPE_01, CUSTOMER_TYPE_02, CUSTOMER_TYPE_03]

/**
 * 行业额外资质和获奖情况（加分项）
 */
export const QUALITY_01 = new CommonState('10', '世界500强、国内100强或本行业国内50强', 'Fortune Global 500 / Top 100 CN / Top 50 sector')
export const QUALITY_02 = new CommonState('10.001', '支付了预付担保金或提供了银行保函（信用额80%以上）', 'Advance deposit / BG ≥ 80% credit')
export const QUALITY_03 = new CommonState('5.001', '获得省或较大市级以上行业重合同守信用证书', 'Provincial/municipal trustworthy enterprise')
export const QUALITY_04 = new CommonState('5.002', '拥有NVOCC、一级货代、3A级及以上综合性物流认证、ISO9001：2000等质量管理证书等', 'NVOCC / Class-A freight forwarder / 3A logistics / ISO9001')
export const QUALITY_05 = new CommonState('5.003', '获得海关AEO高级认证证书', 'Customs AEO Advanced Certification')
export const QUALITY_06 = new CommonState('5.004', '提供国企或上市公司对账款的担保', 'SOE / listed company guarantee')
export const QUALITY_07 = new CommonState('2', '公司其他与资信有关的获奖情况', 'Other credit-related awards')
export const QUALITY_LIST = [QUALITY_01, QUALITY_02, QUALITY_03, QUALITY_04, QUALITY_05, QUALITY_06, QUALITY_07]

/**
 * 采购类型
 */
export const PROCUREMENT_TYPE_01 = new CommonState('1', '询比采购', 'Inquiry & Comparison Procurement')
export const PROCUREMENT_TYPE_02 = new CommonState('2', '竞价采购', 'Bidding Procurement')
export const PROCUREMENT_TYPE_03 = new CommonState('3', '谈判采购', 'Negotiation Procurement')
export const PROCUREMENT_TYPE_04 = new CommonState('4', '直接采购', 'Direct Procurement')
export const PROCUREMENT_TYPE_LIST = [PROCUREMENT_TYPE_01, PROCUREMENT_TYPE_02, PROCUREMENT_TYPE_03, PROCUREMENT_TYPE_04]

/**
 * 英制单位模块
 * @type {CommonState}
 */
export const IMPERIAL_1 = new CommonState('1', '空运订舱', 'Air Booking')
export const IMPERIAL_2 = new CommonState('2', '远程订舱', 'Remote booking')
export const IMPERIAL_3 = new CommonState('3', '前置仓收货', 'Pre-distribution center receiving')
export const IMPERIAL_4 = new CommonState('4', '待入库清单', 'Pending inbound list')
export const IMPERIAL_5 = new CommonState('5', '仓储', 'Warehouse storage')
export const IMPERIAL_6 = new CommonState('6', '前置仓出库', 'Pre-distribution center outbound')
export const IMPERIAL_LIST = [IMPERIAL_1, IMPERIAL_2, IMPERIAL_3, IMPERIAL_4, IMPERIAL_5, IMPERIAL_6]
export const TIME_TYPE_1 = new CommonState('hour', '按小时', 'Per Hour')
export const TIME_TYPE_2 = new CommonState('day', '每天', 'Daily')
export const TIME_TYPE_3 = new CommonState('week', '每周', 'Weekly')
export const TIME_TYPE_4 = new CommonState('mon', '每月', 'Monthly')
/**
 * ocr模板状态
 */
export const OCR_TEMPLATE_STATUS_INVALID = new CommonState(false, '失效', 'Invalid')
export const OCR_TEMPLATE_STATUS_VALID = new CommonState(true, '有效', 'Valid')
export const OCR_TEMPLATE_STATUS = [OCR_TEMPLATE_STATUS_INVALID, OCR_TEMPLATE_STATUS_VALID]

/**
 * ocr调用结果
 */
export const OCR_TEMPLATE_CALL_STATUS_SUCCESS = new CommonState(0, '失败', 'fail')
export const OCR_TEMPLATE_CALL_STATUS_FAIL = new CommonState(1, '成功', 'success')
export const OCR_TEMPLATE_CALL_STATUS = [OCR_TEMPLATE_CALL_STATUS_SUCCESS, OCR_TEMPLATE_CALL_STATUS_FAIL]

/**
 * ocr页面
 */
export const OCR_LIST = new CommonState('list', '列表', 'list')
export const OCR_DETAIL = new CommonState('detail', '详情', 'detail')
export const OCR_CODE_HANDLE = new CommonState('codeHandle', '代码处理', 'codeHandle')
export const OCR_TEST_FILE = new CommonState('testFile', '测试文件', 'testFile')

/**
 * ocr企业 结合有效期 的状态
 */
export const OCR_ENTERPRISE_STATUS_WITH_DATE_INVALID = new CommonState(1, '失效', 'Invalid')
export const OCR_ENTERPRISE_STATUS_WITH_DATE_VALID = new CommonState(2, '有效', 'Valid')
export const OCR_ENTERPRISE_STATUS_WITH_DATE_NOT_EFFECTIVE = new CommonState(3, '未生效', 'Not effective')
export const OCR_ENTERPRISE_STATUS_WITH_DATE = [OCR_ENTERPRISE_STATUS_WITH_DATE_INVALID, OCR_ENTERPRISE_STATUS_WITH_DATE_VALID, OCR_ENTERPRISE_STATUS_WITH_DATE_NOT_EFFECTIVE]

/**
 * ocr企业状态
 */
export const OCR_ENTERPRISE_STATUS_INVALID = new CommonState(false, '失效', 'Invalid')
export const OCR_ENTERPRISE_STATUS_VALID = new CommonState(true, '有效', 'Valid')

export const FROZEN_GOODS_SEA_HOUSE = new CommonState('RF', '海管家冷冻品', 'SeaHouseFrozenGoods')
export const FROZEN_GOODS_WSE = new CommonState('R', '未斯冷冻品', 'WseFrozenGoods')

export const RECEIVE_CONSIGNMENT_NOTE = new CommonState(1, '接收托书', 'Receive consignment note')
export const RECEIVE_RECEIPT = new CommonState(2, '接收回执', 'Receive receipt')
export const RECEIVE_SHIPPING_SCHEDULE = new CommonState(3, '接收船期', 'Receive shipping schedule')

export const EMAIL_PARSING_TYPE = [RECEIVE_CONSIGNMENT_NOTE, RECEIVE_RECEIPT, RECEIVE_SHIPPING_SCHEDULE]

export const FIXED_LAST_NUMBER = new CommonState(1, '尾号固定00', 'Fixed Last Number 00')
export const GENERAL = new CommonState(2, '通用规则', 'General rule')

export const GENERATIVE_RULES = [FIXED_LAST_NUMBER, GENERAL]

/**
 * ocr字段配置 是否必填
 */
export const OCR_FIELD_IF_REQUIRED_SAVE_JOB = new CommonState('SAVE_JOB', '保存业务必填', 'Save business required')
export const OCR_FIELD_IF_REQUIRED_BOOKING = new CommonState('BOOKING', '订舱必填', 'Booking is required')
export const OCR_FIELD_IF_REQUIRED = [
  OCR_FIELD_IF_REQUIRED_SAVE_JOB,
  OCR_FIELD_IF_REQUIRED_BOOKING
]

/**
 * ocr字段配置 渠道
 */
export const OCR_FIELD_CHANNEL_BOOK_NOTE = new CommonState('BOOK_NOTE', '托书', 'Book note')
export const OCR_FIELD_CHANNEL_MAIL = new CommonState('MAIL', '邮件', 'Mail')
export const OCR_FIELD_CHANNEL = [
  OCR_FIELD_CHANNEL_BOOK_NOTE,
  OCR_FIELD_CHANNEL_MAIL
]

/**
 * ocr字段配置 对比不一致
 */
export const OCR_FIELD_IF_SAME_MUST_SAME = new CommonState('MUST_SAME', '必须一致', 'Must same')
export const OCR_FIELD_IF_SAME_FROM_BOOK_NOTE = new CommonState('FROM_BOOK_NOTE', '以托书为准', 'Subject to consignment note')
export const OCR_FIELD_IF_SAME_FROM_FROM_MAIL = new CommonState('FROM_MAIL', '以邮件为准', 'Subject to email')
export const OCR_FIELD_IF_SAME = [
  OCR_FIELD_IF_SAME_MUST_SAME,
  OCR_FIELD_IF_SAME_FROM_BOOK_NOTE,
  OCR_FIELD_IF_SAME_FROM_FROM_MAIL
]

/**
 * 是否自动订舱下拉
 * @type {CommonState}
 */
export const IF_AUTO_BOOKING_YES = new CommonState(true, '是', 'Yes')
export const IF_AUTO_BOOKING_NO = new CommonState(false, '否', 'No')
export const IF_AUTO_BOOKING = [
  IF_AUTO_BOOKING_YES,
  IF_AUTO_BOOKING_NO
]

/**
 * 模块来源
 * @type {CommonState}
 */
export const SOURCE_REMOTE_BOOKING_SAVE = new CommonState('remoteBooking-save', '远程订舱保存')

// /**
//  * 托书-业务进度：1-已录单、2-已订舱、3-订舱失败、4-订舱确认回执、5-订舱取消回执、6-收到订舱
//  */
// export const JOB_PROCESS_SAVE_SUCCESS = new CommonState(1, '已录单', 'Recorded order')
// export const JOB_PROCESS_BOOKING_SUCCESS = new CommonState(2, '已订舱', 'Booking already made')
// export const JOB_PROCESS_BOOKING_FAIL = new CommonState(3, '订舱失败', 'Recorded order')
// export const JOB_PROCESS_BOOKING_CONFIRM_RECEIPT = new CommonState(4, '订舱确认回执', 'Booking Confirmation Receipt')
// export const JOB_PROCESS_BOOKING_CANCEL_RECEIPT = new CommonState(5, '订舱取消回执', 'Booking cancellation receipt')
// export const JOB_PROCESS_BOOKING_RECEIVE = new CommonState(6, '收到订舱', 'Received booking')
//
// export const JOB_PROCESS = [
//   JOB_PROCESS_SAVE_SUCCESS,
//   JOB_PROCESS_BOOKING_SUCCESS,
//   JOB_PROCESS_BOOKING_FAIL,
//   JOB_PROCESS_BOOKING_CONFIRM_RECEIPT,
//   JOB_PROCESS_BOOKING_CANCEL_RECEIPT,
//   JOB_PROCESS_BOOKING_RECEIVE
// ]

/**
 * 订舱状态 海出
 * @type {CommonState}
 */
export const JOB_BOOKING_STATE_RECORDED_NOT_BOOKING = new CommonState(100, '已录单，未订舱', 'Recorded, not booked yet')
export const JOB_BOOKING_STATE_BOOKING = new CommonState(101, '正在订舱', 'Booking')
export const JOB_BOOKING_STATE_BOOKING_SEND_FAIL = new CommonState(102, '调用异常', 'Call exception')
export const JOB_BOOKING_STATE_BOOKING_SEND_SUCCESS = new CommonState(103, '订舱发送成功', 'Booking sent successfully')
export const JOB_BOOKING_STATE_BOOKING_RECEIVED = new CommonState(104, '订舱已接收', 'Booking received')
export const JOB_BOOKING_STATE_BOOKING_REFUSED = new CommonState(105, '订舱被拒绝', 'Booking rejected')
export const JOB_BOOKING_STATE_BOOKING_CONFIRM = new CommonState(106, '订舱确认', 'Booking confirmation')
export const JOB_BOOKING_STATE_BOOKING_CANCEL = new CommonState(107, '订舱取消', 'Booking cancellation')
export const JOB_BOOKING_STATE_RECEIPT_RECEIVED = new CommonState(108, '回执已接收', 'Receipt received')
export const JOB_BOOKING_STATE_VALID_FAIL = new CommonState(109, '校验错误', 'Verification error')
export const JOB_BOOKING_STATE_TEMPLATE_MATCH_FAIL = new CommonState(110, '模版匹配失败', 'Template matching failed')
export const JOB_BOOKING_STATE_NO_BOOKING = new CommonState(111, '不订舱', 'No booking')
export const JOB_BOOKING_GET_BOOKING_RECEIPT_FAIL = new CommonState(112, '订阅订舱回执失败', 'Failed to obtain booking receipt')
export const JOB_BOOKING_IN_QUEUE = new CommonState(113, '订舱EDI队列排队中', 'Booking EDI queue in queue')
export const JOB_BILL_IN_QUEUE = new CommonState(114, '提单EDI队列排队中', 'The bill of lading EDI queue is queued')

export const JOB_BOOKING_STATE_BOOKING_FAIL = new CommonState(999, '发送订舱失败', 'booking fail')

export const JOB_BOOKING_STATES_NEW = [
  JOB_BOOKING_STATE_RECORDED_NOT_BOOKING,
  JOB_BOOKING_STATE_BOOKING,
  JOB_BOOKING_STATE_BOOKING_SEND_FAIL,
  JOB_BOOKING_STATE_BOOKING_SEND_SUCCESS,
  JOB_BOOKING_STATE_BOOKING_RECEIVED,
  JOB_BOOKING_STATE_BOOKING_REFUSED,
  JOB_BOOKING_STATE_BOOKING_CONFIRM,
  JOB_BOOKING_STATE_BOOKING_CANCEL,
  JOB_BOOKING_STATE_VALID_FAIL,
  JOB_BOOKING_STATE_TEMPLATE_MATCH_FAIL,
  JOB_BOOKING_STATE_NO_BOOKING,
  JOB_BOOKING_STATE_BOOKING_FAIL,
  JOB_BOOKING_GET_BOOKING_RECEIPT_FAIL,
  JOB_BOOKING_IN_QUEUE,
  JOB_BILL_IN_QUEUE
]
// 排除掉 回执已接收
export const JOB_BOOKING_STATES = [
  JOB_BOOKING_STATE_RECORDED_NOT_BOOKING,
  JOB_BOOKING_STATE_BOOKING,
  JOB_BOOKING_STATE_BOOKING_SEND_SUCCESS,
  JOB_BOOKING_STATE_BOOKING_RECEIVED,
  JOB_BOOKING_STATE_BOOKING_REFUSED,
  JOB_BOOKING_STATE_BOOKING_CONFIRM,
  JOB_BOOKING_STATE_BOOKING_CANCEL,
  JOB_BOOKING_STATE_NO_BOOKING,
  JOB_BOOKING_STATE_BOOKING_FAIL,
  JOB_BOOKING_GET_BOOKING_RECEIPT_FAIL
]

export const JOB_BOOKING_STATE_FAIL_CODES = [
  JOB_BOOKING_STATE_BOOKING_SEND_FAIL.code,
  JOB_BOOKING_STATE_VALID_FAIL.code,
  JOB_BOOKING_STATE_TEMPLATE_MATCH_FAIL.code,
  JOB_BOOKING_GET_BOOKING_RECEIPT_FAIL.code
]

export const ALLOCATION_0 = new CommonState(0, '未分配', 'Not allocated')
export const ALLOCATION_1 = new CommonState(1, '已分配', 'Allocated')

export const ALLOCATION_LIST = [
  ALLOCATION_0,
  ALLOCATION_1
]

export const COMMISSION_ROLE_1 = new CommonState('sales', '销售', 'Sales')
export const COMMISSION_ROLE_2 = new CommonState('csr', '客服', 'Customer Service')
export const COMMISSION_ROLE_3 = new CommonState('op', '操作', 'Operation')
export const COMMISSION_ROLE_4 = new CommonState('userDefinedRole1', '自定义岗位1', 'Custom Position 1')
export const COMMISSION_ROLE_5 = new CommonState('userDefinedRole2', '自定义岗位2', 'Custom Position 2')
export const COMMISSION_ROLE_6 = new CommonState('userDefinedRole3', '自定义岗位3', 'Custom Position 3')
export const COMMISSION_ROLE_7 = new CommonState('userDefinedRole4', '自定义岗位4', 'Custom Position 4')

export const COMMISSION_ROLE_LIST = [
  COMMISSION_ROLE_1,
  COMMISSION_ROLE_2,
  COMMISSION_ROLE_3,
  COMMISSION_ROLE_4,
  COMMISSION_ROLE_5,
  COMMISSION_ROLE_6,
  COMMISSION_ROLE_7
]

export const CABIN_BP_1 = new CommonState(-1, '订舱预审', 'Booking Pre-Audit')
export const CABIN_BP_2 = new CommonState(0, '海运订舱', 'Shipping booking')
export const CABIN_BP_LIST = new Set([CABIN_BP_1, CABIN_BP_2])

export const CABIN_0 = new CommonState(0, '待订舱', 'Pending booking')
export const CABIN_1 = new CommonState(1, '待放舱', 'Pending release of cabin space')
export const CABIN_2 = new CommonState(2, '已放舱', 'Cabin space released')
export const CABIN_3 = new CommonState(3, '已退舱', 'Cabin space canceled')
export const CABIN_4 = new CommonState(4, '订舱失败', 'Booking failed')
export const CABIN_LIST = [
  CABIN_0,
  CABIN_1,
  CABIN_2,
  CABIN_3,
  CABIN_4
]

export const ROUTE_CONFIRMATION_0 = new CommonState(0, '待确认', 'Not Confirm')
export const ROUTE_CONFIRMATION_1 = new CommonState(1, '已确认', 'Confirm')
export const ROUTE_CONFIRMATION_2 = new CommonState(2, '二次确认', 'Secondary confirmation')
export const ROUTE_CONFIRMATION_LIST = [ROUTE_CONFIRMATION_0, ROUTE_CONFIRMATION_1, ROUTE_CONFIRMATION_2]

/**
 * 公海舱位 舱位状态
 * @type {Set<CommonState>}
 */
export const PUBLIC_SEA_CABIN_SPACE_STATUS = [
  CABIN_0,
  CABIN_1,
  CABIN_2
]

export const CHANNEL_0 = new CommonState(0, 'cargoWare', 'cargoWare')
export const CHANNEL_1 = new CommonState(1, '沃行之家', '沃行之家')
export const CHANNEL_2 = new CommonState(2, 'eTowerOne', 'eTowerOne')
export const CHANNEL_3 = new CommonState(3, 'eTowerTech', 'eTowerTech')
export const CHANNEL_4 = new CommonState(4, 'cargoApi', 'cargoApi')
export const CHANNEL_5 = new CommonState(5, '邮件导入', '邮件导入')
export const CHANNEL_6 = new CommonState(6, 'B2B', 'B2B')
export const CHANNEL_7 = new CommonState(7, 'excel导入', 'excel导入')
export const CHANNEL_8 = new CommonState(8, 'OCR识别', 'OCR识别')

export const CHANNEL_LIST = [
  CHANNEL_5,
  CHANNEL_0,
  CHANNEL_1,
  CHANNEL_2,
  CHANNEL_3,
  CHANNEL_4,
  CHANNEL_6,
  CHANNEL_7,
  CHANNEL_8
]
/**
 * ocr tab
 * @type {CommonState}
 */
export const OCR_TAB_IDENTIFY = new CommonState(1, 'OCR识别')
export const OCR_TAB_PENDING = new CommonState(2, '未完成')
export const OCR_TAB_FINISHED = new CommonState(3, '已完成')
export const OCR_TAB_TRASH = new CommonState(4, '垃圾箱')

/**
 * ocr 识别方式
 * @type {CommonState}
 */
export const IDENTIFICATION_METHOD_SYSTEM = new CommonState('system', '系统上传', 'System upload')
export const IDENTIFICATION_METHOD_EMAIL = new CommonState('email', '邮件上传', 'Email upload')

export const IDENTIFICATION_METHOD = [IDENTIFICATION_METHOD_SYSTEM, IDENTIFICATION_METHOD_EMAIL]

/**
 * ocr 上传进度
 * @type {CommonState}
 */
export const UPLOAD_STATUS_PARSE_PROGRESS = new CommonState(0, '上传完成,正在解析', 'Upload completed, parsing in progress')
export const UPLOAD_STATUS_PARSE_FAULT = new CommonState(1, '解析失败', 'Analysis failed')
export const UPLOAD_STATUS_PARSE_DONE = new CommonState(2, '解析完成', 'Analysis completed')
export const UPLOAD_STATUS_COMPLETE_ORDER = new CommonState(3, '已生成订单', 'Generated order')
export const UPLOAD_STATUS_REMOVE = new CommonState(4, '已删除', 'Deleted')

export const UPLOAD_STATUS = [UPLOAD_STATUS_PARSE_PROGRESS, UPLOAD_STATUS_PARSE_FAULT, UPLOAD_STATUS_PARSE_DONE]

/**
 * 托书保存业务时，指定【船公司】收发通校验（每行长度不超过35）
 * @type {*[]}
 */
export const ADDRESS_VALID_CARRIER = ['ONE', 'HMM']

/**
 * 获取回执配置-船公司
 * @type {CommonState}
 */
export const RECEIPT_CARRIER_HMM = new CommonState('HMM', '现代', 'HMM')
export const RECEIPT_CARRIER_ONE = new CommonState('ONE', '海洋网联', 'ONE')

export const RECEIPT_CARRIERS = [RECEIPT_CARRIER_HMM, RECEIPT_CARRIER_ONE]

/**
 * 获取回执配置-渠道
 * @type {CommonState}
 */
export const RECEIPT_CHANNEL_EMAIL = new CommonState('EMAIL', '邮件', 'EMAIL')

export const RECEIPT_CHANNELS = [RECEIPT_CHANNEL_EMAIL]

/**
 * 获取回执配置-操作符
 * @type {CommonState}
 */
export const RECEIPT_OPERATOR_EQUALS = new CommonState('EQUALS', '等于', 'EQUALS')
export const RECEIPT_OPERATOR_CONTAINS = new CommonState('CONTAINS', '包含', 'CONTAINS')

export const RECEIPT_OPERATORS = [RECEIPT_OPERATOR_EQUALS, RECEIPT_OPERATOR_CONTAINS]

/**
 * 回执来源
 * @type {CommonState}
 */
export const RECEIPT_SOURCE_EMAIL = new CommonState('EMAIL', '邮件', 'EMAIL')
export const RECEIPT_SOURCE_HPL = new CommonState('HPL', '赫伯罗特', 'HPL')
export const RECEIPT_SOURCE_YD = new CommonState('YD', '壹沓', 'YD')

/**
 * 订舱发送方式
 * @type {CommonState}
 */
export const BOOKING_SEND_METHOD_MANUAL = new CommonState('MANUAL', '手动', 'MANUAL')
export const BOOKING_SEND_METHOD_AUTOMATIC = new CommonState('AUTOMATIC', '自动', 'AUTOMATIC')

export const BOOKING_SEND_METHODS = [BOOKING_SEND_METHOD_MANUAL, BOOKING_SEND_METHOD_AUTOMATIC]

/**
 * 订舱传输方式
 * @type {CommonState}
 */
export const TRANSPORT_MODE_FTP = new CommonState('FTP', 'FTP', 'FTP')
export const TRANSPORT_MODE_RPA = new CommonState('RPA', 'RPA', 'RPA')
export const TRANSPORT_MODE_API = new CommonState('API', 'API', 'API')

export const TRANSPORT_MODES = [TRANSPORT_MODE_FTP, TRANSPORT_MODE_RPA, TRANSPORT_MODE_API]

/**
 * 订舱失败原因
 * @type {CommonState}
 */
export const BOOKING_ERROR_CODE_CONTAINS_SENSITIVE_WORD = new CommonState(1, '品名中包含敏感词', 'The product name contains sensitive words')
export const BOOKING_ERROR_CODE_MBL_NOT_FOUND = new CommonState(2, '未找到提单号', 'Bill of lading number not found')
export const BOOKING_ERROR_CODE_TEMPLATE_NOT_MATCH = new CommonState(3, '未匹配到模版', 'Template not matched')
export const BOOKING_ERROR_CODE_TEMPLATE_MATCH_TOO_MANY = new CommonState(4, '匹配到多个模版', 'Match to multiple templates')
export const BOOKING_ERROR_CODE_TEMPLATE_CONTENT_VALID_FAIL = new CommonState(5, '模板内容校验错误', 'Template content verification error')
export const BOOKING_ERROR_CODE_SYSTEM_ERROR = new CommonState(6, '系统异常', 'System abnormality')
export const BOOKING_ERROR_CODE_CALL_FTP_FAIL = new CommonState(7, '调用FTP失败', 'FTP call failed')
export const BOOKING_ERROR_CODE_CALL_API_FAIL = new CommonState(8, '调用API失败', 'API call failed')
export const BOOKING_ERROR_USERNAME_PASSWORD_NOT_MAINTAINED = new CommonState(9, '未设置账号或者密码', 'UserName/Password not maintained')
export const BOOKING_ERROR_SHIP_COMPANY_NOT_MAINTAINED = new CommonState(10, '业务的船公司未维护关联船公司', 'Related platform ShipCompany not maintained')
export const BOOKING_ERROR_SHIPPINGCOMPANYCODE_NOT_MAINTAINED = new CommonState(11, '未维护映射船公司', 'ShippingCompanyCode not maintained')
export const BOOKING_ERROR_YD_RESPONSE_NOT_SUCCESS = new CommonState(12, '壹沓返回的结果是不成功', 'The result returned by YD is unsuccessful')
export const BOOKING_ERROR_BOOKINGCHANNEL_CONFIG_NOT_MAINTAINED = new CommonState(13, '未匹配到订舱渠道设置', 'Not matched with bookingChannel config')
export const BOOKING_ERROR_GET_BOOKING_RECEIPT_FAIL = new CommonState(14, '订阅订舱回执失败', 'Subscription booking receipt failed')

export const BOOKING_ERROR_CODES = [BOOKING_ERROR_CODE_CONTAINS_SENSITIVE_WORD, BOOKING_ERROR_CODE_MBL_NOT_FOUND,
  BOOKING_ERROR_CODE_TEMPLATE_NOT_MATCH, BOOKING_ERROR_CODE_TEMPLATE_MATCH_TOO_MANY,
  BOOKING_ERROR_CODE_TEMPLATE_CONTENT_VALID_FAIL, BOOKING_ERROR_CODE_SYSTEM_ERROR, BOOKING_ERROR_CODE_CALL_FTP_FAIL,
  BOOKING_ERROR_CODE_CALL_API_FAIL, BOOKING_ERROR_USERNAME_PASSWORD_NOT_MAINTAINED, BOOKING_ERROR_SHIP_COMPANY_NOT_MAINTAINED,
  BOOKING_ERROR_SHIPPINGCOMPANYCODE_NOT_MAINTAINED, BOOKING_ERROR_YD_RESPONSE_NOT_SUCCESS, BOOKING_ERROR_BOOKINGCHANNEL_CONFIG_NOT_MAINTAINED,
  BOOKING_ERROR_GET_BOOKING_RECEIPT_FAIL]

/**
 * 订单渠道
 * @type {CommonState}
 */
export const SALES_CHANNEL_OCR_RECOGNITION = new CommonState('OCR识别', 'OCR识别', 'OCR recognition')

/**
 * 订舱模式
 */
export const BOOKING_MODE_1 = new CommonState(1, 'RPA', 'RPA')
export const BOOKING_MODES = new Set([BOOKING_MODE_1])

/**
 * RPA供应商
 */
export const RPA_SUPPLIER_1 = new CommonState('YD', '壹沓', '壹沓')
export const RPA_SUPPLIERS = new Set([RPA_SUPPLIER_1])

/**
 * 订舱渠道：船公司、亿通、INTRA、订舱代理、船代、CARGOSMART、宁波电子口岸、宁波EDI中心
 */
export const BOOKING_CHANNEL_1 = new CommonState('CARRIER', '船公司', '船公司')
export const BOOKING_CHANNEL_2 = new CommonState('YITONG_PLATFORM', '亿通', '亿通')
export const BOOKING_CHANNEL_3 = new CommonState('INTTRA_PLATFORM', 'INTTRA', 'INTTRA')
export const BOOKING_CHANNEL_4 = new CommonState('DCDW', '订舱代理', '订舱代理')
export const BOOKING_CHANNEL_5 = new CommonState('CAG', '船代', '船代')
export const BOOKING_CHANNEL_6 = new CommonState('CARGOSMART_PLATFORM', 'CARGOSMART', 'CARGOSMART')
export const BOOKING_CHANNEL_7 = new CommonState('NBDZKA', '宁波电子口岸', '宁波电子口岸')
export const BOOKING_CHANNEL_8 = new CommonState('NINGBO_EDI_CENTER', '宁波EDI中心', '宁波EDI中心')
export const BOOKING_CHANNELS = new Set([BOOKING_CHANNEL_1, BOOKING_CHANNEL_2, BOOKING_CHANNEL_3, BOOKING_CHANNEL_4, BOOKING_CHANNEL_5, BOOKING_CHANNEL_6, BOOKING_CHANNEL_7, BOOKING_CHANNEL_8])

/**
 * 回执配置
 */
export const RECEIPT_CONFIG_1 = new CommonState(1, 'FTP获取回执', 'FTP获取回执')
export const RECEIPT_CONFIG_2 = new CommonState(2, 'CW邮件获取', 'CW邮件获取')
export const RECEIPT_CONFIG_3 = new CommonState(3, '壹沓邮件获取', '壹沓邮件获取')
export const RECEIPT_CONFIG_4 = new CommonState(4, '壹沓船司获取', '壹沓船司获取')
export const RECEIPT_CONFIG_5 = new CommonState(5, '不获取回执', '不获取回执')
export const RECEIPT_CONFIGS = new Set([RECEIPT_CONFIG_1, RECEIPT_CONFIG_2, RECEIPT_CONFIG_3, RECEIPT_CONFIG_4, RECEIPT_CONFIG_5])

// 承运人信息
export const CARRIER = new CommonState(1, '承运人', 'CARRIER')
export const POL = new CommonState(2, '起运港', 'POL')
export const POD = new CommonState(3, '目标港', 'POD')
export const REGION = new CommonState(4, '航线/区域', 'REGION')
export const COUNTRY = new CommonState(5, '国家', 'COUNTRY')
/**
 * 调用带出逻辑 调用来源
 * @type {CommonState}
 * @private
 */
export const BRING_OUT_LOGIC_CALL_SOURCE_SE_BOOKING = new CommonState('SE_BOOKING', '海运订舱', 'Sea export booking')
export const BRING_OUT_LOGIC_CALL_SOURCE_OCR = new CommonState('OCR', 'OCR识别', 'OCR recognition')

// 装箱信息-数据类型（区分列表中的数据具体类型）
export const CONTAINER_DATA_TYPE_JOB = new CommonState('JOB', '业务', 'JOB')
export const CONTAINER_DATA_TYPE_POITEMS = new CommonState('POITEMS', '关单信息', 'POITEMS')
export const CONTAINER_DATA_TYPE_USAGE = new CommonState('USAGE', '装箱信息', 'USAGE')

export const CONTRACT_RATE_MODE_0 = new CommonState(0, '请选择', 'Please select')
export const CONTRACT_RATE_MODE_1 = new CommonState(1, 'General Tariff', 'General Tariff')
export const CONTRACT_RATE_MODE_2 = new CommonState(2, 'Rate Agreement', 'Rate Agreement')
export const CONTRACT_RATE_MODE_3 = new CommonState(3, 'Service Contract Number', 'Service Contract Number')
export const CONTRACT_RATE_MODE_4 = new CommonState(4, 'Spot Quotation', 'Spot Quotation')
export const CONTRACT_RATE_MODE_LIST = new Set([
  CONTRACT_RATE_MODE_0,
  CONTRACT_RATE_MODE_1, CONTRACT_RATE_MODE_2,
  CONTRACT_RATE_MODE_3, CONTRACT_RATE_MODE_4
])

export const CHARGE_TYPE_RADIO_COST_PAY = new CommonState(0, '应收应付', 'cost pay')
export const CHARGE_TYPE_RADIO_COST = new CommonState(1, '应收', 'cost')
export const CHARGE_TYPE_RADIO_PAY = new CommonState(2, '应付', 'pay')
export const CHARGE_TYPE_RADIO_COST_PAY_SPECIAL = new CommonState(3, '应收应付特殊费用', 'cost pay special')
export const CHARGE_TYPE_RADIO_COST_SPECIAL = new CommonState(4, '应收特殊费用', 'cost 特殊费用')
export const CHARGE_TYPE_RADIO_PAY_SPECIAL = new CommonState(5, '应付特殊费用', 'pay 特殊费用')

export const CHARGE_TYPE_RADIOS = new Set([
  CHARGE_TYPE_RADIO_COST_PAY,
  CHARGE_TYPE_RADIO_COST,
  CHARGE_TYPE_RADIO_PAY,
  CHARGE_TYPE_RADIO_COST_PAY_SPECIAL,
  CHARGE_TYPE_RADIO_COST_SPECIAL,
  CHARGE_TYPE_RADIO_PAY_SPECIAL
])

// 工作单业务类型
export const SE_JOB_NO_PATTERN = new CommonState('SEJobNoPattern', '海运出口', 'SEJobNoPattern')
export const SI_JOB_NO_PATTERN = new CommonState('SIJobNoPattern', '海运进口', 'SIJobNoPattern')
export const AE_JOB_NO_PATTERN = new CommonState('AEJobNoPattern', '空运出口', 'AEJobNoPattern')
export const AI_JOB_NO_PATTERN = new CommonState('AIJobNoPattern', '空运进口', 'AIJobNoPattern')
export const RE_JOB_NO_PATTERN = new CommonState('REJobNoPattern', '铁路出口', 'REJobNoPattern')
export const RI_JOB_NO_PATTERN = new CommonState('RIJobNoPattern', '铁路进口', 'RIJobNoPattern')
export const FBA_SE_JOB_NO_PATTERN = new CommonState('FBASEJobNoPattern', 'FBA海运', 'FBASEJobNoPattern')
export const FBA_AE_JOB_NO_PATTERN = new CommonState('FBAAEJobNoPattern', 'FBA空运', 'FBAAEJobNoPattern')
export const FBA_RE_JOB_NO_PATTERN = new CommonState('FBAREJobNoPattern', 'FBA铁路', 'FBAREJobNoPattern')
export const IE_JOB_NO_PATTERN = new CommonState('IEJobNoPattern', '综合物流', 'IEJobNoPattern')

export const JOB_NO_CONFIGS = new Set([
  SE_JOB_NO_PATTERN, SI_JOB_NO_PATTERN,
  AE_JOB_NO_PATTERN, AI_JOB_NO_PATTERN,
  RE_JOB_NO_PATTERN, RI_JOB_NO_PATTERN,
  FBA_SE_JOB_NO_PATTERN, FBA_AE_JOB_NO_PATTERN, FBA_RE_JOB_NO_PATTERN,
  IE_JOB_NO_PATTERN
])

// 主单号业务类型
export const SE_MBL_NO_PATTERN = new CommonState('SEMblNoPattern', '海运出口', 'SEMblNoPattern')
export const SI_MBL_NO_PATTERN = new CommonState('SIMblNoPattern', '海运进口', 'SIMblNoPattern')
export const AE_MBL_NO_PATTERN = new CommonState('AEMblNoPattern', '空运出口', 'AEMblNoPattern')

export const MBL_NO_CONFIGS = new Set([SE_MBL_NO_PATTERN, SI_MBL_NO_PATTERN, AE_MBL_NO_PATTERN])

// 分单号业务类型
export const SE_HBL_NO_PATTERN = new CommonState('SEHblNoPattern', '海运出口', 'SEHblNoPattern')
export const SI_HBL_NO_PATTERN = new CommonState('SIHblNoPattern', '海运进口', 'SIHblNoPattern')
export const AE_HBL_NO_PATTERN = new CommonState('AEHblNoPattern', '空运出口', 'AEHblNoPattern')

export const HBL_NO_CONFIGS = new Set([SE_HBL_NO_PATTERN, SI_HBL_NO_PATTERN, AE_HBL_NO_PATTERN])

// 进仓编号业务类型
export const SE_WAREHOUSE_NO_PATTERN = new CommonState('SEWareHouseNoPattern', '海运出口', 'SEWareHouseNoPattern')
export const SI_WAREHOUSE_NO_PATTERN = new CommonState('SIWareHouseNoPattern', '海运进口', 'SIWareHouseNoPattern')
export const AE_WAREHOUSE_NO_PATTERN = new CommonState('AEWareHouseNoPattern', '空运出口', 'AEWareHouseNoPattern')
export const AI_WAREHOUSE_NO_PATTERN = new CommonState('AIWareHouseNoPattern', '空运进口', 'AIWareHouseNoPattern')
export const RE_WAREHOUSE_NO_PATTERN = new CommonState('REWareHouseNoPattern', '铁路出口', 'REWareHouseNoPattern')
export const RI_WAREHOUSE_NO_PATTERN = new CommonState('RIWareHouseNoPattern', '铁路进口', 'RIWareHouseNoPattern')
export const FBA_SE_WAREHOUSE_NO_PATTERN = new CommonState('FBASEWareHouseNoPattern', 'FBA海运', 'FBASEWareHouseNoPattern')
export const FBA_AE_WAREHOUSE_NO_PATTERN = new CommonState('FBAAEWareHouseNoPattern', 'FBA空运', 'FBAAEWareHouseNoPattern')
export const FBA_RE_WAREHOUSE_NO_PATTERN = new CommonState('FBAREWareHouseNoPattern', 'FBA铁路', 'FBAREWareHouseNoPattern')
export const IE_WAREHOUSE_NO_PATTERN = new CommonState('IEWareHouseNoPattern', '综合物流', 'IEWareHouseNoPattern')

export const WAREHOUSE_NO_CONFIGS = new Set([
  SE_WAREHOUSE_NO_PATTERN,
  SI_WAREHOUSE_NO_PATTERN,
  AE_WAREHOUSE_NO_PATTERN,
  AI_WAREHOUSE_NO_PATTERN,
  RE_WAREHOUSE_NO_PATTERN,
  RI_WAREHOUSE_NO_PATTERN,
  FBA_SE_WAREHOUSE_NO_PATTERN,
  FBA_AE_WAREHOUSE_NO_PATTERN,
  FBA_RE_WAREHOUSE_NO_PATTERN,
  IE_WAREHOUSE_NO_PATTERN
])

// 海外账单号
export const BILLING_NO_PATTERN = new CommonState('BillingNoPattern', '海外账单号', 'BillingNoPattern')
export const BILLING_NO_CONFIGS = new Set([
  BILLING_NO_PATTERN
])

// 海外账单号
export const BILLING_INTERNAL_NO_PATTERN = new CommonState('BillingInternalNoPattern', '国内账单号', 'BillingInternalNoPattern')
export const BILLING_INTERNAL_NO_CONFIGS = new Set([
  BILLING_INTERNAL_NO_PATTERN
])

// 海外账单号
export const BILL_PAYMENT_NO_PATTERN = new CommonState('BillPaymentNoPattern', '付款申请号', 'BillPaymentNoPattern')
export const BILL_PAYMENT_NO_CONFIGS = new Set([
  BILL_PAYMENT_NO_PATTERN
])

// 国内对账单
export const BILLING_GROUP_INTERNAL_NO_PATTERN = new CommonState('BillingGroupInternalNoPattern', '国内对账单号', 'BillingGroupInternalNoPattern')
export const BILLING_GROUP_INTERNAL_NO_CONFIGS = new Set([
  BILLING_GROUP_INTERNAL_NO_PATTERN
])

// 国外对账单
export const BILLING_GROUP_NO_PATTERN = new CommonState('BillingGroupNoPattern', '海外对账单号', 'BillingGroupNoPattern')
export const BILLING_GROUP_NO_CONFIGS = new Set([
  BILLING_GROUP_NO_PATTERN
])

// 销账流水号
export const WRITE_OFF_NO_PATTERN = new CommonState('WriteOffNoPattern', '销账流水号', 'WriteOffNoPattern')
export const WRITE_OFF_NO_CONFIGS = new Set([
  WRITE_OFF_NO_PATTERN
])

// 提单流水号
export const SE_MBL_BILL_NO_PATTERN = new CommonState('SEMBLBillNoPattern', '海运出口', 'SEMBLBillNoPattern')
export const SI_MBL_BILL_NO_PATTERN = new CommonState('SIMBLBillNoPattern', '海运进口', 'SIMBLBillNoPattern')
export const SE_HBL_BILL_NO_PATTERN = new CommonState('SEHBLBillNoPattern', '海运出口', 'SEHBLBillNoPattern')
export const SI_HBL_BILL_NO_PATTERN = new CommonState('SIHBLBillNoPattern', '海运进口', 'SIHBLBillNoPattern')
export const MBL_BILL_NO_CONFIGS = new Set([
  SE_MBL_BILL_NO_PATTERN, SI_MBL_BILL_NO_PATTERN, SE_HBL_BILL_NO_PATTERN, SI_HBL_BILL_NO_PATTERN
])

export const MBL = new CommonState('MBL', '主单', 'MBL')
export const HBL = new CommonState('HBL', '分单', 'HBL')
export const BILL_TYPE_SOURCE = new Set([
  MBL, HBL
])

// 大包货物类型
export const REGULAR = new CommonState(1, '普货', 'Regular')
export const SPECIAL = new CommonState(2, '特货', 'Special')
export const SENSITIVE = new CommonState(3, '敏感品', 'Sensitive')
export const NO_CONFIRMING = new CommonState(4, '超规品', 'Non-confirming')
export const PROHIBITB = new CommonState(5, '禁运品', 'prohibitb')

export const ALL_BIG_BAG_GOODS_TYPE = [REGULAR, SPECIAL, SENSITIVE, NO_CONFIRMING, PROHIBITB]

// 履约类型
export const MAINLAND_SPECIAL = new CommonState(1, '大陆特', 'Mainland Special')
export const MAINLAND_MAKEUP = new CommonState(2, '大陆敏', 'Mainland Makeup')

export const ALL_FULFILLMENT_LABEL = [MAINLAND_SPECIAL, MAINLAND_MAKEUP]

/**
 * 指令类型
 * @type {CommonState}
 */
export const INSTRUCTION_TYPE_UPLOAD_FILE = new CommonState('UPLOAD_FILE', '上传文件', 'Upload file')
export const INSTRUCTION_TYPE_PRINT_FILE = new CommonState('PRINT_FILE', '打印文件', 'Print file')
export const INSTRUCTION_TYPE_SEND_EMAIL = new CommonState('SEND_EMAIL', '发送邮件', 'Send email')
export const INSTRUCTION_TYPE_SEND_DATA = new CommonState('SEND_DATA', '发送数据', 'Send data')
export const INSTRUCTION_TYPE_EXPORT_DATA = new CommonState('EXPORT_DATA', '导出数据', 'Export data')
export const INSTRUCTION_TYPE_DATA_FILL = new CommonState('DATA_FILL', '数据填写', 'Data fill')
export const INSTRUCTION_TYPE_OTHER_OPERATION = new CommonState('OTHER_OPERATION', '其他操作', 'Other operation')
export const INSTRUCTION_TYPE_JUMP_PAGE = new CommonState('JUMP_PAGE', '跳转页面', 'Jump page')

export const INSTRUCTION_TYPES = [
  INSTRUCTION_TYPE_UPLOAD_FILE, INSTRUCTION_TYPE_PRINT_FILE, INSTRUCTION_TYPE_SEND_EMAIL,
  INSTRUCTION_TYPE_SEND_DATA, INSTRUCTION_TYPE_EXPORT_DATA, INSTRUCTION_TYPE_DATA_FILL,
  INSTRUCTION_TYPE_OTHER_OPERATION, INSTRUCTION_TYPE_JUMP_PAGE
]

/**
 * 打印渠道
 * @type {CommonState}
 */
export const PRINT_CANCEL_0 = new CommonState(0, '无', 'none')
export const PRINT_CANCEL_1 = new CommonState(1, 'OCR打印', 'OCR print')

export const PRINT_CANCEL_LIST = [
  PRINT_CANCEL_0, PRINT_CANCEL_1
]

/**
 * 指令来源
 * @type {CommonState}
 */
export const INSTRUCTION_SOURCE_PLATFORM = new CommonState(true, '平台', 'Platform')
export const INSTRUCTION_SOURCE_TENANT = new CommonState(false, '租户', 'Tenant')

export const INSTRUCTION_SOURCES = [
  INSTRUCTION_SOURCE_PLATFORM, INSTRUCTION_SOURCE_TENANT
]

/**
 * 租户操作指令树 中的 数据类型
 * @type {CommonState}
 */
export const INSTRUCTION_TREE_DATE_TYPE_LOB = new CommonState('LOB', '业务', 'Lob')
export const INSTRUCTION_TREE_DATE_TYPE_INSTRUCTION_TYPE = new CommonState('INSTRUCTION_TYPE', '租户', 'Instruction type')

export const ZH = new CommonState('zh', '中文', 'Chinese')
export const EN = new CommonState('en', '英文', 'English')
export const JA = new CommonState('ja', '日文', 'Japanese')

/**
 * 指令执行结果
 * @type {CommonState}
 */
export const INSTRUCTION_EXECUTE_RESULT_SUCCESS = new CommonState(1, '执行成功', 'Execute success')
export const INSTRUCTION_EXECUTE_RESULT_FAIL = new CommonState(2, '执行失败', 'Execute fail')

export const INSTRUCTION_EXECUTE_RESULTS = [
  INSTRUCTION_EXECUTE_RESULT_SUCCESS, INSTRUCTION_EXECUTE_RESULT_SUCCESS
]

/**
 * 平台指令规则代码
 * @type {CommonState}
 */
export const PLATFORM_INSTRUCTION_CODE_BB_SEND_DESTINATION_PORT_AGENT = new CommonState('bbSendDestinationPortAgent', '委托拼箱批量发送目的港代理', 'Break Bulk send to destination port agent')
export const PLATFORM_INSTRUCTION_CODE_VIRTUAL_HBL = new CommonState('virtualHbl', '形式分单', 'Form splitting')
export const PLATFORM_INSTRUCTION_CODE_LCL_SEND_DESTINATION_PORT_AGENT = new CommonState('lclSendDestinationPortAgent', '自拼箱发送目的港代理', 'LCL send to destination port agent')
export const PLATFORM_INSTRUCTION_CODE_LCL_SEND_PACKAGE_AGENT = new CommonState('lclSendPackageAgent', '自拼箱发送套单代理', 'LCL send to package agent')
export const PLATFORM_INSTRUCTION_CODE_LCL_RESET_ONE_CLICK_SEND = new CommonState('lclResetOneClickSend', '重置一键发送', 'LCL reset one click send')
export const PLATFORM_INSTRUCTION_CODE_UPLOAD_FILE = new CommonState('uploadFile', '上传文件', 'Upload file')
export const PLATFORM_INSTRUCTION_CODE_PRINT_FILE = new CommonState('printFile', '打印文件', 'Print file')
export const PLATFORM_INSTRUCTION_CODE_JUMP_PAGE = new CommonState('jumpPage', '跳转页面', 'Jump page')
export const PLATFORM_INSTRUCTION_CODE_UPDATE_SOP_NODE_STATUS = new CommonState('updateSopNodeStatus', '更新业务SOP节点状态', 'Update business SOP node status')
export const PLATFORM_INSTRUCTION_CODE_CUSTOM_FORM = new CommonState('customForm', '自定义表单', 'Custom Form')
export const PLATFORM_INSTRUCTION_CODE_MERGE_INVOCIE_FILE = new CommonState('mergeInvocieFile', '合并发票文件', 'Merge Invocie File')
export const PLATFORM_INSTRUCTION_CODE_UPDATE_JOB_STATE = new CommonState('updateJobState', '更新业务状态', 'Update job state')
export const PLATFORM_INSTRUCTION_CODE_SAME_TENANT_CROSS_DELEGATION = new CommonState('sameTenantCrossDelegation', '同租户交叉委托', 'Same tenant cross delegation')
export const PLATFORM_INSTRUCTION_CODE_CONFIRMED_BILL = new CommonState('confirmedBill', '发送账单信息', 'send bill')
export const PLATFORM_INSTRUCTION_CODE_CANCEL_CONFIRMED_BILL = new CommonState('cancelConfirmedBill', '取消确认账单', 'Cancel Confirmed Bill')

export const ACTIVE_TAB_NAME_BUSINESS_STATUS_MANAGEMENT = new CommonState('businessStatusManagement', '业务状态管理', 'Business status management')
export const ACTIVE_TAB_NAME_OPERATION_INSTRUCTIONS_MANAGEMENT = new CommonState('operationInstructionsManagement', '操作指令管理', 'Operation instructions management')

export const PUSH_LINK_LIST = [
  {
    name: lang.t('SystemMaintenance.PreSendingSupplementaryInvitationLink'),
    id: '1'
  },
  {
    name: lang.t('SystemMaintenance.MarineMBLInvitationForProofreading'),
    id: '2'
  },
  {
    name: lang.t('SystemMaintenance.MarineHBLInvitationForProofreading'),
    id: '3'
  },
  {
    name: lang.t('SystemMaintenance.MarineExportBulkPrinting'),
    id: '4'
  },
  {
    name: lang.t('SystemMaintenance.AirCargoStorage'),
    id: '5'
  },
  {
    name: lang.t('SystemMaintenance.BillOfLadingPrintProduction'),
    id: '6'
  },
  {
    name: lang.t('SystemMaintenance.FileHistory'),
    id: '7'
  },
  // {
  //   name: '成基',
  //   id: '8'
  // },
  {
    name: lang.t('SystemMaintenance.OceanShippingAlertReminderEmail'),
    id: '10'
  },
  {
    name: lang.t('SystemMaintenance.AirExportAlertReminderEmail'),
    id: '11'
  },
  {
    name: lang.t('SystemMaintenance.RailwayAlertReminderEmail'),
    id: '12'
  },
  {
    name: lang.t('SystemMaintenance.AirImportAlertReminderEmails'),
    id: '13'
  },
  {
    name: lang.t('SystemMaintenance.IntegratedAlertReminderEmails'),
    id: '14'
  },
  {
    name: lang.t('SystemMaintenance.ReminderEmail'),
    id: '15'
  },
  {
    name: lang.t('SystemMaintenance.SendDestinationPortProxyDocuments'),
    id: '16'
  },
  {
    name: lang.t('SystemMaintenance.SendPackageProxyFiles'),
    id: '17'
  },
  {
    name: lang.t('SystemMaintenance.BbSendDestinationPortAgent'),
    id: BB_SEND_DESTINATION_PORT_AGENT_STRING
  },
  {
    name: lang.t('SystemMaintenance.ChargeSyncAuditPass'),
    id: '19'
  },
  {
    name: lang.t('SystemMaintenance.ChargeSyncAuditNotPass'),
    id: '20'
  },
  {
    name: lang.t('SystemMaintenance.ChargeSyncRecallApplyCharge'),
    id: '21'
  }
]
// 已锁定/未锁定

export const LOCK_STATUS = new CommonState(1, '已锁定', 'Locked')
export const UNLOCK_STATUS = new CommonState(0, '未锁定', 'Unlocked')

export const LOCK_TYPES = ([
  LOCK_STATUS,
  UNLOCK_STATUS
])

export const SHIPPING_STAY_RELEASE = new CommonState(1, '待放舱', 'shipping stay release')
export const SHIPPING_DONE_RELEASE = new CommonState(2, '已放舱', 'shipping done release')
export const SHIPPING_STAY_BOOKING = new CommonState(3, '待订舱', 'shipping stay booking')
export const SHIPPING_MANAGERS = ([
  SHIPPING_STAY_RELEASE,
  SHIPPING_DONE_RELEASE,
  SHIPPING_STAY_BOOKING
])

export const CABIN_STAY_RELEASE = new CommonState(1, '舱位管理-舱位待放舱', 'Cabin Management - Cabin Pending Release')
export const CABIN_DONE_RELEASE = new CommonState(2, '舱位管理-舱位已放舱', 'Cabin Management - Cabin Opened')
export const CABIN_STAY_BOOKING = new CommonState(3, '舱位管理-舱位待订舱', 'Cabin Management - Cabin Pending Booking')
export const CABIN_MANAGERS = ([
  CABIN_STAY_RELEASE,
  CABIN_DONE_RELEASE,
  CABIN_STAY_BOOKING
])

// 上传文件 来源
export const UPLOAD_SOURCE_FILE_HISTORY = new CommonState('fileHistory', '文件历史', 'File history')

export const ROW_SELECTION_SINGLE = new CommonState('single', '单选', 'single')
export const ROW_SELECTION_MULTIPLE = new CommonState('multiple', '多选', 'multiple')

export const TEMPLATE_TYPE_BOOKING = 'BOOKING'
export const TEMPLATE_TYPE_BACNKLETTER = 'BACNKLETTER'
export const TEMPLATE_TYPE_MANIFESTINFO = 'MANIFESTINFO'
export const TEMPLATE_TYPE_LOCALSERVICE = 'LOCALSERVICE'
export const TEMPLATE_TYPE_FBA_INTERNAL_WAREHOUSE = 'FBA_INTERNAL_WAREHOUSE'
export const TEMPLATE_TYPE_FBA_OVERSEA_WAREHOUSE = 'FBA_OVERSEA_WAREHOUSE'
export const TEMPLATE_TYPE_POD_TRUCKING = 'POD_TRUCKING'
export const TEMPLATE_TYPE_SIJOBNO = 'SIJOBNO'
export const TEMPLATE_TYPE_SIMBL = 'SIMBL'
export const TEMPLATE_TYPE_SIHBL = 'SIHBL'
export const TEMPLATE_TYPE_SIPO = 'SIPO'
export const TEMPLATE_TYPE_AEBOOKING = 'AEBOOKING'
export const TEMPLATE_TYPE_AEMAWB = 'AEMAWB'
export const TEMPLATE_TYPE_AEHAWB = 'AEHAWB'
export const TEMPLATE_TYPE_AIJOBNO = 'AIJOBNO'
export const TEMPLATE_TYPE_AIHAWB = 'AIHAWB'
export const TEMPLATE_TYPE_BOOKING_RE = 'BOOKING_RE'

// 【打印模板】操作指令 支持的模板类
export const INSTRUCTION_TEMPLATE_TYPE_MAP = new Map([
  [SE.code,
    ['BOOKING', 'BACNKLETTER', 'MANIFESTINFO', 'MBL', 'MBL2', 'HBL2', 'AMS',
      'LOCALSERVICE', 'FBA_INTERNAL_WAREHOUSE', 'FBA_OVERSEA_WAREHOUSE', 'POD_TRUCKING']],
  [SI.code,
    ['SIJOBNO', 'SIMBL', 'SIMBL2', 'SIHBL', 'SIHBL2', 'WT', 'SIPO']],
  [AE.code,
    ['AEBOOKING', 'BACNKLETTER', 'AEMAWB', 'AEHAWB', 'AEHAWB2', 'FBA_INTERNAL_WAREHOUSE',
      'FBA_OVERSEA_WAREHOUSE', 'SIPO', 'LOCALSERVICE', 'AELOCALSERVICE', 'POD_TRUCKING']],
  [AI.code,
    ['AIJOBNO', 'AIHAWB', 'AIWT']],
  [RE.code,
    ['BOOKING_RE', 'LOCALSERVICE_RE', 'FBA_INTERNAL_WAREHOUSE', 'FBA_OVERSEA_WAREHOUSE',
      'RAILWAYHEADWAYTAIL']],
  [RI.code,
    ['BOOKING_RE', 'LOCALSERVICE_RE', 'FBA_INTERNAL_WAREHOUSE', 'FBA_OVERSEA_WAREHOUSE',
      'RAILWAYHEADWAYTAIL']],
  [IE.code,
    ['BOOKING', 'LOCALSERVICE']]
])

// 批量【打印模板】操作指令 支持的模板类
export const INSTRUCTION_BATCH_TEMPLATE_TYPE_MAP = new Map([
  [SE.code, 'JOBLIST'],
  [SI.code, 'SIJOBLIST'],
  [AE.code, 'AEJOBLIST'],
  [AI.code, 'AIJOBLIST'],
  [RE.code, 'JOBLIST_RE'],
  [RI.code, 'JOBLIST_RE'],
  [IE.code, 'IEJOBLIST']
])

export const INSTRUCTION_ACTION_SINGLE = new CommonState('single', '单个操作', 'single')
export const INSTRUCTION_ACTION_BATCH = new CommonState('batch', '批量操作', 'batch')

// 时贝希 货物明细 类型
export const FCL_TYPE = new CommonState('FCL', 'Fcl模式', 'Fcl mode')
export const LCL_TYPE = new CommonState('LCL', 'Lcl模式', 'Lcl mode')
export const CONSOLE_TYPE = new CommonState('CONSOLE', 'Console模式', 'Console mode')

export const GOODS_DETAIL_MODES = [FCL_TYPE, LCL_TYPE, CONSOLE_TYPE]

export const SHIPPING_COMPANY = new CommonState(0, '船公司', 'shipping Company')
export const AIRLINE_COMPANY = new CommonState(1, '航空公司', 'airline Company')
export const CARRIER_TYPE = [SHIPPING_COMPANY, AIRLINE_COMPANY]
export const NORMAL_VIRTUAL_BILL_TYPE = new CommonState(0, '普通', 'Normal')
export const MERGE_VIRTUAL_BILL_TYPE = new CommonState(1, '并单', 'Merge')
export const VIRTUAL_BILL_TYPES = [NORMAL_VIRTUAL_BILL_TYPE, MERGE_VIRTUAL_BILL_TYPE]

// 可选税率范围
export const TAX_RATE_RANGE_0 = new CommonState('0', '0%', '0%')
export const TAX_RATE_RANGE_3 = new CommonState('3', '3%', '3%')
export const TAX_RATE_RANGE_6 = new CommonState('6', '6%', '6%')
export const TAX_RATE_RANGE_9 = new CommonState('9', '9%', '9%')
export const TAX_RATE_RANGE_13 = new CommonState('13', '13%', '13%')

export const TAX_RATE_RANGES = [TAX_RATE_RANGE_0, TAX_RATE_RANGE_3, TAX_RATE_RANGE_6, TAX_RATE_RANGE_9, TAX_RATE_RANGE_13]

export const UN_BERTH_PLAN_DATE_SYN_ETD = new CommonState('0', '计划离泊时间同步ETD', 'Synchronize ETD with planned departure time')
export const ESTIMATED_ARRIVAL_TIME_SYN_ETA = new CommonState('1', '预计到港时间同步ETA', 'Expected arrival time synchronized with ETA')

// 下载日志类型
export const INVOICE = new CommonState('INVOICE', '发票', 'INVOICE')

export const DOWNLOAD_LOG_TYPE = [INVOICE]

// '一般货物'
export const GENERAL_CARGO = '一般货物'

export const SALES_AND_OPERATIONS_ARE_THE_SAME = new CommonState('SALES_AND_OPERATIONS_ARE_THE_SAME', '销售、操作相同', 'Sales and operations are the same.')

// action
export const ACTION_ADD = new CommonState('add', '新增', 'add')

// methodParams的key
export const METHOD_PARAMS_KEY_COMPANY_LOB = new CommonState('companyLob', '业务类型', 'companyLob')

export const WEEK_MONDAY = new CommonState(1, '星期一', 'monday')
export const WEEK_TUESDAY = new CommonState(2, '星期二', 'tuesday')
export const WEEK_WEDNESDAY = new CommonState(3, '星期三', 'wednesday')
export const WEEK_THURSDAY = new CommonState(4, '星期四', 'thursday')
export const WEEK_FRIDAY = new CommonState(5, '星期五', 'friday')
export const WEEK_SATURDAY = new CommonState(6, '星期六', 'saturday')
export const WEEK_SUNDAY = new CommonState(7, '星期天', 'sunday')
export const WEEKS = [WEEK_MONDAY, WEEK_TUESDAY, WEEK_WEDNESDAY, WEEK_THURSDAY, WEEK_FRIDAY, WEEK_SATURDAY, WEEK_SUNDAY]

export const FEE_STANDARDS_WEIGHT = new CommonState(1, '计重', 'weight')
export const FEE_STANDARDS_ROUTE = new CommonState(2, '航线产品', 'route')
export const FEE_STANDARDS_GROSS_WEIGHT = new CommonState(3, '毛重', 'gross weight')
export const FEE_STANDARDS_VOLUME = new CommonState(4, '体积', 'volume')
export const FEE_STANDARDS_QUANTITY = new CommonState(5, '件数', 'quantity')
export const FEE_STANDARDS_MASTER_BILL = new CommonState(6, '主单', 'master bill')
export const FEE_STANDARDS_SUB_BILL = new CommonState(7, '分单', 'sub bill')

export const FEE_STANDARDS = [
  FEE_STANDARDS_WEIGHT,
  FEE_STANDARDS_ROUTE,
  FEE_STANDARDS_GROSS_WEIGHT,
  FEE_STANDARDS_VOLUME,
  FEE_STANDARDS_QUANTITY,
  FEE_STANDARDS_MASTER_BILL,
  FEE_STANDARDS_SUB_BILL
]

// 航线产品-航次-成本-单位
export const UNIT_PRICE = new CommonState(1, '单价', 'unit price')
export const UNIT_TOTAL_PRICE = new CommonState(2, '总价', 'total price')

export const UNITS = [UNIT_PRICE, UNIT_TOTAL_PRICE]

export const CURRENCY_RMB = new CommonState('RMB', '人民币', 'RMB')

// 采购方式
export const PURCHASE_METHOD_AIRLINE = new CommonState('airln', '航司', 'airln')
export const PURCHASE_METHOD_AGENT = new CommonState('agent', '代理', 'agent')

export const PURCHASE_METHODS = [PURCHASE_METHOD_AIRLINE, PURCHASE_METHOD_AGENT]

// 数据层级结构
export const DATA_TYPE_LEVEL_1 = new CommonState(1, '一级数据')
export const DATA_TYPE_LEVEL_2 = new CommonState(2, '二级数据')

export const YES_NO_STATE = [YES, NO]

export const DEFAULT_CREDIT_TYPE_DEFAULT = new CommonState(1, '默认信控', 'default')
export const DEFAULT_CREDIT_TYPE_BAO_DI = new CommonState(2, '保底信控', 'bao di')
// 保函类型
export const GUARANTEE_HBL = new CommonState('HBLTR', 'HBL电放保函', 'HBL Telex Release L/G')

// 保函类型集合
export const GUARANTEE_TYPES = new Set([
  GUARANTEE_HBL
])

// 分润模式：job=整票、currency=币种
export const SHARE_MODE_JOB = new CommonState('job', '整票', 'Job')
export const SHARE_MODE_CURRENCY = new CommonState('currency', '币种', 'Currency')
export const SHARE_MODES = [SHARE_MODE_JOB, SHARE_MODE_CURRENCY]

// 可拼装 件数、毛重、体积
export const QUANTITY_NOT_ASSEMBLY_LABEL = new CommonState('quantityNotAssemblyLabel', '拼装件数', 'Not assembly quantity')
export const WEIGHT_NOT_ASSEMBLY_LABEL = new CommonState('weightNotAssemblyLabel', '拼装毛重', 'Not assembly weight')
export const CUBAGE_NOT_ASSEMBLY_LABEL = new CommonState('cubageNotAssemblyLabel', '拼装体积', 'Not assembly cubage')
export const CHARGE_NOT_WEIGHT_ASSEMBLY_LABEL = new CommonState('chargeWeightNotAssemblyLabel', '拼装计费重量', 'Not assembly chargeWeight')

// 可出仓
export const OUTBOUND_INSTRUCTION_ENABLE = new CommonState(true, '可出仓', 'Outbound instruction enable')
export const OUTBOUND_INSTRUCTION_DISABLE = new CommonState(false, '不可出仓', 'Outbound instruction disable')

export const OUTBOUND_INSTRUCTIONS = [
  OUTBOUND_INSTRUCTION_ENABLE,
  OUTBOUND_INSTRUCTION_DISABLE
]

export const ASSEMBLY_PLAN_STATUS_SAVED = new CommonState(1, '已暂存', 'saved')
export const ASSEMBLY_PLAN_STATUS_ISSUED = new CommonState(2, '已下达', 'issued')
export const ASSEMBLY_PLAN_STATUS_COMPLETED = new CommonState(3, '已完成', 'completed')
export const ASSEMBLY_PLAN_STATUS_CONFIRMED = new CommonState(4, '已确认', 'confirmed')

export const ASSEMBLY_PLAN_STATUS = [
  ASSEMBLY_PLAN_STATUS_SAVED,
  ASSEMBLY_PLAN_STATUS_ISSUED,
  ASSEMBLY_PLAN_STATUS_COMPLETED,
  ASSEMBLY_PLAN_STATUS_CONFIRMED
]

// 按钮动作
export const ASSEMBLY_PLAN_ACTION_ISSUE = new CommonState(1, '计划下达', 'issue')
export const ASSEMBLY_PLAN_ACTION_CANCEL_ISSUE = new CommonState(2, '取消计划下达', 'cancel_issue')
export const ASSEMBLY_PLAN_ACTION_COMPLETE = new CommonState(3, '拼装完成', 'complete')
export const ASSEMBLY_PLAN_ACTION_CANCEL_COMPLETE = new CommonState(4, '取消拼装完成', 'cancel_complete')
export const ASSEMBLY_PLAN_ACTION_CONFIRM = new CommonState(5, '确认完成', 'confirm')
export const ASSEMBLY_PLAN_ACTION_CANCEL_CONFIRM = new CommonState(6, '取消确认完成', 'cancel_confirm')

export const ASSEMBLY_PLAN_ACTIONS = [
  ASSEMBLY_PLAN_ACTION_ISSUE,
  ASSEMBLY_PLAN_ACTION_CANCEL_ISSUE,
  ASSEMBLY_PLAN_ACTION_COMPLETE,
  ASSEMBLY_PLAN_ACTION_CANCEL_COMPLETE,
  ASSEMBLY_PLAN_ACTION_CONFIRM,
  ASSEMBLY_PLAN_ACTION_CANCEL_CONFIRM
]

export const LOAD_POOL_SOURCE_HOME_PAGE = new CommonState('homePage', '首页', 'home page')
export const LOAD_POOL_SOURCE_DETAIL = new CommonState('detail', '详情', 'detail')

// 交货状态
export const DELIVERY_STATUS_NOT_ARRIVED = new CommonState(0, '未到货', 'Not arrived')
export const DELIVERY_STATUS_ARRIVED = new CommonState(1, '已到货', 'Arrived')
export const DELIVERY_STATUS_DELIVERED = new CommonState(2, '已交货', 'Delivered')
export const DELIVERY_STATUS_WEIGHED_OUT = new CommonState(3, '已出重', 'Weighed out')

export const DELIVERY_STATUS = [
  DELIVERY_STATUS_NOT_ARRIVED,
  DELIVERY_STATUS_ARRIVED,
  DELIVERY_STATUS_DELIVERED,
  DELIVERY_STATUS_WEIGHED_OUT
]

// edi模板类型
export const EDI_TEMPLATE_TYPE_BOOKING = 1

// 用车申请单-来源
export const USE_CAR_APPLICATION_FORM_SOURCE_PICK_UP = new CommonState('pickUp', '提货', 'pick up')
export const USE_CAR_APPLICATION_FORM_SOURCE_DELIVERY = new CommonState('delivery', '送货', 'delivery')

export const USE_CAR_APPLICATION_FORM_SOURCES = [
  USE_CAR_APPLICATION_FORM_SOURCE_PICK_UP,
  USE_CAR_APPLICATION_FORM_SOURCE_DELIVERY
]

// 车单按钮动作
export const CAR_FORM_ACTION_SENT = new CommonState(1, '已出车', 'sentCarFormShow')
export const CAR_FORM_ACTION_REVOKE_SENT = new CommonState(2, '撤销出车状态', 'revokeSentCarStatusShow')
export const CAR_FORM_ACTION_FINISHED = new CommonState(3, '已完成', 'finishedShow')
export const CAR_FORM_ACTION_REVOKE_FINISHED = new CommonState(4, '撤销完成状态', 'revokeFinishedStatusShow')

// 车单状态
export const CAR_FORM_STATUS_NOT_SENT = new CommonState(1, '未出车', 'not depart')
export const CAR_FORM_STATUS_SENT = new CommonState(2, '已出车', 'already depart')
export const CAR_FORM_STATUS_FINISHED = new CommonState(3, '已完成', 'finished')

export const CAR_FORM_STATUS = [
  CAR_FORM_STATUS_NOT_SENT,
  CAR_FORM_STATUS_SENT,
  CAR_FORM_STATUS_FINISHED
]

// 车单记录表状态
export const CAR_FORM_RECORD_STATUS_NOT_SENT = new CommonState(11, '未出车', 'not depart')
export const CAR_FORM_RECORD_STATUS_SENT = new CommonState(12, '已出车', 'already depart')
export const CAR_FORM_RECORD_STATUS_FINISHED = new CommonState(13, '已完成', 'finished')

export const CAR_FORM_RECORD_STATUS = [
  CAR_FORM_RECORD_STATUS_NOT_SENT,
  CAR_FORM_RECORD_STATUS_SENT,
  CAR_FORM_RECORD_STATUS_FINISHED
]

// 运价方式
export const PRICE_METHOD_DIRECT = new CommonState(1, '直拖', 'direct')
export const PRICE_METHOD_BRANCH = new CommonState(2, '支线', 'branch')

export const PRICE_METHODS = [
  PRICE_METHOD_DIRECT,
  PRICE_METHOD_BRANCH
]

// 支线类型
export const BRANCH_LINE_HUZHOUHAITIE = new CommonState(1, '湖州海铁', 'huzhouhaitie')
export const BRANCH_LINE_HAINING = new CommonState(2, '海宁支线', 'haining')
export const BRANCH_LINE_ZHAPU = new CommonState(3, '乍浦支线', 'zhapu')
export const BRANCH_LINE_ANJIGANG = new CommonState(4, '安吉港', 'anjigang')
export const BRANCH_LINE_ANJISHANGGANG = new CommonState(5, '安吉上港', 'anjishanggang')
export const BRANCH_LINE_DEQING = new CommonState(6, '德清内河', 'deqing')
export const BRANCH_LINE_DONGZHOU = new CommonState(7, '东洲港', 'dongzhou')
export const BRANCH_LINE_DUSHAN = new CommonState(8, '独山港', 'dushan')
export const BRANCH_LINE_HAININGGANG = new CommonState(9, '海宁港', 'haininggang')
export const BRANCH_LINE_HUZHOUSHANGGANG = new CommonState(10, '湖州上港', 'huzhoushanggang')
export const BRANCH_LINE_JIAXING = new CommonState(11, '嘉兴东铁路', 'jiaxing')
export const BRANCH_LINE_JIANSHAN = new CommonState(12, '尖山码头', 'jianshan')
export const BRANCH_LINE_NANJINGLONGTANMATOU = new CommonState(13, '南京港龙潭码头', 'nanjinglongtanmatou')
export const BRANCH_LINE_NANJINGQIBEIMATOU = new CommonState(14, '南京港七坝码头', 'nanjingqibemato')
export const BRANCH_LINE_NANJINGLONGTANGANG = new CommonState(15, '南京龙潭港', 'nanjinglongtangang')
export const BRANCH_LINE_QIXING = new CommonState(16, '七星内河', 'qixing')
export const BRANCH_LINE_XIASHA = new CommonState(17, '下沙港', 'xiasha')
export const BRANCH_LINE_XIAOSHAN = new CommonState(18, '萧山铁路', 'xiaoshan')
export const BRANCH_LINE_YUSHI = new CommonState(19, '宇石码头', 'yushi')
export const BRANCH_LINE_ZHAPUGANG = new CommonState(20, '乍浦港', 'zhapugang')
export const BRANCH_LINE_CHANGXING = new CommonState(21, '长兴内河', 'changxing')

export const BRANCH_LINES = [
  BRANCH_LINE_HUZHOUHAITIE,
  BRANCH_LINE_HAINING,
  BRANCH_LINE_ZHAPU,
  BRANCH_LINE_ANJIGANG,
  BRANCH_LINE_ANJISHANGGANG,
  BRANCH_LINE_DEQING,
  BRANCH_LINE_DONGZHOU,
  BRANCH_LINE_DUSHAN,
  BRANCH_LINE_HAININGGANG,
  BRANCH_LINE_HUZHOUSHANGGANG,
  BRANCH_LINE_JIAXING,
  BRANCH_LINE_JIANSHAN,
  BRANCH_LINE_NANJINGLONGTANMATOU,
  BRANCH_LINE_NANJINGQIBEIMATOU,
  BRANCH_LINE_NANJINGLONGTANGANG,
  BRANCH_LINE_QIXING,
  BRANCH_LINE_XIASHA,
  BRANCH_LINE_XIAOSHAN,
  BRANCH_LINE_YUSHI,
  BRANCH_LINE_ZHAPUGANG,
  BRANCH_LINE_CHANGXING
]
// 0-空 1-已有运价 2-商务报价
export const CHARGE_UNIT_RATE_CHECK_NO = new CommonState(0, '未选择', 'not select')
export const CHARGE_UNIT_RATE_CHECK_SAVE = new CommonState(1, '继续保存', 'save')
export const CHARGE_UNIT_RATE_CHECK_CLEAR = new CommonState(2, '清除为0费用', 'clear')

// 运价状态
export const PRICE_STATUS_DRAFT = new CommonState(1, '草稿', 'draft')
export const PRICE_STATUS_NORMAL = new CommonState(2, '正常', 'normal')
export const PRICE_STATUS_EXPIRED = new CommonState(3, '过期', 'expired')
export const PRICE_STATUS_SHELVED = new CommonState(4, '下架', 'shelved')

export const PRICE_STATUS = [
  PRICE_STATUS_DRAFT,
  PRICE_STATUS_NORMAL,
  PRICE_STATUS_EXPIRED,
  PRICE_STATUS_SHELVED
]

// 起运港类型
export const PORT_TYPE_SEAPORT = new CommonState('seaport', '海港', 'seaport')
export const PORT_TYPE_AIRPORT = new CommonState('airport', '空港', 'airport')

export const PORT_TYPES = [
  PORT_TYPE_SEAPORT,
  PORT_TYPE_AIRPORT
]

// 配送地址类型
export const DELIVERY_ADDRESS_TYPE_THIRD_PARTY = new CommonState(1, '第三方地址', 'third_party')
export const DELIVERY_ADDRESS_TYPE_AMAZON_WAREHOUSE = new CommonState(2, '亚马逊仓库', 'amazon_warehouse')
export const DELIVERY_ADDRESS_TYPE_ECANG = new CommonState(3, '易仓', 'ecang')
export const DELIVERY_ADDRESS_TYPE_WALMART_WAREHOUSE = new CommonState(4, '沃尔玛仓库', 'walmart_warehouse')

export const DELIVERY_ADDRESS_TYPES = [
  DELIVERY_ADDRESS_TYPE_THIRD_PARTY,
  DELIVERY_ADDRESS_TYPE_AMAZON_WAREHOUSE,
  DELIVERY_ADDRESS_TYPE_ECANG,
  DELIVERY_ADDRESS_TYPE_WALMART_WAREHOUSE
]

// 港前、尾程运价 动作
export const PRICE_ACTION_LISTED = new CommonState(1, '上架', 'listed')
export const PRICE_ACTION_UNLISTED = new CommonState(2, '下架', 'unlisted')

export const PRICE_ACTION_LIST = [
  PRICE_ACTION_LISTED,
  PRICE_ACTION_UNLISTED
]

// 港前、尾程 计费条目
export const CHARGING_ITEM_TYPE_BY_EQ_SIZE = new CommonState(1, '按箱型计费条目', 'Charged by Box Type Items')
export const CHARGING_ITEM_TYPE_NOT_BY_EQ_SIZE = new CommonState(2, '非按箱型计费条目', 'Charged not by Box Type Items')

export const CHARGING_ITEM_TYPES = [
  CHARGING_ITEM_TYPE_BY_EQ_SIZE,
  CHARGING_ITEM_TYPE_NOT_BY_EQ_SIZE
]

// 港前、尾程、干线 运价 及所有子类型
export const PRICE_QUOTATION_TYPE_PRE_PORT = new CommonState(1, '港前运价', 'pre port price')
export const PRICE_QUOTATION_TYPE_LAST_MILE = new CommonState(2, '尾程运价', 'last mile price')
export const PRICE_QUOTATION_TYPE_TRUNK_LINE = new CommonState(3, '干线运价', 'trunk line price')
// export const PRICE_QUOTATION_TYPE_SEA_FCL = new CommonState(4, '海运整箱运价', 'sea fcl price')
// export const PRICE_QUOTATION_TYPE_SEA_LCL = new CommonState(5, '海运拼箱运价', 'sea lcl price')
// export const PRICE_QUOTATION_TYPE_AIR = new CommonState(6, '空运运价', 'air price')

export const PRICE_TYPES = [
  PRICE_QUOTATION_TYPE_PRE_PORT,
  PRICE_QUOTATION_TYPE_LAST_MILE
]

// 报价 类型
export const QUOTATION_TYPE_FCL = new CommonState(0, '整箱', 'fcl')
export const QUOTATION_TYPE_LCL = new CommonState(1, '空运', 'lcl')
export const QUOTATION_TYPE_AIR = new CommonState(2, '拼箱', 'air')
export const QUOTATION_TYPE_PRE_PORT = new CommonState(3, '港前', 'pre port')
export const QUOTATION_TYPE_LAST_MILE = new CommonState(4, '尾程', 'last mile')

// 询价类型/干线运价子类型
export const PRICE_INQUIRY_TYPE_SEA_FCL = new CommonState(1, '海运整箱', 'sea fcl')
export const PRICE_INQUIRY_TYPE_SEA_LCL = new CommonState(2, '海运拼箱', 'sea lcl')
export const PRICE_INQUIRY_TYPE_AIR = new CommonState(3, '空运', 'air')

// 询价来源
export const INQUIRY_SOURCE_INTERNAL = new CommonState(1, '内部', 'internal')

export const INQUIRY_SOURCES = [
  INQUIRY_SOURCE_INTERNAL
]

// 文件来源
export const FILE_BELONG_INQUIRY = new CommonState('inquiry', '询价', 'inquiry')
export const FILE_BELONG_QUOTATION = new CommonState('quotation', '报价', 'quotation')

// 询价状态
export const INQUIRY_STATUS_DRAFT = new CommonState(1, '草稿', 'draft')
export const INQUIRY_STATUS_SUBMITTED = new CommonState(2, '已提交', 'submitted')

export const INQUIRY_STATUS = [
  INQUIRY_STATUS_DRAFT,
  INQUIRY_STATUS_SUBMITTED
]

// 询价 动作
export const INQUIRY_ACTION_SUBMIT = new CommonState(1, '提交', 'submit')
export const INQUIRY_ACTION_REVOKE = new CommonState(2, '撤销', 'revoke')

// 货好时间-类型 1-区间 2-日期
export const CARGO_READY_TIME_TYPE_RANGE = new CommonState('range', '区间', 'range')
export const CARGO_READY_TIME_TYPE_DATE = new CommonState('date', '日期', 'date')

export const CARGO_READY_TIME_TYPES = [
  CARGO_READY_TIME_TYPE_RANGE,
  CARGO_READY_TIME_TYPE_DATE
]

// 货好时间-区间 1-一周内 2-二周内 3-一个月内 4-一个月以上 5-时间未知 6-三天内
export const CARGO_READY_TIME_RANGE_WITHIN_ONE_WEEK = new CommonState(1, '一周内', 'within_one_week')
export const CARGO_READY_TIME_RANGE_WITHIN_TWO_WEEKS = new CommonState(2, '二周内', 'within_two_weeks')
export const CARGO_READY_TIME_RANGE_WITHIN_ONE_MONTH = new CommonState(3, '一个月内', 'within_one_month')
export const CARGO_READY_TIME_RANGE_OVER_ONE_MONTH = new CommonState(4, '一个月以上', 'over_one_month')
export const CARGO_READY_TIME_RANGE_UNKNOWN = new CommonState(5, '时间未知', 'unknown')
export const CARGO_READY_TIME_RANGE_WITHIN_THREE_DAY = new CommonState(6, '三天内', 'within_three_day')

export const CARGO_READY_TIME_RANGES = [
  CARGO_READY_TIME_RANGE_WITHIN_THREE_DAY,
  CARGO_READY_TIME_RANGE_WITHIN_ONE_WEEK,
  CARGO_READY_TIME_RANGE_WITHIN_TWO_WEEKS,
  CARGO_READY_TIME_RANGE_WITHIN_ONE_MONTH,
  CARGO_READY_TIME_RANGE_OVER_ONE_MONTH,
  CARGO_READY_TIME_RANGE_UNKNOWN
]

// 货盘性质 1-询价 2-实单
export const PALLET_NATURE_INQUIRY = new CommonState(1, '询价', 'inquiry')
export const PALLET_NATURE_REAL_ORDER = new CommonState(2, '实单', 'real_order')

export const PALLET_NATURES = [
  PALLET_NATURE_INQUIRY,
  PALLET_NATURE_REAL_ORDER
]

export const TASK_SCENARIO_1 = new CommonState('invoicing', '开票', 'Invoicing')
export const TASK_SCENARIO_2 = new CommonState('sendSettlementRateNB', '发送结算运价-宁波航交所', 'Send Settlement Freight Rate – Ningbo Shipping Exchange')
export const TASK_SCENARIO_3 = new CommonState('sendBusinessStatus', '发送业务状态', 'send business status')
export const TASK_SCENARIO_4 = new CommonState('sendDesignationInfo', '发送目的港派车', 'send destination port dispatch')
export const TASK_SCENARIO_5 = new CommonState('sendOrderCharges', '发送订单费用信息', 'send order charges')
export const TASK_SCENARIO_6 = new CommonState('sendDataToPlatform', '发送数据到第三方', 'Send third-party data')
export const TASK_SCENARIO_LIST = [
  TASK_SCENARIO_1,
  TASK_SCENARIO_2,
  TASK_SCENARIO_3,
  TASK_SCENARIO_4,
  TASK_SCENARIO_5,
  TASK_SCENARIO_6
]

export const DATA_TYPE_1 = new CommonState(1, '按费用', 'By Fee')
export const DATA_TYPE_2 = new CommonState(2, '按业务', 'By Business')
export const DATA_TYPE_LIST = [
  DATA_TYPE_1,
  DATA_TYPE_2
]

// 直达/中转 0-不指定 1-直达 2-中转
export const DIRECT_TRANSIT_NOT_POINT = new CommonState(0, '不指定', 'not point')
export const DIRECT_TRANSIT_DIRECT = new CommonState(1, '直达', 'direct')
export const DIRECT_TRANSIT_TRANSIT = new CommonState(2, '中转', 'transit')

export const DIRECT_TRANSITS = [
  DIRECT_TRANSIT_NOT_POINT,
  DIRECT_TRANSIT_DIRECT,
  DIRECT_TRANSIT_TRANSIT
]

// 危险品等级
export const DANGEROUS_GOODS_LEVEL_1 = new CommonState(1, '1.1 具有整体爆炸危险的爆炸品', '1.1 Explosives with a mass explosion hazard')
export const DANGEROUS_GOODS_LEVEL_2 = new CommonState(2, '1.2 具有严重抛射危险的爆炸品', '1.2 Explosives with a severe projection hazard')
export const DANGEROUS_GOODS_LEVEL_3 = new CommonState(3, '1.3 具有燃烧危险的爆炸品', '1.3 Explosives with a fire')
export const DANGEROUS_GOODS_LEVEL_4 = new CommonState(4, '1.4 轻微火灾或抛射危险', '1.4 Minor fire or projection hazard')
export const DANGEROUS_GOODS_LEVEL_5 = new CommonState(5, '1.5 具有整体爆炸危险的钝感物质', '1.5 An insensitive substance with a mass explosion hazard')
export const DANGEROUS_GOODS_LEVEL_6 = new CommonState(6, '1.6 极不敏感的物品', '1.6 Extremely insensitive articles')
export const DANGEROUS_GOODS_LEVEL_7 = new CommonState(7, '2.1 易燃气体', '2.1 Flammable Gas')
export const DANGEROUS_GOODS_LEVEL_8 = new CommonState(8, '2.2 不燃、无毒气体', '2.2 Non-flammable, Non-poisonous Gas')
export const DANGEROUS_GOODS_LEVEL_9 = new CommonState(9, '2.3 氧气', '2.3 Oxygen Gas')
export const DANGEROUS_GOODS_LEVEL_10 = new CommonState(10, '2.4 毒性气体', '2.4 Poison Gas')
export const DANGEROUS_GOODS_LEVEL_11 = new CommonState(11, '3 易燃液体', '3 Flammable Liquid')
export const DANGEROUS_GOODS_LEVEL_12 = new CommonState(12, '4.1 易燃固体或物质', '4.1 Flammable Solids or Substances')
export const DANGEROUS_GOODS_LEVEL_13 = new CommonState(13, '4.2 易燃固体', '4.2 Flammable solids')
export const DANGEROUS_GOODS_LEVEL_14 = new CommonState(14, '4.3 遇水放出易燃气体的物质', '4.3 Substances which, in contact with water, emit flammable gases')
export const DANGEROUS_GOODS_LEVEL_15 = new CommonState(15, '5.1 氧化性物质（通过释放氧气增加火灾风险和强度）', '5.1 Oxidizing substances (agents) by yielding oxygen increase the risk and intensity of fire')
export const DANGEROUS_GOODS_LEVEL_16 = new CommonState(16, '5.2 有机过氧化物 - 大多数燃烧迅速，对撞击或摩擦敏感', '5.2 Organic peroxides - most will burn rapidly and are sensitive to impact or friction')
export const DANGEROUS_GOODS_LEVEL_17 = new CommonState(17, '6.1 毒性物质', '6.1 Toxic substances')
export const DANGEROUS_GOODS_LEVEL_18 = new CommonState(18, '6.2 感染性物质', '6.2 Infectious substances')
export const DANGEROUS_GOODS_LEVEL_19 = new CommonState(19, '7 放射性物质', '7 Radioactive Substances')
export const DANGEROUS_GOODS_LEVEL_20 = new CommonState(20, '8 腐蚀品', '8 Corrosives')
export const DANGEROUS_GOODS_LEVEL_21 = new CommonState(21, '9 杂项危险物质和物品', '9 Miscellaneous dangerous substances and articles')

export const DANGEROUS_GOODS_LEVELS = [
  DANGEROUS_GOODS_LEVEL_1,
  DANGEROUS_GOODS_LEVEL_2,
  DANGEROUS_GOODS_LEVEL_3,
  DANGEROUS_GOODS_LEVEL_4,
  DANGEROUS_GOODS_LEVEL_5,
  DANGEROUS_GOODS_LEVEL_6,
  DANGEROUS_GOODS_LEVEL_7,
  DANGEROUS_GOODS_LEVEL_8,
  DANGEROUS_GOODS_LEVEL_9,
  DANGEROUS_GOODS_LEVEL_10,
  DANGEROUS_GOODS_LEVEL_11,
  DANGEROUS_GOODS_LEVEL_12,
  DANGEROUS_GOODS_LEVEL_13,
  DANGEROUS_GOODS_LEVEL_14,
  DANGEROUS_GOODS_LEVEL_15,
  DANGEROUS_GOODS_LEVEL_16,
  DANGEROUS_GOODS_LEVEL_17,
  DANGEROUS_GOODS_LEVEL_18,
  DANGEROUS_GOODS_LEVEL_19,
  DANGEROUS_GOODS_LEVEL_20,
  DANGEROUS_GOODS_LEVEL_21
]

// 报价状态 0-已保存、1-待报价、2-已报价、3-拒绝报价
export const QUOTE_STATUS_SAVED = new CommonState(0, '已保存', 'saved')
export const QUOTE_STATUS_PENDING = new CommonState(1, '待报价', 'pending')
export const QUOTE_STATUS_QUOTED = new CommonState(2, '已报价', 'quoted')
export const QUOTE_STATUS_REJECTED = new CommonState(3, '拒绝报价', 'rejected')

export const QUOTE_STATUS = [
  QUOTE_STATUS_SAVED,
  QUOTE_STATUS_PENDING,
  QUOTE_STATUS_QUOTED,
  QUOTE_STATUS_REJECTED
]

// 0-空 1-已有运价 2-商务报价
export const QUOTATION_METHOD_NULL = new CommonState(0, '空', 'null')
export const QUOTATION_METHOD_HAS_PRICE = new CommonState(1, '已有运价', 'has price')
export const QUOTATION_METHOD_COMMERCE_QUOTATION = new CommonState(2, '商务报价', 'commerce quotation')

export const QUOTATION_METHODS = [
  QUOTATION_METHOD_HAS_PRICE,
  QUOTATION_METHOD_COMMERCE_QUOTATION
]

// 0-已保存、1-待报价、2-已报价、3-拒绝报价
export const QUOTE_ACTION_SUBMIT = new CommonState(1, '提交报价', 'SUBMIT')
export const QUOTE_ACTION_REVOKE = new CommonState(2, '撤回报价', 'REVOKE')
export const QUOTE_ACTION_REFUSE = new CommonState(3, '拒绝报价', 'REFUSE')

export const QUOTE_ACTIONS = [
  QUOTE_ACTION_SUBMIT,
  QUOTE_ACTION_REVOKE,
  QUOTE_ACTION_REFUSE
]

// 1-正式客户、2-临时客户
export const CUSTOMER_ID_TYPE_OFFICIAL = new CommonState(1, '正式客户', 'official')
export const CUSTOMER_ID_TYPE_TEMPORARY = new CommonState(2, '临时客户', 'temporary')

export const CUSTOMER_ID_TYPES = [
  CUSTOMER_ID_TYPE_OFFICIAL,
  CUSTOMER_ID_TYPE_TEMPORARY
]

export const JDY_NOT_SENT = new CommonState(1, '未发送', 'Not sent')
export const JDY_PARTIAL_SENDING = new CommonState(2, '部分发送', 'Partial sending')
export const HDY_SEND = new CommonState(3, '已发送', 'Send')

export const JDY_STATUS = [
  JDY_NOT_SENT,
  JDY_PARTIAL_SENDING,
  HDY_SEND
]
// 20GP、40GP、40HC、45HC、20NOR、40NOR
export const SEA_EQ_TYPE_20GP = new CommonState('20GP', '20GP', '20GP')
export const SEA_EQ_TYPE_40GP = new CommonState('40GP', '40GP', '40GP')
export const SEA_EQ_TYPE_40HC = new CommonState('40HC', '40HC', '40HC')
export const SEA_EQ_TYPE_45HC = new CommonState('45HC', '45HC', '45HC')
export const SEA_EQ_TYPE_20NOR = new CommonState('20NOR', '20NOR', '20NOR')
export const SEA_EQ_TYPE_40NOR = new CommonState('40NOR', '40NOR', '40NOR')

export const SEA_EQ_TYPES = [
  SEA_EQ_TYPE_20GP,
  SEA_EQ_TYPE_40GP,
  SEA_EQ_TYPE_40HC,
  SEA_EQ_TYPE_45HC,
  SEA_EQ_TYPE_20NOR,
  SEA_EQ_TYPE_40NOR
]
export const SEA_EQ_TYPE_GP_20 = new CommonState('GP_20', '20GP', '20GP')
export const SEA_EQ_TYPE_GP_40 = new CommonState('GP_40', '40GP', '40GP')
export const SEA_EQ_TYPE_HC_40 = new CommonState('HC_40', '40HC', '40HC')
export const SEA_EQ_TYPE_HC_45 = new CommonState('HC_45', '45HC', '45HC')
export const SEA_EQ_TYPE_NOR_20 = new CommonState('NOR_20', '20NOR', '20NOR')
export const SEA_EQ_TYPE_NOR_40 = new CommonState('NOR_40', '40NOR', '40NOR')

export const SEA_EQ_TYPES_SEARCH = [
  SEA_EQ_TYPE_GP_20,
  SEA_EQ_TYPE_GP_40,
  SEA_EQ_TYPE_HC_40,
  SEA_EQ_TYPE_HC_45,
  SEA_EQ_TYPE_NOR_20,
  SEA_EQ_TYPE_NOR_40
]

export const SEA_EQ_TYPE_MAP = new Map([
  [SEA_EQ_TYPE_20GP.code, { numField: 'num20', field: 'gp20', eqSize: '20', eqType: 'GP', measure: ChargeMeasure.C20_CHARGE_MEASURE.code }],
  [SEA_EQ_TYPE_40GP.code, { numField: 'num40', field: 'gp40', eqSize: '40', eqType: 'GP', measure: ChargeMeasure.C40_CHARGE_MEASURE.code }],
  [SEA_EQ_TYPE_40HC.code, { numField: 'numHc', field: 'hc40', eqSize: '40', eqType: 'HC', measure: ChargeMeasure.C40H_CHARGE_MEASURE.code }],
  [SEA_EQ_TYPE_45HC.code, { numField: 'num45', field: 'hc45', eqSize: '45', eqType: 'HC', measure: ChargeMeasure.C45_CHARGE_MEASURE.code }],
  [SEA_EQ_TYPE_20NOR.code, { numField: 'num20Nor', field: 'nor20', eqSize: '20', eqType: 'NOR', measure: ChargeMeasure.BY_CNTR_CHARGE_MEASURE.code }],
  [SEA_EQ_TYPE_40NOR.code, { numField: 'num40Nor', field: 'nor40', eqSize: '40', eqType: 'NOR', measure: ChargeMeasure.BY_CNTR_CHARGE_MEASURE.code }]
])

export const OPEN_PRICE_WARNING_TYPE_NOT_DECLARED = new CommonState(1, '未申报', 'not declared')
export const OPEN_PRICE_WARNING_TYPE_OVERRUN = new CommonState(2, '超限', 'overrun')
export const OPEN_PRICE_WARNING_TYPES = new Set([OPEN_PRICE_WARNING_TYPE_NOT_DECLARED, OPEN_PRICE_WARNING_TYPE_OVERRUN])

export const OPEN_PRICE_REMINDER_TYPE_NOT_SAVE = new CommonState(1, '禁止保存', 'Not save')
export const OPEN_PRICE_REMINDER_TYPE_REMINDER_USER = new CommonState(2, '提醒用户', 'Remind user')
export const OPEN_PRICE_REMINDER_TYPE_ONLY_RECORD = new CommonState(3, '只记录不提醒', 'Only_record')
export const OPEN_PRICE_REMINDER_TYPE_NOT_RECORD = new CommonState(4, '不记录不提醒', 'Not_record')
export const OPEN_PRICE_REMINDER_TYPES = new Set([
  OPEN_PRICE_REMINDER_TYPE_NOT_SAVE,
  OPEN_PRICE_REMINDER_TYPE_REMINDER_USER,
  OPEN_PRICE_REMINDER_TYPE_ONLY_RECORD,
  OPEN_PRICE_REMINDER_TYPE_NOT_RECORD
])

// 运价、报价
export const DATA_TYPE_PRICE = new CommonState(1, '运价', 'Price')
export const DATA_TYPE_QUOTATION = new CommonState(2, '报价', 'Quotation')

// RPA-企业微信 当前状态
export const RPALOGIN_TYPE_SCAN_CODE = new CommonState('scan_code', '等待用户扫码', 'Waiting to scan the code')
export const RPALOGIN_TYPE_CAPTCHA = new CommonState('captcha', '等待用户输入验证码', 'Waiting for input of verification code')
export const RPALOGIN_TYPE_CAPTCHA_USING = new CommonState('captcha_using', '验证码正在输入中', 'The verification code is currently being entered')
export const RPALOGIN_TYPE_LOGIN_SUCCESS = new CommonState('login_success', '已登录成功', 'Successfully logged in')
export const RPALOGIN_TYPE_CODE_EXPIRE = new CommonState('code_expire', '指定时间内没有扫码已超时', 'Time expired')
export const RPALOGIN_TYPES = [RPALOGIN_TYPE_SCAN_CODE, RPALOGIN_TYPE_CAPTCHA, RPALOGIN_TYPE_CAPTCHA_USING, RPALOGIN_TYPE_LOGIN_SUCCESS, RPALOGIN_TYPE_CODE_EXPIRE]

// 航交所运价批次状态：草稿、处理中、暂停、已完成
export const OPEN_PRICE_BATCH_DRAFT = new CommonState(0, '草稿', 'Draft')
export const OPEN_PRICE_BATCH_PROCESSING = new CommonState(1, '处理中', 'Processing')
export const OPEN_PRICE_BATCH_PAUSE = new CommonState(2, '暂停', 'Pause')
export const OPEN_PRICE_BATCH_COMPLETED = new CommonState(4, '已完成', 'Completed')
export const OPEN_PRICE_BATCHS = new Set([OPEN_PRICE_BATCH_DRAFT, OPEN_PRICE_BATCH_PROCESSING, OPEN_PRICE_BATCH_PAUSE, OPEN_PRICE_BATCH_COMPLETED])

export const DOCUMENT_TEMPLATE_DRAFT = new CommonState(0, '草稿', 'draft')
export const DOCUMENT_TEMPLATE_DISABLE = new CommonState(1, '禁用', 'disable')
export const DOCUMENT_TEMPLATE_ENABLE = new CommonState(2, '启用', 'enable')
export const DOCUMENT_TEMPLATE_ADD = new CommonState(3, '新增', 'add')
export const DOCUMENT_TEMPLATE_EDIT = new CommonState(4, '编辑', 'edit')
export const DOCUMENT_TEMPLATE_TYPE = [DOCUMENT_TEMPLATE_DRAFT, DOCUMENT_TEMPLATE_DISABLE, DOCUMENT_TEMPLATE_ENABLE, DOCUMENT_TEMPLATE_ADD, DOCUMENT_TEMPLATE_EDIT]
export const DOCUMENT_TEMPLATE_TYPE_STATUS = [DOCUMENT_TEMPLATE_DRAFT, DOCUMENT_TEMPLATE_DISABLE, DOCUMENT_TEMPLATE_ENABLE]

// 航交所运价RPA状态：启动、暂停
export const OPEN_PRICE_RPA_DEFAULT = new CommonState(0, '', '')
export const OPEN_PRICE_RPA_START = new CommonState(1, '启动', 'Start')
export const OPEN_PRICE_RPA_SUSPEND = new CommonState(2, '暂停', 'Suspend')
export const OPEN_PRICE_RPAS = new Set([OPEN_PRICE_RPA_DEFAULT, OPEN_PRICE_RPA_START, OPEN_PRICE_RPA_SUSPEND])

export const OPEN_PRICE_WARNING_UN_PROCESSED = new CommonState(0, '未处理', 'Unprocessed')
export const OPEN_PRICE_WARNING_PROCESSED = new CommonState(1, '已处理', 'Processed')
export const OPEN_PRICE_WARNINGS = new Set([OPEN_PRICE_WARNING_UN_PROCESSED, OPEN_PRICE_WARNING_PROCESSED])

// 舱单预审 审核状态
export const MANIFEST_PRE_TRIAL_STATUS_WAIT = new CommonState(10, '待审核', 'Pending')
export const MANIFEST_PRE_TRIAL_STATUS_APPROVE = new CommonState(11, '审核通过', 'Approved')
export const MANIFEST_PRE_TRIAL_STATUS_REJECT = new CommonState(12, '已拒绝', 'Rejected')
export const MANIFEST_PRE_TRIAL_STATUSES = new Set([MANIFEST_PRE_TRIAL_STATUS_WAIT, MANIFEST_PRE_TRIAL_STATUS_APPROVE, MANIFEST_PRE_TRIAL_STATUS_REJECT])

// 舱单预审 是否拆并单
export const MANIFEST_IS_SPLIT_ORDER_0 = new CommonState(0, '无', 'null')
export const MANIFEST_IS_SPLIT_ORDER_1 = new CommonState(1, '拆单', 'orderSplitting')
export const MANIFEST_IS_SPLIT_ORDER_2 = new CommonState(2, '并单', 'mergeSingle')
export const MANIFEST_IS_SPLIT_ORDER = new Set([MANIFEST_IS_SPLIT_ORDER_0, MANIFEST_IS_SPLIT_ORDER_1, MANIFEST_IS_SPLIT_ORDER_2])

// 舱单预审 是否特殊并单
export const MANIFEST_IS_SPECIAL_CONSOLIDATED_YSE = new CommonState(true, '是', 'Yes')
export const MANIFEST_IS_SPECIAL_CONSOLIDATED_NO = new CommonState(false, '否', 'No')
export const MANIFEST_IS_SPECIAL_CONSOLIDATED = new Set([MANIFEST_IS_SPECIAL_CONSOLIDATED_YSE, MANIFEST_IS_SPECIAL_CONSOLIDATED_NO])

// 舱单预审 附加费审核
export const MANIFEST_ADD_FEE_REVIEW_FLAG_PASS = new CommonState(1, '审核通过', 'PASS')
export const MANIFEST_ADD_FEE_REVIEW_FLAG_FAIL = new CommonState(0, '审核不通过', 'FAIL')
export const MANIFEST_ADD_FEE_REVIEW_FLAG = new Set([MANIFEST_ADD_FEE_REVIEW_FLAG_PASS, MANIFEST_ADD_FEE_REVIEW_FLAG_FAIL])

/**
 * 是否包含敏感词
 * @type {CommonState}
 */
export const NONE = new CommonState(0, '无', 'none')
export const INCLUDE = new CommonState(1, '包含', 'include')
export const NOT_INCLUDE = new CommonState(2, '不包含', 'not include')

export const HAS_SENSIVITE_WORD = [NONE, INCLUDE, NOT_INCLUDE]

export const EMAIL_SYSTEM_CONFIG = new CommonState(0, '系统邮箱', 'System email')
export const EMAIL_OFFICE_CONFIG = new CommonState(1, '公司邮箱', 'Office email')
export const EMAIL_SERVERS_CONFIG = [EMAIL_SYSTEM_CONFIG, EMAIL_OFFICE_CONFIG]

// 验证结果
export const CHECK_RESULT_MBL_REPEATED = new CommonState('MBL_REPEATED', '主单号重复', 'mbl repeated')
export const CHECK_RULE_RESULT_EMPTY = new CommonState('EMPTY', '空', 'empty')
export const CHECK_RESULTS = new Set([CHECK_RESULT_MBL_REPEATED, CHECK_RULE_RESULT_EMPTY])

export const JOB_PUSH_STATUS_NOT_SENT = new CommonState(0, '未发送', 'Not sent')
export const JOB_PUSH_STATUS_SENDING = new CommonState(1, '已发送', 'sending')
export const JOB_PUSH_STATUS_TO_BE_SENDING = new CommonState(2, '修改待发送', 'to be Send')

export const JOB_PUSH_STATUS = [
  JOB_PUSH_STATUS_NOT_SENT,
  JOB_PUSH_STATUS_SENDING,
  JOB_PUSH_STATUS_TO_BE_SENDING
]

export const CHARGE_PUSH_STATUS_NOT_SENT = new CommonState(0, '未发送', 'Not sent')
export const CHARGE_PUSH_STATUS_SENDING = new CommonState(1, '已发送', 'sending')

export const CHARGE_PUSH_STATUS = [
  JOB_PUSH_STATUS_NOT_SENT,
  JOB_PUSH_STATUS_SENDING
]

export const PAY_QUOTE_WAIT = new CommonState('PAY_QUOTE_WAIT', '商务待报价', 'Business quotation pending')
export const PAY_QUOTE_CONFIRM = new CommonState('PAY_QUOTE_CONFIRM', '报价确认预警', 'Quotation confirmation warning')

export const TYPE_LIST = [
  PAY_QUOTE_WAIT,
  PAY_QUOTE_CONFIRM
]
